// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/k2/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        readinessCheck: build.query<ReadinessCheckApiResponse, ReadinessCheckApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        livenessCheck: build.query<LivenessCheckApiResponse, LivenessCheckApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        getWorkflowFieldUsages: build.query<GetWorkflowFieldUsagesApiResponse, GetWorkflowFieldUsagesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/field-usages`,
                params: {
                    page: queryArg.page,
                    field_id: queryArg.fieldId,
                    field_lookup_table_id: queryArg.fieldLookupTableId,
                    is_required: queryArg.isRequired,
                    search: queryArg.search,
                    include_drafts: queryArg.includeDrafts,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketFieldUsages: build.query<GetTicketFieldUsagesApiResponse, GetTicketFieldUsagesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/field-usages`,
                params: { page: queryArg.page, field_id: queryArg.fieldId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        approveTicketNegotiation: build.mutation<ApproveTicketNegotiationApiResponse, ApproveTicketNegotiationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/negotiation/approve`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resolveRenewalWorkflow: build.query<ResolveRenewalWorkflowApiResponse, ResolveRenewalWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/renewals`,
                params: {
                    document_id: queryArg.documentId,
                    document_handler_id: queryArg.documentHandlerId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntakeValues: build.query<GetIntakeValuesApiResponse, GetIntakeValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/intake-values`,
                params: { source_document_id: queryArg.sourceDocumentId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        requestWorkflowDocumentUpload: build.mutation<RequestWorkflowDocumentUploadApiResponse, RequestWorkflowDocumentUploadApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/upload-request`,
                method: "POST",
                body: queryArg.documentUploadUrlRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        workflowUploadComplete: build.mutation<WorkflowUploadCompleteApiResponse, WorkflowUploadCompleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/upload-complete`,
                method: "POST",
                body: queryArg.documentUploadCompleteRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowDocumentDownloadUrl: build.query<GetWorkflowDocumentDownloadUrlApiResponse, GetWorkflowDocumentDownloadUrlApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/download-request`,
                params: {
                    document_version: queryArg.documentVersion,
                    format: queryArg.format,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflowDocument: build.mutation<DeleteWorkflowDocumentApiResponse, DeleteWorkflowDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        replaceWorkflowDocumentPlaceholderMappings: build.mutation<ReplaceWorkflowDocumentPlaceholderMappingsApiResponse, ReplaceWorkflowDocumentPlaceholderMappingsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/placeholder-mappings`,
                method: "PUT",
                body: queryArg.placeholderMappingsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        previewWorkflowTemplate: build.mutation<PreviewWorkflowTemplateApiResponse, PreviewWorkflowTemplateApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/preview`,
                method: "POST",
                body: queryArg.templatePreviewRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createWorkflowLocalField: build.mutation<CreateWorkflowLocalFieldApiResponse, CreateWorkflowLocalFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/local-fields`,
                method: "POST",
                body: queryArg.createLocalFieldRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowLocalFields: build.query<ListWorkflowLocalFieldsApiResponse, ListWorkflowLocalFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/local-fields`,
                params: { version: queryArg.version, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflowLocalField: build.mutation<UpdateWorkflowLocalFieldApiResponse, UpdateWorkflowLocalFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/local-fields/${queryArg.fieldId}`,
                method: "PATCH",
                body: queryArg.updateLocalFieldRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowFieldOverrides: build.query<ListWorkflowFieldOverridesApiResponse, ListWorkflowFieldOverridesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/field-overrides`,
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        putWorkflowFieldOverride: build.mutation<PutWorkflowFieldOverrideApiResponse, PutWorkflowFieldOverrideApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/field-overrides/${queryArg.fieldId}`,
                method: "PUT",
                body: queryArg.putFieldOverrideRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflowFieldOverride: build.mutation<DeleteWorkflowFieldOverrideApiResponse, DeleteWorkflowFieldOverrideApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/field-overrides/${queryArg.fieldId}`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createWorkflowPermissionBundle: build.mutation<CreateWorkflowPermissionBundleApiResponse, CreateWorkflowPermissionBundleApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/permission-bundles`,
                method: "POST",
                body: queryArg.createPermissionBundleRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowPermissionBundles: build.query<ListWorkflowPermissionBundlesApiResponse, ListWorkflowPermissionBundlesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/permission-bundles`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflowPermissionBundle: build.mutation<UpdateWorkflowPermissionBundleApiResponse, UpdateWorkflowPermissionBundleApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/permission-bundles/${queryArg.bundleId}`,
                method: "PATCH",
                body: queryArg.updatePermissionBundleRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflowPermissionBundle: build.mutation<DeleteWorkflowPermissionBundleApiResponse, DeleteWorkflowPermissionBundleApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/permission-bundles/${queryArg.bundleId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createWorkflow: build.mutation<CreateWorkflowApiResponse, CreateWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows`,
                method: "POST",
                body: queryArg.createWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflows: build.query<ListWorkflowsApiResponse, ListWorkflowsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows`,
                params: {
                    page: queryArg.page,
                    include: queryArg.include,
                    published: queryArg.published,
                    search: queryArg.search,
                    search_mode: queryArg.searchMode,
                    created_by: queryArg.createdBy,
                    created_at_gte: queryArg.createdAtGte,
                    created_at_lte: queryArg.createdAtLte,
                    updated_at_gte: queryArg.updatedAtGte,
                    updated_at_lte: queryArg.updatedAtLte,
                    sort: queryArg.sort,
                    include_archived: queryArg.includeArchived,
                    status: queryArg.status,
                    latest_published: queryArg.latestPublished,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflow: build.query<GetWorkflowApiResponse, GetWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}`,
                params: {
                    version: queryArg.version,
                    latest_published: queryArg.latestPublished,
                    include: queryArg.include,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflow: build.mutation<UpdateWorkflowApiResponse, UpdateWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}`,
                method: "PUT",
                body: queryArg.updateWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflow: build.mutation<DeleteWorkflowApiResponse, DeleteWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowVersions: build.query<ListWorkflowVersionsApiResponse, ListWorkflowVersionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/versions`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        archiveWorkflow: build.mutation<ArchiveWorkflowApiResponse, ArchiveWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/archive`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        unarchiveWorkflow: build.mutation<UnarchiveWorkflowApiResponse, UnarchiveWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/unarchive`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        publishWorkflow: build.mutation<PublishWorkflowApiResponse, PublishWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/publish`,
                method: "PATCH",
                body: queryArg.publishWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        unpublishWorkflow: build.mutation<UnpublishWorkflowApiResponse, UnpublishWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/unpublish`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cloneWorkflow: build.mutation<CloneWorkflowApiResponse, CloneWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/clone`,
                method: "POST",
                body: queryArg.cloneWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflowAcl: build.mutation<UpdateWorkflowAclApiResponse, UpdateWorkflowAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/acl`,
                method: "PATCH",
                body: queryArg.updateWorkflowAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        validateWorkflow: build.mutation<ValidateWorkflowApiResponse, ValidateWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/validate`,
                method: "POST",
                body: queryArg.validateWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        evaluateWorkflowFormVisibility: build.mutation<EvaluateWorkflowFormVisibilityApiResponse, EvaluateWorkflowFormVisibilityApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/form-visibility-evaluation`,
                method: "POST",
                body: queryArg.workflowFormVisibilityEvaluationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowActivityLogs: build.query<ListWorkflowActivityLogsApiResponse, ListWorkflowActivityLogsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/activity-logs`,
                params: {
                    resource_type: queryArg.resourceType,
                    action: queryArg.action,
                    document_id: queryArg.documentId,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowTemplates: build.query<ListWorkflowTemplatesApiResponse, ListWorkflowTemplatesApiArg>({
            query: () => ({ url: `/api/v1/workflow-templates` }),
        }),
        getWorkflowTemplate: build.query<GetWorkflowTemplateApiResponse, GetWorkflowTemplateApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflow-templates/${queryArg.templateId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listStages: build.query<ListStagesApiResponse, ListStagesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        transitionToNextStage: build.mutation<TransitionToNextStageApiResponse, TransitionToNextStageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/next`,
                method: "POST",
                body: queryArg.stageTransitionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        transitionToStage: build.mutation<TransitionToStageApiResponse, TransitionToStageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.targetStageId}`,
                method: "POST",
                body: queryArg.stageTransitionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getStageAcl: build.query<GetStageAclApiResponse, GetStageAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}/acl`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateStageAcl: build.mutation<UpdateStageAclApiResponse, UpdateStageAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}/acl`,
                method: "PATCH",
                body: queryArg.updateStageAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteStageAcl: build.mutation<DeleteStageAclApiResponse, DeleteStageAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}/acl`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTasks: build.query<ListTasksApiResponse, ListTasksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks`,
                params: {
                    stage_id: queryArg.stageId,
                    status: queryArg.status,
                    assignee: queryArg.assignee,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createAdHocTask: build.mutation<CreateAdHocTaskApiResponse, CreateAdHocTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks`,
                method: "POST",
                body: queryArg.adHocTaskCreateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTask: build.query<GetTaskApiResponse, GetTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateAdHocTask: build.mutation<UpdateAdHocTaskApiResponse, UpdateAdHocTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}`,
                method: "PATCH",
                body: queryArg.adHocTaskUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteAdHocTask: build.mutation<DeleteAdHocTaskApiResponse, DeleteAdHocTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        completeTask: build.mutation<CompleteTaskApiResponse, CompleteTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/complete`,
                method: "POST",
                body: queryArg.taskCompleteRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        assignTask: build.mutation<AssignTaskApiResponse, AssignTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/assign`,
                method: "PATCH",
                body: queryArg.taskAssignRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        claimTask: build.mutation<ClaimTaskApiResponse, ClaimTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/claim`,
                method: "POST",
                body: queryArg.taskClaimRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resetTask: build.mutation<ResetTaskApiResponse, ResetTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/reset`,
                method: "POST",
                body: queryArg.taskResetRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        retractJudgment: build.mutation<RetractJudgmentApiResponse, RetractJudgmentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/retract`,
                method: "POST",
                body: queryArg.taskResetRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTaskAssociation: build.mutation<UpdateTaskAssociationApiResponse, UpdateTaskAssociationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/associations`,
                method: "PATCH",
                body: queryArg.taskAssociationUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTaskAcl: build.query<GetTaskAclApiResponse, GetTaskAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/acl`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTaskAcl: build.mutation<UpdateTaskAclApiResponse, UpdateTaskAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/acl`,
                method: "PATCH",
                body: queryArg.updateTaskAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTaskAcl: build.mutation<DeleteTaskAclApiResponse, DeleteTaskAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/acl`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        remindTask: build.mutation<RemindTaskApiResponse, RemindTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/remind`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateField: build.mutation<UpdateFieldApiResponse, UpdateFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/fields/${queryArg.fieldId}`,
                method: "PATCH",
                body: queryArg.fieldUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateFieldsBatch: build.mutation<UpdateFieldsBatchApiResponse, UpdateFieldsBatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/fields`,
                method: "PATCH",
                body: queryArg.fieldBatchUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createComment: build.mutation<CreateCommentApiResponse, CreateCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments`,
                method: "POST",
                body: queryArg.createCommentRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listComments: build.query<ListCommentsApiResponse, ListCommentsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments`,
                params: {
                    task_id: queryArg.taskId,
                    filter: queryArg.filter,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listThreads: build.query<ListThreadsApiResponse, ListThreadsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/threads`,
                params: {
                    task_id: queryArg.taskId,
                    filter: queryArg.filter,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getComment: build.query<GetCommentApiResponse, GetCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateComment: build.mutation<UpdateCommentApiResponse, UpdateCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}`,
                method: "PATCH",
                body: queryArg.updateCommentRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteComment: build.mutation<DeleteCommentApiResponse, DeleteCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resolveComment: build.mutation<ResolveCommentApiResponse, ResolveCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}/resolve`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        unresolveComment: build.mutation<UnresolveCommentApiResponse, UnresolveCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}/unresolve`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        retryGeneration: build.mutation<RetryGenerationApiResponse, RetryGenerationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/retry-generation`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        forceUnlockTicketDocument: build.mutation<ForceUnlockTicketDocumentApiResponse, ForceUnlockTicketDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/force-unlock`,
                method: "POST",
                body: queryArg.documentForceUnlockRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        versionUpTicketDocument: build.mutation<VersionUpTicketDocumentApiResponse, VersionUpTicketDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/version-up`,
                method: "POST",
                body: queryArg.documentVersionUpRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchDocument: build.mutation<PatchDocumentApiResponse, PatchDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}`,
                method: "PATCH",
                body: queryArg.documentPatchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicketDocument: build.mutation<DeleteTicketDocumentApiResponse, DeleteTicketDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}`,
                method: "DELETE",
                params: {
                    version: queryArg.version,
                    document_lock_version: queryArg.documentLockVersion,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        recordDocumentShare: build.mutation<RecordDocumentShareApiResponse, RecordDocumentShareApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/record-share`,
                method: "POST",
                body: queryArg.recordShareRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getCycleTime: build.query<GetCycleTimeApiResponse, GetCycleTimeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/cycle-time`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTurns: build.query<ListTurnsApiResponse, ListTurnsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/turns`,
                params: {
                    next_token: queryArg.nextToken,
                    page: queryArg.page,
                    sort: queryArg.sort,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createTurn: build.mutation<CreateTurnApiResponse, CreateTurnApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/turns`,
                method: "POST",
                body: queryArg.createTurnRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTurn: build.mutation<UpdateTurnApiResponse, UpdateTurnApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/turns/${queryArg.turnId}`,
                method: "PATCH",
                body: queryArg.updateTurnRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        recordSignatures: build.mutation<RecordSignaturesApiResponse, RecordSignaturesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/sign-tasks/${queryArg.taskId}/record-signatures`,
                method: "POST",
                body: queryArg.recordSignaturesRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        recordSignaturesBatch: build.mutation<RecordSignaturesBatchApiResponse, RecordSignaturesBatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/sign-tasks/${queryArg.taskId}/record-signatures-batch`,
                method: "POST",
                body: queryArg.recordSignaturesBatchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSigningConfiguration: build.query<GetSigningConfigurationApiResponse, GetSigningConfigurationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/signing-participants/${queryArg.taskId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        replaceSigningConfiguration: build.mutation<ReplaceSigningConfigurationApiResponse, ReplaceSigningConfigurationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/signing-participants/${queryArg.taskId}`,
                method: "PUT",
                body: queryArg.signingConfigurationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createEsignPackage: build.mutation<CreateEsignPackageApiResponse, CreateEsignPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/esign-packages`,
                method: "POST",
                body: queryArg.createEsignPackageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketActions: build.query<GetTicketActionsApiResponse, GetTicketActionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/actions`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTicketPermissionBundles: build.query<ListTicketPermissionBundlesApiResponse, ListTicketPermissionBundlesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/permission-bundles`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTickets: build.query<ListTicketsApiResponse, ListTicketsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets`,
                params: {
                    state: queryArg.state,
                    workflow_id: queryArg.workflowId,
                    workflow_version: queryArg.workflowVersion,
                    contract_record_unique_id: queryArg.contractRecordUniqueId,
                    page: queryArg.page,
                    include: queryArg.include,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createTicket: build.mutation<CreateTicketApiResponse, CreateTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets`,
                method: "POST",
                body: queryArg.createTicketRequest,
                params: { reference_id: queryArg.referenceId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cloneTicket: build.mutation<CloneTicketApiResponse, CloneTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/clone`,
                method: "POST",
                body: queryArg.cloneTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketState: build.query<GetTicketStateApiResponse, GetTicketStateApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/state`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicket: build.mutation<DeleteTicketApiResponse, DeleteTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTicketMetadata: build.mutation<UpdateTicketMetadataApiResponse, UpdateTicketMetadataApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}`,
                method: "PATCH",
                body: queryArg.updateTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicket: build.query<GetTicketApiResponse, GetTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}`,
                params: { include: queryArg.include },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        evaluateTicketFormVisibility: build.mutation<EvaluateTicketFormVisibilityApiResponse, EvaluateTicketFormVisibilityApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/form-visibility-evaluation`,
                method: "POST",
                body: queryArg.ticketFormVisibilityEvaluationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        pauseTicket: build.mutation<PauseTicketApiResponse, PauseTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/pause`,
                method: "POST",
                body: queryArg.pauseTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resumeTicket: build.mutation<ResumeTicketApiResponse, ResumeTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/resume`,
                method: "POST",
                body: queryArg.resumeTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cancelTicket: build.mutation<CancelTicketApiResponse, CancelTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/cancel`,
                method: "POST",
                body: queryArg.cancelTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        completeTicket: build.mutation<CompleteTicketApiResponse, CompleteTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/complete`,
                method: "POST",
                body: queryArg.completeTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        submitTicket: build.mutation<SubmitTicketApiResponse, SubmitTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/submit`,
                method: "POST",
                body: queryArg.submitTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resetStageTasks: build.mutation<ResetStageTasksApiResponse, ResetStageTasksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/reset-tasks`,
                method: "POST",
                body: queryArg.resetStageTasksRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTicketAcl: build.mutation<UpdateTicketAclApiResponse, UpdateTicketAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/acl`,
                method: "PATCH",
                body: queryArg.updateTicketAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reassignTicketOwner: build.mutation<ReassignTicketOwnerApiResponse, ReassignTicketOwnerApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/owner`,
                method: "PATCH",
                body: queryArg.reassignTicketOwnerRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        supplierNegotiation: build.mutation<SupplierNegotiationApiResponse, SupplierNegotiationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/supplier-negotiation`,
                method: "POST",
                body: queryArg.supplierNegotiationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        shareExternally: build.mutation<ShareExternallyApiResponse, ShareExternallyApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/share-externally`,
                method: "POST",
                body: queryArg.shareExternallyRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        shareInternally: build.mutation<ShareInternallyApiResponse, ShareInternallyApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/share-internally`,
                method: "POST",
                body: queryArg.shareInternallyRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getContractFamily: build.query<GetContractFamilyApiResponse, GetContractFamilyApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/documents/${queryArg.documentId}/contract-family`,
                params: { include: queryArg.include },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        bulkReassignTasks: build.mutation<BulkReassignTasksApiResponse, BulkReassignTasksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/admin/tasks/bulk-reassign`,
                method: "POST",
                body: queryArg.bulkReassignRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        searchSuppliers: build.query<SearchSuppliersApiResponse, SearchSuppliersApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/suppliers`,
                params: { q: queryArg.q, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSupplierCompany: build.query<GetSupplierCompanyApiResponse, GetSupplierCompanyApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/suppliers/${queryArg.supplierId}`,
                params: { include_contacts: queryArg.includeContacts },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listContractTypes: build.query<ListContractTypesApiResponse, ListContractTypesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/contract-types`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listCurrencies: build.query<ListCurrenciesApiResponse, ListCurrenciesApiArg>({
            query: () => ({ url: `/api/v1/integrate-workflow/currencies` }),
        }),
        getIntakeFormLink: build.query<GetIntakeFormLinkApiResponse, GetIntakeFormLinkApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/${queryArg.workflowId}/intake-form/link`,
                params: { reference_id: queryArg.referenceId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        checkProcurementAmendability: build.query<CheckProcurementAmendabilityApiResponse, CheckProcurementAmendabilityApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/procurement-amendability`,
                params: { contract_record_unique_id: queryArg.contractRecordUniqueId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getProcurementAmendmentIntakeForm: build.query<GetProcurementAmendmentIntakeFormApiResponse, GetProcurementAmendmentIntakeFormApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/procurement-amendment-intake-form`,
                params: { contract_record_unique_id: queryArg.contractRecordUniqueId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExpressionAstSchema: build.query<GetExpressionAstSchemaApiResponse, GetExpressionAstSchemaApiArg>({
            query: () => ({ url: `/api/v1/schemas/expression-ast` }),
        }),
        searchCompanies: build.query<SearchCompaniesApiResponse, SearchCompaniesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/companies`,
                params: { q: queryArg.q, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        requestDocumentUpload: build.mutation<RequestDocumentUploadApiResponse, RequestDocumentUploadApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/upload-request`,
                method: "POST",
                body: queryArg.ticketDocumentUploadUrlRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        uploadComplete: build.mutation<UploadCompleteApiResponse, UploadCompleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/upload-complete`,
                method: "POST",
                body: queryArg.documentUploadCompleteRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        retryProcessing: build.mutation<RetryProcessingApiResponse, RetryProcessingApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/retry-processing`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cancelPendingDocumentUpload: build.mutation<CancelPendingDocumentUploadApiResponse, CancelPendingDocumentUploadApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/cancel-upload`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDownloadUrl: build.query<GetDownloadUrlApiResponse, GetDownloadUrlApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/download-request`,
                params: {
                    document_version: queryArg.documentVersion,
                    format: queryArg.format,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentComparison: build.query<GetDocumentComparisonApiResponse, GetDocumentComparisonApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/comparisons`,
                params: {
                    newer_version: queryArg.newerVersion,
                    older_version: queryArg.olderVersion,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        searchTickets: build.mutation<SearchTicketsApiResponse, SearchTicketsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/search`,
                method: "POST",
                body: queryArg.ticketSearchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketVersion: build.query<GetTicketVersionApiResponse, GetTicketVersionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/version`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTicketActivityLogs: build.query<ListTicketActivityLogsApiResponse, ListTicketActivityLogsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/activity-logs`,
                params: {
                    resource_type: queryArg.resourceType,
                    action: queryArg.action,
                    document_id: queryArg.documentId,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        scribylLockDocument: build.mutation<ScribylLockDocumentApiResponse, ScribylLockDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/lock`,
                method: "POST",
                body: queryArg.scribylDocumentLockRequest,
                headers: {
                    "X-Document-Lock-Version": queryArg["X-Document-Lock-Version"],
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        scribylUnlockDocument: build.mutation<ScribylUnlockDocumentApiResponse, ScribylUnlockDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/unlock`,
                method: "POST",
                body: queryArg.scribylDocumentUnlockRequest,
                headers: {
                    "X-Document-Lock-Version": queryArg["X-Document-Lock-Version"],
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWssWorkflows: build.query<GetWssWorkflowsApiResponse, GetWssWorkflowsApiArg>({
            query: () => ({ url: `/api/v1/wss/workflows` }),
        }),
        updateWssContractNegotiation: build.mutation<UpdateWssContractNegotiationApiResponse, UpdateWssContractNegotiationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wss/contract-negotiations/${queryArg.contractRecordUniqueId}/update`,
                method: "POST",
                body: queryArg.contractNegotiationUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        contractFamilyChainCheck: build.query<ContractFamilyChainCheckApiResponse, ContractFamilyChainCheckApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/contract-family/chains`,
                params: { document_ids: queryArg.documentIds },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ReadinessCheckApiResponse = 
/** status 200 The probe report; every check passed. */ HealthcheckReport;
export type ReadinessCheckApiArg = void;
export type LivenessCheckApiResponse = 
/** status 200 The probe report; every check passed. */ HealthcheckReport;
export type LivenessCheckApiArg = void;
export type GetWorkflowFieldUsagesApiResponse = 
/** status 200 One page of workflows that use the field or lookup table. */ FieldUsagesResponse;
export type GetWorkflowFieldUsagesApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** UF field UUID to find in form-question usage */
    fieldId?: UuidStr | null;
    /** Field lookup table id to find in field_library[].field_lookup_table.field_lookup_table_id */
    fieldLookupTableId?: string | null;
    /** Filter field_id usage to required usage only */
    isRequired?: boolean | null;
    /** Free-text search over workflow name. Matches whole words and word prefixes. */
    search?: string | null;
    /** Match each non-archived workflow's latest version, drafts and never-published workflows included, instead of its latest published version. Matches a user caller cannot view are counted in meta.inaccessible_count instead of listed. A user caller may not combine it with search or is_required=true (422). */
    includeDrafts?: boolean;
};
export type GetTicketFieldUsagesApiResponse = 
/** status 200 One page of tickets whose workflow references the field, with the total match count. */ TicketFieldUsagesResponse;
export type GetTicketFieldUsagesApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** UF field UUID. Matches tickets bound to a workflow that references it. */
    fieldId: UuidStr;
};
export type ApproveTicketNegotiationApiResponse = 
/** status 200 The ticket id and the negotiation status after the approve attempt. */ NegotiationApproveResponse;
export type ApproveTicketNegotiationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidStr;
};
export type ResolveRenewalWorkflowApiResponse = 
/** status 200 Zero or one intake workflow to use for the renewal. */ RenewalWorkflowListResponse;
export type ResolveRenewalWorkflowApiArg = {
    /** Document id of the contract being renewed. */
    documentId: string;
    /** Pilot DocumentHandler id of the contract being renewed. */
    documentHandlerId: string;
};
export type GetIntakeValuesApiResponse = 
/** status 200 Intake-form field values prefilled from the source document. */ GetIntakeValuesResponse;
export type GetIntakeValuesApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Canonical Pilot Document.id of the Renewal/Amendment source contract, to prefill the workflow's editable intake-form fields from that document's current values. */
    sourceDocumentId: string;
};
export type RequestWorkflowDocumentUploadApiResponse = 
/** status 201 Presigned upload URL(s), the upload id, and the workflow version the upload landed on. */ DocumentUploadUrlResponse;
export type RequestWorkflowDocumentUploadApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    documentUploadUrlRequest: DocumentUploadUrlRequest;
};
export type WorkflowUploadCompleteApiResponse = 
/** status 200 The document's processing state after the upload was confirmed. */ DocumentUploadCompleteResponse;
export type WorkflowUploadCompleteApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Template document identifier returned by upload-request */
    documentId: string;
    documentUploadCompleteRequest: DocumentUploadCompleteRequest;
};
export type GetWorkflowDocumentDownloadUrlApiResponse = 
/** status 200 A presigned download URL for the template (null while pending), its format and expiry. */ DocumentDownloadUrlResponse;
export type GetWorkflowDocumentDownloadUrlApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Template document identifier */
    documentId: string;
    /** Version number to download. Omit only when the newest version is READY. */
    documentVersion?: number | null;
    /** Which format to download. ``original`` returns the uploaded file; ``sfdt`` returns the cached SFDT conversion. */
    format?: DocumentFormat;
};
export type DeleteWorkflowDocumentApiResponse = 
/** status 204 No content. */ void;
export type DeleteWorkflowDocumentApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique template document identifier (UUID) */
    documentId: UuidPath;
    /** Current version for optimistic locking */
    version: number;
};
export type ReplaceWorkflowDocumentPlaceholderMappingsApiResponse = 
/** status 200 The template document as stored, with the version the write landed on in meta. */ PlaceholderMappingsResponse;
export type ReplaceWorkflowDocumentPlaceholderMappingsApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique template document identifier (UUID) */
    documentId: UuidPath;
    placeholderMappingsRequest: PlaceholderMappingsRequest;
};
export type PreviewWorkflowTemplateApiResponse = 
/** status 200 A short-lived presigned URL for the rendered preview and its format. */ TemplatePreviewResponse;
export type PreviewWorkflowTemplateApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique template document identifier (UUID) */
    documentId: UuidPath;
    templatePreviewRequest: TemplatePreviewRequest;
};
export type CreateWorkflowLocalFieldApiResponse = 
/** status 201 The created field, and the workflow version it was added to. */ CreateLocalFieldResponseRead;
export type CreateWorkflowLocalFieldApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    createLocalFieldRequest: CreateLocalFieldRequest;
};
export type ListWorkflowLocalFieldsApiResponse = 
/** status 200 One page of the version's local fields, in field-library order. */ ListLocalFieldsResponse;
export type ListWorkflowLocalFieldsApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Specific version to retrieve. Omit for latest. */
    version?: number | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type UpdateWorkflowLocalFieldApiResponse = 
/** status 200 The edited field or its copy, and the workflow version that holds it. */ CreateLocalFieldResponseRead;
export type UpdateWorkflowLocalFieldApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** The local field's Unified Fields id (UUID) */
    fieldId: UuidPath;
    updateLocalFieldRequest: UpdateLocalFieldRequest;
};
export type ListWorkflowFieldOverridesApiResponse = 
/** status 200 Every field of the version's field library that has an override scope, in library order. */ ListFieldOverridesResponse;
export type ListWorkflowFieldOverridesApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Specific version to retrieve. Omit for latest. */
    version?: number | null;
};
export type PutWorkflowFieldOverrideApiResponse = 
/** status 200 The override as written, and the workflow version it was written to. */ FieldOverrideWriteResponseRead;
export type PutWorkflowFieldOverrideApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** The global Unified Fields field id (UUID) */
    fieldId: UuidPath;
    putFieldOverrideRequest: PutFieldOverrideRequest;
};
export type DeleteWorkflowFieldOverrideApiResponse = 
/** status 200 The override as it was, and the workflow version it was removed from. */ FieldOverrideWriteResponseRead;
export type DeleteWorkflowFieldOverrideApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** The global Unified Fields field id (UUID) */
    fieldId: UuidPath;
    /** Current workflow version for optimistic locking. */
    version: VersionInt;
};
export type CreateWorkflowPermissionBundleApiResponse = 
/** status 201 The created permission bundle. */ PermissionBundleResponse;
export type CreateWorkflowPermissionBundleApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    createPermissionBundleRequest: CreatePermissionBundleRequest;
};
export type ListWorkflowPermissionBundlesApiResponse = 
/** status 200 Every permission bundle the workflow owns, ordered by name. */ ListPermissionBundlesResponse;
export type ListWorkflowPermissionBundlesApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
};
export type UpdateWorkflowPermissionBundleApiResponse = 
/** status 200 The updated permission bundle. */ PermissionBundleResponse;
export type UpdateWorkflowPermissionBundleApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique permission bundle identifier (UUID) */
    bundleId: UuidPath;
    updatePermissionBundleRequest: UpdatePermissionBundleRequest;
};
export type DeleteWorkflowPermissionBundleApiResponse = 
/** status 204 No content. */ void;
export type DeleteWorkflowPermissionBundleApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique permission bundle identifier (UUID) */
    bundleId: UuidPath;
};
export type CreateWorkflowApiResponse = 
/** status 201 The created workflow. */ CreateWorkflowResponse;
export type CreateWorkflowApiArg = {
    createWorkflowRequest: CreateWorkflowRequest;
};
export type ListWorkflowsApiResponse = 
/** status 200 One page of workflows matching the filters. */ ListWorkflowsResponseRead;
export type ListWorkflowsApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** Data to include in response. By default, only metadata is returned for performance. */
    include?: WorkflowIncludeParam[];
    /** Filter by published status. Mutually exclusive with `status`. */
    published?: boolean | null;
    /** Free-text search over workflow name. Each word matches anywhere inside a word in the name, not only at its start, so `730` matches `Workflow 0730`. A word of 1-2 characters matches by prefix instead when no word in the query is 3+ characters. tsquery operators are stripped. By default (`search_mode=and`) a workflow must match every word in the query. Set `search_mode=or` so a workflow needs to match only some of the query's words, not all of them (e.g. 'find me a standard NDA' matches a workflow named 'NDA Review'); when `search_mode=or` and `sort` is left on the `created_at` field (the default), multi-word queries are then ordered by `ts_rank_cd` relevance instead of recency. Sorting by any other field is always honored as the primary order; relevance only breaks ties between results with an equal sort value in that case. */
    search?: string | null;
    /** How `search`'s words are combined: `and` (default) requires every word to match, matching only the results a caller would expect for a scoped/unique lookup. `or` matches a workflow that contains only some of the query's words, better suited to conversational multi-word queries, at the cost of matching a broader set of workflows and enabling relevance ordering — see the `search` parameter. In `or` mode, words of 1-2 characters match by prefix rather than anywhere in a word. */
    searchMode?: "and" | "or";
    /** Exact-match filter on the user who created the latest version. */
    createdBy?: string | null;
    /** Inclusive lower bound on when the workflow was first created (ISO 8601). */
    createdAtGte?: string | null;
    /** Inclusive upper bound on when the workflow was first created (ISO 8601). */
    createdAtLte?: string | null;
    /** Inclusive lower bound on the latest-version updated_at (ISO 8601). */
    updatedAtGte?: string | null;
    /** Inclusive upper bound on the latest-version updated_at (ISO 8601). */
    updatedAtLte?: string | null;
    /** Sort key. Leading '-' is descending. Default is most-recently-revised first. If left on the `created_at` field (either direction) while `search` is a multi-word query and `search_mode=or`, relevance leads instead — see the `search` and `search_mode` parameters. Sorting by any other field (e.g. `name`) always wins as the primary order, even while searching. */
    sort?: WorkflowSortParam;
    /** Include archived (soft-deleted) workflows alongside active ones. Defaults to `false`, which excludes archived workflows exactly as before. Mutually exclusive with `status`. */
    includeArchived?: boolean;
    /** Multi-value status filter, OR'd across the given values: `published` (not archived and published), `draft` (not archived and not published), `archived` (archived, regardless of its published flag). Lets the list show only archived workflows via `status=archived`. While the release feature is on, `published` also matches a workflow whose latest version is unpublished but that has an older published version (after an older-version publish), and `draft` only a workflow with no published version. Mutually exclusive with `published` and `include_archived` (422 if combined). */
    status?: ("published" | "draft" | "archived")[] | null;
    /** Represent each workflow by its highest published version (name, description, definition, `version`) instead of its newest, so a workflow with a newer unpublished draft is listed as the version requests are created from. Search, sort, and the `created_by`/date filters then read that published version too. Requires `status=published` and no other status (422 otherwise). */
    latestPublished?: boolean;
};
export type GetWorkflowApiResponse = 
/** status 200 The requested workflow version. */ ReadWorkflowResponseRead;
export type GetWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Specific version to retrieve. Omit for latest. */
    version?: number | null;
    /** When true, return the newest published version of this workflow, even if a newer unpublished draft exists. Mutually exclusive with ``version``. */
    latestPublished?: boolean;
    /** Data to include in the response. When omitted, or when only ``actions`` is given, every field — including ``workflow_definition`` and ``acl`` — is loaded. Pass a specific non-``actions`` token (e.g. ``?include=acl``) to narrow to only those gated fields as a payload optimisation. ``actions`` (EKP-64989) is additive and never narrows: it only adds ``attributes.actions``, computed from ticket history and whether the caller's tenant has the workflow-delete release flag enabled. */
    include?: WorkflowIncludeParam[];
};
export type UpdateWorkflowApiResponse = 
/** status 200 The workflow at its newly created version, or the saved Draft at its unchanged version. */ UpdateWorkflowResponseRead;
export type UpdateWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    updateWorkflowRequest: UpdateWorkflowRequest;
};
export type DeleteWorkflowApiResponse = void;
export type DeleteWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unpublished, never-ticketed version to discard. Omit to strictly delete the entire workflow instead -- hard-deleted regardless of archived state, or a 422 if it has ticket history. */
    version?: number | null;
};
export type ListWorkflowVersionsApiResponse = 
/** status 200 One page of the workflow's versions, newest first. */ ListWorkflowVersionsResponse;
export type ListWorkflowVersionsApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ArchiveWorkflowApiResponse = 
/** status 200 The archived workflow. */ GetWorkflowResponseRead;
export type ArchiveWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
};
export type UnarchiveWorkflowApiResponse = 
/** status 200 The unarchived workflow. */ GetWorkflowResponseRead;
export type UnarchiveWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
};
export type PublishWorkflowApiResponse = 
/** status 200 Summary of the published workflow version. */ PublishWorkflowResponse;
export type PublishWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    publishWorkflowRequest: PublishWorkflowRequest;
};
export type UnpublishWorkflowApiResponse = 
/** status 200 The unpublished workflow. */ GetWorkflowResponseRead;
export type UnpublishWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
};
export type CloneWorkflowApiResponse = 
/** status 201 The newly created copy. */ CreateWorkflowResponse;
export type CloneWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    cloneWorkflowRequest: CloneWorkflowRequest;
};
export type UpdateWorkflowAclApiResponse = 
/** status 200 The workflow's full ACL after the update. */ UpdateWorkflowAclResponse;
export type UpdateWorkflowAclApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    updateWorkflowAclRequest: UpdateWorkflowAclRequest;
};
export type ValidateWorkflowApiResponse = 
/** status 200 Validation result with errors, warnings, and which check groups ran. */ ValidateWorkflowResponse;
export type ValidateWorkflowApiArg = {
    validateWorkflowRequest: ValidateWorkflowRequest;
};
export type EvaluateWorkflowFormVisibilityApiResponse = 
/** status 200 The form definition with hidden questions omitted. */ FormVisibilityEvaluationResponse;
export type EvaluateWorkflowFormVisibilityApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    workflowFormVisibilityEvaluationRequest: WorkflowFormVisibilityEvaluationRequest;
};
export type ListWorkflowActivityLogsApiResponse = 
/** status 200 One page of activity log entries for the workflow. */ ListActivityLogsResponse;
export type ListWorkflowActivityLogsApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Filter by resource type */
    resourceType?: string | null;
    /** Filter by action */
    action?: string | null;
    /** Filter to activity logs that include this document id */
    documentId?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ListWorkflowTemplatesApiResponse = 
/** status 200 Every server-defined workflow template, in a single page. */ ListWorkflowTemplatesResponse;
export type ListWorkflowTemplatesApiArg = void;
export type GetWorkflowTemplateApiResponse = 
/** status 200 The requested workflow template. */ ModelResponseWorkflowTemplateResponseData;
export type GetWorkflowTemplateApiArg = {
    /** Template identifier (e.g. 'scratch') */
    templateId: string;
};
export type ListStagesApiResponse = 
/** status 200 The ticket's stages, each with its status, timestamps and task summary. */ ListStagesResponse;
export type ListStagesApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type TransitionToNextStageApiResponse = 
/** status 200 The exited and newly active stage ids and the new ticket version. */ StageTransitionResponse;
export type TransitionToNextStageApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    stageTransitionRequest: StageTransitionRequest;
};
export type TransitionToStageApiResponse = 
/** status 200 The exited and newly active stage ids and the new ticket version. */ StageTransitionResponse;
export type TransitionToStageApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the target stage to transition to */
    targetStageId: string;
    stageTransitionRequest: StageTransitionRequest;
};
export type GetStageAclApiResponse = 
/** status 200 The stage's ACL settings and the current ticket version. */ UpdateStageAclResponseRead;
export type GetStageAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** ID of the stage whose ACL is being read */
    stageId: string;
};
export type UpdateStageAclApiResponse = 
/** status 200 The stage's ACL settings after the update and the new ticket version. */ UpdateStageAclResponseRead;
export type UpdateStageAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the stage whose ACL is being updated */
    stageId: string;
    updateStageAclRequest: UpdateStageAclRequest;
};
export type DeleteStageAclApiResponse = void;
export type DeleteStageAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the stage whose ACL override is being removed */
    stageId: string;
    /** Current version for optimistic locking */
    version: number;
};
export type ListTasksApiResponse = 
/** status 200 One page of the ticket's tasks matching the filters. */ ListTasksResponse;
export type ListTasksApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Filter by stage ID. Use '*' for all stages. */
    stageId?: string | null;
    /** Filter by exact task status. A newly started task is `pending`; it becomes `active` only after a partial approval or a sign request. To find every task actionable now, query `pending` and `active` separately. */
    status?: TaskStatus | null;
    /** Filter by assigned user */
    assignee?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type CreateAdHocTaskApiResponse = 
/** status 201 The created ad-hoc task. */ GetTaskResponse;
export type CreateAdHocTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    adHocTaskCreateRequest: AdHocTaskCreateRequest;
};
export type GetTaskApiResponse = GetTaskResponse;
export type GetTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique task identifier within the ticket */
    taskId: string;
};
export type UpdateAdHocTaskApiResponse = 
/** status 200 The updated ad-hoc task. */ GetTaskResponse;
export type UpdateAdHocTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    adHocTaskUpdateRequest: AdHocTaskUpdateRequest;
};
export type DeleteAdHocTaskApiResponse = void;
export type DeleteAdHocTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    /** Current version for optimistic locking */
    version: number;
};
export type CompleteTaskApiResponse = 
/** status 200 The task's status and approval counts after the judgment, and any tasks it activated. */ TaskCompleteResponse;
export type CompleteTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique task identifier within the ticket */
    taskId: string;
    taskCompleteRequest: TaskCompleteRequest;
};
export type AssignTaskApiResponse = 
/** status 200 The task after the assignment change. */ GetTaskResponse;
export type AssignTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    taskAssignRequest: TaskAssignRequest;
};
export type ClaimTaskApiResponse = 
/** status 200 The task after the claim. */ GetTaskResponse;
export type ClaimTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    taskClaimRequest: TaskClaimRequest;
};
export type ResetTaskApiResponse = 
/** status 200 The task after the reset. */ GetTaskResponse;
export type ResetTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    taskResetRequest: TaskResetRequest;
};
export type RetractJudgmentApiResponse = 
/** status 200 The task after the judgment is retracted. */ GetTaskResponse;
export type RetractJudgmentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    taskResetRequest: TaskResetRequest;
};
export type UpdateTaskAssociationApiResponse = 
/** status 200 The task with its updated associations. */ GetTaskResponse;
export type UpdateTaskAssociationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    taskAssociationUpdateRequest: TaskAssociationUpdateRequest;
};
export type GetTaskAclApiResponse = 
/** status 200 The task's ACL settings and the current ticket version. */ UpdateTaskAclResponseRead;
export type GetTaskAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** ID of the task whose ACL is being read */
    taskId: string;
};
export type UpdateTaskAclApiResponse = 
/** status 200 The task's ACL settings after the update and the new ticket version. */ UpdateTaskAclResponseRead;
export type UpdateTaskAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the task whose ACL is being updated */
    taskId: string;
    updateTaskAclRequest: UpdateTaskAclRequest;
};
export type DeleteTaskAclApiResponse = void;
export type DeleteTaskAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the task whose ACL override is being removed */
    taskId: string;
    /** Current version for optimistic locking */
    version: number;
};
export type RemindTaskApiResponse = 
/** status 200 An empty acknowledgment; the reminder was sent. */ EmptyResponse;
export type RemindTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier (UUID) */
    taskId: UuidPath;
};
export type UpdateFieldApiResponse = 
/** status 200 The ticket's new version and its field values after the update. */ FieldUpdateResponse;
export type UpdateFieldApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unified Fields field ID (UUID); matches keys in ticket field_values. */
    fieldId: UuidPath;
    fieldUpdateRequest: FieldUpdateRequest;
};
export type UpdateFieldsBatchApiResponse = 
/** status 200 The ticket's new version and its field values after the update. */ FieldUpdateResponse;
export type UpdateFieldsBatchApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    fieldBatchUpdateRequest: FieldBatchUpdateRequest;
};
export type CreateCommentApiResponse = 
/** status 201 The created comment. */ CommentResponse;
export type CreateCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    createCommentRequest: CreateCommentRequest;
};
export type ListCommentsApiResponse = 
/** status 200 One page of the ticket's comments, newest first. */ ListCommentsResponse;
export type ListCommentsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Filter by task ID */
    taskId?: string | null;
    filter?: {
        /** Filter by resolved state */
        resolved?: boolean | null;
    };
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ListThreadsApiResponse = 
/** status 200 One page of root comments, each with its replies. */ ListThreadsResponse;
export type ListThreadsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Filter by task ID */
    taskId?: string | null;
    filter?: {
        /** Filter by resolved state of root comment */
        resolved?: boolean | null;
    };
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type GetCommentApiResponse = 
/** status 200 The comment. */ CommentResponse;
export type GetCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type UpdateCommentApiResponse = 
/** status 200 The updated comment. */ CommentResponse;
export type UpdateCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
    updateCommentRequest: UpdateCommentRequest;
};
export type DeleteCommentApiResponse = void;
export type DeleteCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type ResolveCommentApiResponse = 
/** status 200 The comment after it is resolved. */ CommentResponse;
export type ResolveCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type UnresolveCommentApiResponse = 
/** status 200 The comment after its resolved state is cleared. */ CommentResponse;
export type UnresolveCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type RetryGenerationApiResponse = 
/** status 200 The document's state, whether generation is pending, and the ticket version. */ DocumentRetryGenerationResponse;
export type RetryGenerationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
};
export type ForceUnlockTicketDocumentApiResponse = 
/** status 200 The document's state and lock metadata after the unlock. */ DocumentForceUnlockResponse;
export type ForceUnlockTicketDocumentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    documentForceUnlockRequest: DocumentForceUnlockRequest;
};
export type VersionUpTicketDocumentApiResponse = 
/** status 200 The document's state and lock version after the version-up. */ DocumentVersionUpResponse;
export type VersionUpTicketDocumentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    documentVersionUpRequest: DocumentVersionUpRequest;
};
export type PatchDocumentApiResponse = 
/** status 200 The document's metadata after the patch and the new ticket version. */ DocumentPatchResponse;
export type PatchDocumentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    documentPatchRequest: DocumentPatchRequest;
};
export type DeleteTicketDocumentApiResponse = 
/** status 204 No content. */ void;
export type DeleteTicketDocumentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    /** Current version for optimistic locking */
    version: number;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    documentLockVersion?: number | null;
};
export type RecordDocumentShareApiResponse = 
/** status 200 The number of recipients recorded. */ RecordShareResponse;
export type RecordDocumentShareApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    recordShareRequest: RecordShareRequest;
};
export type GetCycleTimeApiResponse = 
/** status 200 The ticket's cycle-time breakdown by stage, phase and party. */ CycleTimeResponse;
export type GetCycleTimeApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type ListTurnsApiResponse = 
/** status 200 One page of the ticket's turn timeline entries. */ ListTurnsResponse;
export type ListTurnsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Opaque cursor from a previous response's `meta.nextToken`; omit for the first page */
    nextToken?: string | null;
    page?: {
        /** Items per page */
        size?: number;
    };
    /** Sort order for turn-groups; default oldest-first */
    sort?: "started_at" | "-started_at";
};
export type CreateTurnApiResponse = 
/** status 201 The created turn timeline entry. */ CreateTurnResponse;
export type CreateTurnApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    createTurnRequest: CreateTurnRequest;
};
export type UpdateTurnApiResponse = 
/** status 200 The updated turn timeline entry. */ CreateTurnResponse;
export type UpdateTurnApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique turn interval identifier (UUID) */
    turnId: UuidPath;
    updateTurnRequest: UpdateTurnRequest;
};
export type RecordSignaturesApiResponse = 
/** status 200 The document's signers after recording and the new ticket version. */ RecordSignaturesResponse;
export type RecordSignaturesApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    recordSignaturesRequest: RecordSignaturesRequest;
};
export type RecordSignaturesBatchApiResponse = 
/** status 200 Each document's signers after recording and the new ticket version. */ RecordSignaturesBatchResponse;
export type RecordSignaturesBatchApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    recordSignaturesBatchRequest: RecordSignaturesBatchRequest;
};
export type GetSigningConfigurationApiResponse = 
/** status 200 The sign task's participants and document assignments. */ SigningConfigurationResponse;
export type GetSigningConfigurationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
};
export type ReplaceSigningConfigurationApiResponse = 
/** status 200 The sign task's signing configuration after the replacement. */ SigningConfigurationResponse;
export type ReplaceSigningConfigurationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier within the ticket */
    taskId: string;
    signingConfigurationRequest: SigningConfigurationRequest;
};
export type CreateEsignPackageApiResponse = 
/** status 202 Async enqueue — creation deferred (no sender_view yet). */ CreateEsignPackageAcceptedResponse;
export type CreateEsignPackageApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    createEsignPackageRequest: CreateEsignPackageRequest;
};
export type GetTicketActionsApiResponse = 
/** status 200 The actions the caller can take on the ticket and its stages, tasks, documents and comments. */ GetTicketActionsResponse;
export type GetTicketActionsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
};
export type ListTicketPermissionBundlesApiResponse = 
/** status 200 The permission bundles the ticket's ACL may grant, ordered by name. */ ListPermissionBundlesResponse;
export type ListTicketPermissionBundlesApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type ListTicketsApiResponse = 
/** status 200 One page of tickets matching the filters. */ ListTicketsResponseRead;
export type ListTicketsApiArg = {
    /** Filter by ticket state. `DRAFT` tickets are unsubmitted intake forms and are omitted from this list for everyone, the requester who created them and admins included — so `state=DRAFT` returns an empty page. Retrieve a draft by id via `GET /tickets/{ticket_id}`. */
    state?: TicketState | null;
    /** Filter by workflow ID */
    workflowId?: string | null;
    /** Filter by the workflow version pinned on the ticket at creation. Requires ``workflow_id``. ``meta.totalCount`` is the matching total for this version under the caller's visibility. */
    workflowVersion?: number | null;
    /** Filter by WSS contract record unique ID (CRUID). Returns the single ticket the caller can see whose integration metadata carries this CRUID, or an empty list. Used by the contract-reroute flow to resolve a k2-minted CRUID to its ticket. */
    contractRecordUniqueId?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** Data to include in response. By default, only metadata is returned for performance. */
    include?: TicketIncludeParam[];
};
export type CreateTicketApiResponse = 
/** status 201 The created ticket. */ CreateTicketResponse;
export type CreateTicketApiArg = {
    /** Optional external reference ID */
    referenceId?: string | null;
    createTicketRequest: CreateTicketRequest;
};
export type CloneTicketApiResponse = 
/** status 201 The new ticket cloned from the source ticket. */ CreateTicketResponse;
export type CloneTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    cloneTicketRequest: CloneTicketRequest;
};
export type GetTicketStateApiResponse = 
/** status 200 The ticket's lifecycle state with per-stage and per-task states. */ TicketStateResponse;
export type GetTicketStateApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
};
export type DeleteTicketApiResponse = void;
export type DeleteTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type UpdateTicketMetadataApiResponse = 
/** status 200 The updated ticket. */ GetTicketResponseRead;
export type UpdateTicketMetadataApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    updateTicketRequest: UpdateTicketRequest;
};
export type GetTicketApiResponse = 
/** status 200 The ticket. */ GetTicketResponseRead;
export type GetTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Data to include in response. By default (empty), all ticket fields are returned for backwards compatibility. `workflow` is opt-in only (never part of the default) and additionally returns the ticket's frozen workflow blueprint under `data.attributes.workflow` — this needs ticket-level view (not `workflow.view`) and is omitted for node-only grantees and inbound S2S. */
    include?: TicketIncludeParam[];
};
export type EvaluateTicketFormVisibilityApiResponse = 
/** status 200 The form definition with hidden questions omitted for the supplied values. */ FormVisibilityEvaluationResponse;
export type EvaluateTicketFormVisibilityApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    ticketFormVisibilityEvaluationRequest: TicketFormVisibilityEvaluationRequest;
};
export type PauseTicketApiResponse = 
/** status 200 The paused ticket. */ GetTicketResponseRead;
export type PauseTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    pauseTicketRequest: PauseTicketRequest;
};
export type ResumeTicketApiResponse = 
/** status 200 The resumed ticket. */ GetTicketResponseRead;
export type ResumeTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    resumeTicketRequest: ResumeTicketRequest;
};
export type CancelTicketApiResponse = 
/** status 200 The cancelled ticket. */ GetTicketResponseRead;
export type CancelTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    cancelTicketRequest: CancelTicketRequest;
};
export type CompleteTicketApiResponse = 
/** status 200 The completed ticket. */ GetTicketResponseRead;
export type CompleteTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    completeTicketRequest: CompleteTicketRequest;
};
export type SubmitTicketApiResponse = 
/** status 200 The submitted ticket. */ GetTicketResponseRead;
export type SubmitTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    submitTicketRequest: SubmitTicketRequest;
};
export type ResetStageTasksApiResponse = 
/** status 200 The ids of the reset tasks, the stage, and the new ticket version. */ ResetStageTasksResponse;
export type ResetStageTasksApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    resetStageTasksRequest: ResetStageTasksRequest;
};
export type UpdateTicketAclApiResponse = 
/** status 200 The ticket's ACL after the update and the new ticket version. */ UpdateTicketAclResponseRead;
export type UpdateTicketAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    updateTicketAclRequest: UpdateTicketAclRequest;
};
export type ReassignTicketOwnerApiResponse = 
/** status 200 The ticket with its new owner. */ GetTicketResponseRead;
export type ReassignTicketOwnerApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    reassignTicketOwnerRequest: ReassignTicketOwnerRequest;
};
export type SupplierNegotiationApiResponse = 
/** status 200 The action performed and the ticket's resulting negotiation status. */ SupplierNegotiationResponse;
export type SupplierNegotiationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    supplierNegotiationRequest: SupplierNegotiationRequest;
};
export type ShareExternallyApiResponse = 
/** status 200 The number of recipients emailed and documents attached. */ ShareExternallyResponse;
export type ShareExternallyApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    shareExternallyRequest: ShareExternallyRequest;
};
export type ShareInternallyApiResponse = 
/** status 200 The number of recipients emailed and documents attached. */ ShareInternallyResponse;
export type ShareInternallyApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    shareInternallyRequest: ShareInternallyRequest;
};
export type GetContractFamilyApiResponse = 
/** status 200 The chain members, root first; with ?include=metadata, also each member's name and status. */ ListContractFamilyResponse;
export type GetContractFamilyApiArg = {
    /** Pilot document ID (integer) whose Contract Family chain to read; non-integer is 400. */
    documentId: string;
    /** Data to include in response. By default, only ids are returned. */
    include?: ContractFamilyIncludeParam[];
};
export type BulkReassignTasksApiResponse = 
/** status 200 The number of task assignments updated and the IDs of the affected tickets. */ BulkReassignResponse;
export type BulkReassignTasksApiArg = {
    bulkReassignRequest: BulkReassignRequest;
};
export type SearchSuppliersApiResponse = 
/** status 200 A page of matching WSS suppliers with pagination meta and links. */ ListSuppliersResponse;
export type SearchSuppliersApiArg = {
    /** Search query (minimum 2 characters) */
    q: string;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page (max 50) */
        size?: number;
    };
};
export type GetSupplierCompanyApiResponse = 
/** status 200 The supplier company, with its contacts in `included` when requested. */ GetSupplierCompanyResponse;
export type GetSupplierCompanyApiArg = {
    /** WSS supplier company ID */
    supplierId: string;
    /** Include supplier_contacts in JSON:API included (default true) */
    includeContacts?: boolean;
};
export type ListContractTypesApiResponse = 
/** status 200 A page of Workday supplier contract types with pagination meta and links. */ ListContractTypesResponse;
export type ListContractTypesApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page (max 1000) */
        size?: number;
    };
};
export type ListCurrenciesApiResponse = 
/** status 200 Every currency code available in the tenant. */ ListCurrenciesResponse;
export type ListCurrenciesApiArg = void;
export type GetIntakeFormLinkApiResponse = 
/** status 200 The published workflow with prepopulated initial field values. */ GetIntakeFormLinkResponseRead;
export type GetIntakeFormLinkApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** WSS reference ID for supplier prepopulation */
    referenceId?: string | null;
};
export type CheckProcurementAmendabilityApiResponse = 
/** status 200 Whether the contract can be amended, with a reason when it cannot. */ ProcurementAmendabilityResponse;
export type CheckProcurementAmendabilityApiArg = {
    /** Contract record unique ID (CRUID) of the contract to check. */
    contractRecordUniqueId: string;
};
export type GetProcurementAmendmentIntakeFormApiResponse = 
/** status 200 The amendment intake workflow with prefill values from the original document. */ GetIntakeFormLinkResponseRead;
export type GetProcurementAmendmentIntakeFormApiArg = {
    /** Contract record unique ID (CRUID) of the contract to amend. */
    contractRecordUniqueId: string;
};
export type GetExpressionAstSchemaApiResponse = 
/** status 200 The Expression AST JSON Schema document. */ any;
export type GetExpressionAstSchemaApiArg = void;
export type SearchCompaniesApiResponse = 
/** status 200 A page of matching Workday companies or hierarchies. */ ListCompaniesResponse;
export type SearchCompaniesApiArg = {
    /** Search query (minimum 2 characters) */
    q: string;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page (max 1000) */
        size?: number;
    };
};
export type RequestDocumentUploadApiResponse = 
/** status 201 The presigned upload URL, its expiry, and the upload and document identifiers. */ DocumentUploadUrlResponse;
export type RequestDocumentUploadApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    ticketDocumentUploadUrlRequest: TicketDocumentUploadUrlRequest;
};
export type UploadCompleteApiResponse = 
/** status 200 The document's processing state and the ticket version. */ DocumentUploadCompleteResponse;
export type UploadCompleteApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    documentUploadCompleteRequest: DocumentUploadCompleteRequest;
};
export type RetryProcessingApiResponse = 
/** status 200 The document's processing state and the ticket version. */ DocumentUploadCompleteResponse;
export type RetryProcessingApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
};
export type CancelPendingDocumentUploadApiResponse = 
/** status 200 The document's state after the cancellation and the ticket version. */ DocumentCancelUploadResponse;
export type CancelPendingDocumentUploadApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
};
export type GetDownloadUrlApiResponse = 
/** status 200 The document's download status and, when ready, a presigned download URL. */
DocumentDownloadUrlResponse | /** status 202 Conversion has been requested but is not yet ready. ``download_url`` is null; poll this endpoint until the response is 200. */ DocumentDownloadUrlResponse;
export type GetDownloadUrlApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    /** Version number to download. Omit only when the newest version is READY. */
    documentVersion?: number | null;
    /** Which format to download. ``original`` returns the uploaded file; ``sfdt`` returns the cached SFDT conversion; ``pdf`` is produced from DOCX via Muse; ``docx`` is produced from legacy ``.doc`` or PDF uploads via Muse. */
    format?: "original" | "sfdt" | "pdf" | "docx";
};
export type GetDocumentComparisonApiResponse = 
/** status 200 The comparison's status and, when ready, a presigned download URL. */
DocumentComparisonResponse | /** status 202 Comparison has been requested but is not yet ready. ``download_url`` is null; poll the same endpoint until the response is 200. */ DocumentComparisonResponse;
export type GetDocumentComparisonApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    /** Newer version (target) in the diff */
    newerVersion: number;
    /** Older version (reference) in the diff */
    olderVersion: number;
};
export type SearchTicketsApiResponse = 
/** status 200 One page of tickets matching the search filters. */ TicketSearchResponse;
export type SearchTicketsApiArg = {
    ticketSearchRequest: TicketSearchRequest;
};
export type GetTicketVersionApiResponse = 
/** status 200 The ticket's current version and per-document lock versions. */ TicketVersionResponse;
export type GetTicketVersionApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type ListTicketActivityLogsApiResponse = 
/** status 200 One page of the ticket's activity log entries. */ ListActivityLogsResponse;
export type ListTicketActivityLogsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Filter by resource type */
    resourceType?: string | null;
    /** Filter by action */
    action?: string | null;
    /** Filter to activity logs that include this document id */
    documentId?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ScribylLockDocumentApiResponse = void;
export type ScribylLockDocumentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    "X-Document-Lock-Version"?: number | null;
    scribylDocumentLockRequest: ScribylDocumentLockRequest;
};
export type ScribylUnlockDocumentApiResponse = 
/** status 204 No content. */ void;
export type ScribylUnlockDocumentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: string;
    /** Unique document identifier on the ticket */
    documentId: string;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    "X-Document-Lock-Version"?: number | null;
    scribylDocumentUnlockRequest: ScribylDocumentUnlockRequest;
};
export type GetWssWorkflowsApiResponse = 
/** status 200 The tenant's integrated workflows in the Workday-facing shape. */ WorkflowListResponse;
export type GetWssWorkflowsApiArg = void;
export type UpdateWssContractNegotiationApiResponse = 
/** status 200 The contract record unique ID that was updated. */ ContractNegotiationUpdateResponse;
export type UpdateWssContractNegotiationApiArg = {
    /** Contract record unique ID from WSS */
    contractRecordUniqueId: string;
    contractNegotiationUpdateRequest: ContractNegotiationUpdateRequest;
};
export type ContractFamilyChainCheckApiResponse = 
/** status 200 The contract-family chains the requested documents belong to. */ ContractFamilyChainCheckResponse;
export type ContractFamilyChainCheckApiArg = {
    /** Pilot document IDs whose contract-family chain to fetch, in this tenant. */
    documentIds: number[];
};
export type CheckResult = {
    /** Name of the dependency checked, e.g. `PostgreSQL` */
    name: string;
    /** Whether the check passed */
    passed: boolean;
    /** Failure detail when the check failed; null when it passed */
    details?: string | null;
};
export type HealthcheckReport = {
    /** True when every check passed; the response is then 200, otherwise 503 */
    healthy: boolean;
    /** Outcome of each check in the probe; empty for liveness */
    checks: CheckResult[];
};
export type FieldUsageResponseAttributes = {
    /** Display name of the workflow */
    workflow_name: string;
    /** Navigable link to the workflow */
    link: string;
};
export type ResourceIdentifier = {
    /** JSON:API resource type string */
    type: string;
    /** Resource identifier (UUID) */
    id: string;
};
export type Links = {
    /** URL of the current resource or collection */
    self?: string | null;
    /** URL of a related resource */
    related?: string | null;
    /** URL of the first page of results */
    first?: string | null;
    /** URL of the last page of results */
    last?: string | null;
    /** URL of the previous page of results; null on the first page */
    prev?: string | null;
    /** URL of the next page of results; null on the last page */
    next?: string | null;
    [key: string]: any;
};
export type RelationshipData = {
    /** Resource identifier(s) for the related resource(s) */
    data?: ResourceIdentifier | ResourceIdentifier[] | null;
    /** Links to fetch the relationship */
    links?: Links | null;
    /** Non-standard metadata for the relationship */
    meta?: {
        [key: string]: any;
    } | null;
};
export type FieldUsageResponseData = {
    /** JSON:API resource type. */
    type?: "workflow-field-usages";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: FieldUsageResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type PageInfo = {
    /** Current page number (1-based); echoes the `page[number]` query parameter. */
    number: number;
    /** Page size used for this response; echoes the `page[size]` query parameter. */
    size: number;
    /** Total number of pages; 0 when there are no results. */
    totalPages: number;
};
export type WorkflowFieldUsagesPaginationMeta = {
    /** Position of this page within the full result set. */
    page: PageInfo;
    /** Total number of matching resources across all pages. */
    totalCount: number;
    /** The `field_id` query parameter; null when filtering by `field_lookup_table_id`. */
    field_id: string | null;
    /** The `field_lookup_table_id` query parameter; null when filtering by `field_id`. */
    field_lookup_table_id: string | null;
    /** The `search` query parameter; null when not supplied. */
    search: string | null;
    /** Only with `include_drafts=true`: how many matching workflows, across all pages, the calling user cannot view. They are left out of `data` and `totalCount`, so the full match is `totalCount + inaccessible_count`. 0 for admins and signed service callers, who see every match. Omitted without `include_drafts`. */
    inaccessible_count?: number;
    [key: string]: any;
};
export type FieldUsagesResponse = {
    /** The primary resource objects, in response order. */
    data: FieldUsageResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata. */
    meta?: WorkflowFieldUsagesPaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ErrorLinks = {
    /** A link that leads to further details about this particular occurrence of the problem. */
    about?: string | null;
    /** A link that identifies the type of error that this particular error is an instance of. */
    type?: string | null;
};
export type ErrorSource = {
    /** JSON Pointer (RFC 6901) to the value in the request document that caused the error. */
    pointer?: string | null;
    /** URI query parameter that caused the error. */
    parameter?: string | null;
    /** Name of a single request header which caused the error. */
    header?: string | null;
};
export type ErrorMeta = {
    /** Message-catalog key of the error message. */
    i18n_key: string;
    /** Values to interpolate into the translated message template. */
    i18n_params: {
        [key: string]: any;
    };
    [key: string]: any;
};
export type ErrorData = {
    /** A unique identifier for this particular occurrence of the problem. */
    id?: string | null;
    /** Links with further detail about this occurrence. */
    links?: ErrorLinks | null;
    /** The HTTP status code applicable to this problem, expressed as a string value. */
    status: string;
    /** An application-specific error code, expressed as a string value. */
    code: string;
    /** A short, human-readable summary of the problem. Should not change from occurrence to occurrence. */
    title: string;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | null;
    /** Where in the request the problem originates. */
    source?: ErrorSource | null;
    /** Translation hints for the error message; present only for domain errors. */
    meta?: ErrorMeta | null;
};
export type ErrorResponse = {
    /** The problems encountered: one per invalid field for `VALIDATION_ERROR`, otherwise exactly one. */
    errors: ErrorData[];
    /** Not used; always omitted. */
    meta?: null;
    /** Links with further detail about the problem. */
    links?: ErrorLinks | null;
};
export type UuidStr = string;
export type TicketFieldUsageResponseAttributes = {
    /** Display name of the ticket */
    ticket_name: string;
    /** Navigable link to the ticket */
    link: string;
};
export type TicketFieldUsageResponseData = {
    /** JSON:API resource type. */
    type?: "ticket-field-usages";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketFieldUsageResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type FieldUsagesPaginationMeta = {
    /** Position of this page within the full result set. */
    page: PageInfo;
    /** Total number of matching resources across all pages. */
    totalCount: number;
    /** The `field_id` query parameter the listing is filtered by. */
    field_id: string;
    [key: string]: any;
};
export type TicketFieldUsagesResponse = {
    /** The primary resource objects, in response order. */
    data: TicketFieldUsageResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata. */
    meta?: FieldUsagesPaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type NegotiationApproveResponseData = {
    /** Ticket id the negotiation hangs off. */
    id: string;
    /** ``accepted`` when Workday took the approval and the write landed. Still ``new_doc_version`` when either leg failed — the caller should read that as 'not settled yet, a redrive will retry', not as an error. */
    negotiation_status: string | null;
};
export type NegotiationApproveResponse = {
    data: NegotiationApproveResponseData;
};
export type RenewalWorkflowAttributes = {
    /** The display name of the resolved intake workflow. */
    name: string;
};
export type RenewalWorkflowResponseData = {
    /** JSON:API resource type. */
    type?: "renewal-workflow";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: RenewalWorkflowAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type PaginationMeta = {
    /** Position of this page within the full result set. */
    page: PageInfo;
    /** Total number of matching resources across all pages. */
    totalCount: number;
    [key: string]: any;
};
export type RenewalWorkflowListResponse = {
    /** The primary resource objects, in response order. */
    data: RenewalWorkflowResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type PrefillFieldValueEntry = {
    /** Scalar value, for text, number, date and boolean fields. */
    value?: string | number | boolean;
    /** Decimal amount, for monetary fields. */
    amount?: string;
    /** Currency code, for monetary fields. */
    currency?: string;
    /** Workday resource identifier, for reference fields. */
    resource_id?: string;
    /** Display name, for reference fields. */
    default_value?: string;
    /** File identifier, for file fields. */
    id?: string;
    /** File name, for file fields. */
    name?: string;
    /** File extension, for file fields. */
    file_type?: string;
    [key: string]: any;
};
export type PrefillFieldValue = {
    /** The field's values; one entry for a single-value field, several for a multi-value field. */
    data: PrefillFieldValueEntry[];
    /** True when a user set or edited the value on its source; false for values extracted from it or applied as field defaults. */
    is_modified?: boolean;
    [key: string]: any;
};
export type IntakeValuesAttributes = {
    /** Prepopulated field values from the source document, keyed by Unified Fields field ID. Only present when provided. */
    initial_field_values?: {
        [key: string]: PrefillFieldValue;
    } | null;
};
export type IntakeValuesResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: IntakeValuesAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type GetIntakeValuesResponse = {
    /** The primary resource object. */
    data: IntakeValuesResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UuidPath = string;
export type DocumentType = "contract" | "exhibit" | "redline" | "nda" | "attachment" | "template";
export type ContentStatus = "pending" | "ready" | "failed";
export type ConversionStatus = "pending" | "ready" | "failed";
export type DocumentConversionSchema = {
    /** Conversion lifecycle: ``pending`` (requested, not yet produced), ``ready`` (downloadable), or ``failed`` (terminally rejected; will not be retried). */
    status: ConversionStatus;
    /** When the conversion was enqueued; null if never requested. */
    requested_at?: string | null;
    /** When the conversion completed; set only when ``status=ready``. */
    generated_at?: string | null;
    /** When the conversion failed terminally; set only when ``status=failed``. */
    failed_at?: string | null;
    /** Error code for a terminal failure — either Muse's (e.g. ``document_parsing_error.condition_missing_period``) or a K2-originated ``k2_error.*`` sentinel (e.g. ``k2_error.source_document_missing``); null when the conversion has not failed or no code was available. */
    error_code?: string | null;
};
export type DocumentVersionMetaSchema = {
    /** Document version number (1-based) */
    version: number;
    /** Processing status of this version (pending, ready, failed) */
    content_status: ContentStatus;
    /** User ID who uploaded this version */
    created_by?: string | null;
    /** Pilot-internal document identifier */
    pilot_document_id?: string | null;
    /** When this version was uploaded */
    created_at: string;
    /** File extension of this version's content (e.g. 'docx', 'pdf'). Per-version because a re-upload can change format; the frontend uses this to pick the viewer (SFDT for docx, native viewer for pdf) for the specific version being opened. */
    file_format?: string | null;
    /** Whether this specific version can be opened in the browser viewer. True when the version is ready and either the format has a native viewer (e.g. PDF) or its SFDT conversion is complete. */
    is_viewable: boolean;
    /** Pilot DocumentHandler ID associated with this version */
    handler_id?: number | null;
    /** Bounded Muse template-fill error code when this generated version failed fill (distinct from conversions.sfdt.error_code). Null when the failure is retryable or this version was not a fill. */
    fill_error_code?: string | null;
    /** Derived-format conversions for this version, keyed by format ('sfdt', 'pdf', 'docx'). Each entry reports status (pending/ready/failed), timestamps, and — on terminal failure — the Muse error_code. Empty when no conversion has been requested for this version. */
    conversions?: {
        [key: string]: DocumentConversionSchema;
    };
};
export type DocumentUploadUrlResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Presigned PUT URL(s) pointing to Pilot's client.bucket */
    upload_urls: string[];
    /** ID of the created or updated document */
    document_id: string;
    /** Expected file size in bytes (must match Content-Length header on PUT) */
    content_length: number;
    /** URL expiration time in seconds */
    expires_in: number;
    /** Owner version after document registration. Document operations sit outside the owner's optimistic-locking system, so this is the current persisted version of the ticket or workflow — unchanged by the upload itself. */
    version: number;
    /** Pilot upload ID; pass to upload-complete after PUT */
    upload_id: string;
};
export type DocumentUploadUrlResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentUploadUrlResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentUploadUrlResponse = {
    /** The primary resource object. */
    data: DocumentUploadUrlResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UploadFieldValue = {
    /** Field value string to associate with this document upload */
    value: string;
};
export type UploadReferenceFieldValue = {
    /** Workday resource identifier (WID) */
    resource_id: string;
    /** Human-readable display name for the reference */
    default_value: string;
};
export type UploadField = {
    /** Unified Field UUID */
    id: string;
    /** One or more values for the field: plain values carry `value`; reference values carry `resource_id` and `default_value`. */
    values: (UploadFieldValue | UploadReferenceFieldValue)[];
};
export type AiBuilderBlank = {
    /** The blank's label; empty for a blank with no label */
    label: string;
    /** Which occurrence of the blank in the template, counting from 1 */
    occurrence: number;
};
export type AiBuilderRecommendation = {
    /** The recommended field's label */
    label: string;
    /** The recommended field's type, as the builder names it */
    logical_type: string;
    /** Further template texts the field would replace, besides `original_text` */
    other_texts?: string[];
    /** Blanks in the template the field would fill */
    blanks?: AiBuilderBlank[];
    /** The Unified Field api_name the recommendation was applied as; null until applied */
    applied_api_name?: string | null;
};
export type AiBuilderField = {
    /** `new` when the builder created the Unified Field, `existing` when it reused one, `recommended` when it recommended a field without placing it */
    origin: "new" | "existing" | "recommended";
    /** The builder's number for this field, unique per origin within the document */
    index: number;
    /** The template text the token replaced, or would replace; may be empty */
    original_text: string;
    /** Set exactly when `origin` is `recommended` */
    recommendation?: AiBuilderRecommendation | null;
};
export type DocumentUploadUrlAttributes = {
    /** Current owner version. Optional and not enforced — document uploads sit outside the owner's optimistic-locking system; accepted for caller compatibility. */
    version?: number | null;
    /** Existing document ID for re-upload of a new version. Omit for a new document. */
    document_id?: string | null;
    /** Filename of the document to upload */
    name: string;
    /** MIME type of the file */
    content_type: string;
    /** File size in bytes. Capped at an INTERIM threat-model ceiling (EKP-58254) pending a real number from Product/vendor docs — see MAX_DOCUMENT_UPLOAD_SIZE_BYTES. This bound is enforced at the API layer only; end-to-end enforcement is tracked in EKP-63193. */
    content_length: number;
    /** Document's role: contract | attachment | template. Omit to use the owner's default (ATTACHMENT for tickets, TEMPLATE for workflows). */
    document_type?: DocumentType | null;
    /** Optional Unified Field values to set on the document. Each entry identifies a field by UUID and supplies one or more values. */
    fields?: UploadField[] | null;
    /** How to handle a name collision with an existing document. true — rename the incoming file by appending '(N)' before the extension (e.g. 'doc(1).docx'). false — treat this upload as a new version of the existing document with the same name. Omit when document_id is set (re-uploads are already explicitly versioned), or when the caller is certain the name is unique. */
    rename?: boolean | null;
    /** For a template the AI workflow builder generated: per Unified Field api_name, the template text the builder replaced with that field's token, and per key of its choosing, each field it recommended without placing (`origin` `recommended`, with a `recommendation`). At most 500 entries; `index` must be unique per `origin` within the document. Omit on a re-upload to keep the stored value. Cleared from every version when the workflow is published. */
    ai_builder_fields?: {
        [key: string]: AiBuilderField;
    } | null;
};
export type DocumentUploadUrlRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "documents";
    /** The resource's attributes. */
    attributes: DocumentUploadUrlAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type DocumentUploadUrlRequest = {
    /** The primary resource object of the request. */
    data: DocumentUploadUrlRequestData;
};
export type DocumentUploadCompleteResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** ID of the completed document */
    document_id: string;
    /** Owner version of the parent resource after completion. Tickets increment; workflows are unchanged (in-place definition update). */
    version: number;
};
export type DocumentUploadCompleteResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentUploadCompleteResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentUploadCompleteResponse = {
    /** The primary resource object. */
    data: DocumentUploadCompleteResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentUploadCompleteAttributes = {
    /** Pilot upload ID from upload-request response */
    upload_id: string;
};
export type DocumentUploadCompleteRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "documents";
    /** The resource's attributes. */
    attributes: DocumentUploadCompleteAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type DocumentUploadCompleteRequest = {
    /** The primary resource object of the request. */
    data: DocumentUploadCompleteRequestData;
};
export type DocumentFormat = "original" | "sfdt" | "pdf" | "docx" | "doc";
export type DocumentDownloadStatus = "ready" | "pending";
export type DocumentDownloadUrlResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Presigned GET URL for downloading the file. Null when ``download_status=pending`` (derived-format conversion in progress). */
    download_url?: string | null;
    /** URL expiration time in seconds (0 when pending) */
    expires_in?: number;
    /** Format of the downloaded payload (original upload or derived conversion) */
    format?: DocumentFormat;
    /** ``ready`` when ``download_url`` is set; ``pending`` for derived-format conversions still being generated (HTTP 202; poll the same endpoint). */
    download_status?: DocumentDownloadStatus;
    /** File size in bytes for ``format=original`` downloads. Null for derived formats (conversion size is not persisted), when ``download_status=pending``, or when size metadata is unavailable (e.g. legacy documents uploaded before this field was persisted). */
    content_length?: number | null;
};
export type DocumentDownloadUrlResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentDownloadUrlResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentDownloadUrlResponse = {
    /** The primary resource object. */
    data: DocumentDownloadUrlResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ResourceName = string;
export type FieldPlaceholderMappingSchema = {
    /** Discriminator: ``field`` binds the placeholder to a Unified Field. */
    kind: "field";
    /** The literal DOCX token, exactly as ``template_metadata.placeholders`` reports it. */
    placeholder: ResourceName;
    /** The active client field api_name whose value fills this placeholder. */
    api_name: ResourceName;
};
export type SignerPlaceholderMappingSchema = {
    /** Discriminator: ``signer`` binds the placeholder to a field of a signing slot. */
    kind?: "signer";
    /** The literal DOCX token, exactly as ``template_metadata.placeholders`` reports it. */
    placeholder: ResourceName;
    /** 1-based signing slot this placeholder belongs to. */
    slot: number;
    /** Signer field to place here. ``signature``/``name``/``email``/``date`` map to the vendor's core tabs; any other lowercase identifier renders a free-text tab the signer fills in. */
    field_name: string;
};
export type PlaceholderMappingsResponseAttributes = {
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
    /** The persisted list, as stored. */
    placeholder_mappings: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
};
export type PlaceholderMappingsResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: PlaceholderMappingsResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type PlaceholderMappingsResponseMeta = {
    /** Workflow version after the save. Unchanged for a draft; ``version + 1`` when the write forked a new draft from a published workflow. */
    version: number;
};
export type PlaceholderMappingsResponse = {
    /** The primary resource object. */
    data: PlaceholderMappingsResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta: PlaceholderMappingsResponseMeta;
    /** Links for the document. */
    links?: Links | null;
};
export type VersionInt = number;
export type PlaceholderMappingsAttributes = {
    /** Current workflow version for optimistic locking */
    version: VersionInt;
    /** Complete, ordered list of bindings from a template placeholder to what fills it — a Unified Field ``api_name`` (``kind: "field"``) or a signing slot's field (``kind: "signer"``), e.g. ``[{"kind": "field", "placeholder": "Fruit Color", "api_name": "CU.0.fruit_color"}, {"kind": "signer", "placeholder": "Signer Full Name", "slot": 1, "field_name": "name"}]``. Every ``placeholder`` must be one of the template's ``template_metadata.placeholders`` and must not be a conditional gate, and no placeholder may repeat. Every ``api_name`` must be an active client field. A ``signer`` entry also **declares** its slot, so a template written entirely in friendly text still gets vendor anchors. A canonical signer token (``signer_1.name``) is a placeholder like any other: an entry on it overrides the token's native signer behaviour — re-pointing it at another slot or at a field — and omitting it restores that behaviour. Its native slot field then leaves ``signers`` unless another placeholder declares it. The order given is the order returned. */
    placeholder_mappings?: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
};
export type PlaceholderMappingsRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "documents";
    /** The resource's attributes. */
    attributes: PlaceholderMappingsAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type PlaceholderMappingsRequest = {
    /** The primary resource object of the request. */
    data: PlaceholderMappingsRequestData;
};
export type TemplatePreviewResult = {
    /** Presigned GET URL for the rendered preview. */
    download_url: string;
    /** Seconds the URL remains valid, or 0 when the renderer did not report one. The object behind it is transient — re-request rather than storing the URL. */
    expires_in: number;
    /** What ``download_url`` actually points at. Normally the requested ``format``, but read this rather than assuming: the URL carries no file extension, so it is the only description of the bytes behind it. */
    format: "sfdt" | "pdf";
};
export type TemplatePreviewResponse = {
    /** The rendered preview's download location. */
    data: TemplatePreviewResult;
};
export type TemplatePreviewAttributes = {
    /** Unsaved field values keyed by Unified Fields field id. A placeholder whose field is absent or blank is left as its raw ``{{token}}`` in the render, exactly as it would be in a real generated document. */
    field_values?: {
        [key: string]: any;
    };
    /** Workflow version to render. Defaults to the latest, which is normally the draft being edited — previewing an unpublished draft is the main use case. */
    workflow_version?: VersionInt | null;
    /** What to render the filled template into. ``sfdt`` is the in-browser editor format and the default; ``pdf`` is a faithful page render, for showing the document as it will print rather than as it can be edited. */
    format?: "sfdt" | "pdf";
};
export type TemplatePreviewRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: TemplatePreviewAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TemplatePreviewRequest = {
    /** The primary resource object of the request. */
    data: TemplatePreviewRequestData;
};
export type LocalFieldLogicalType = "TEXT" | "NUMBER" | "BOOLEAN" | "DATE" | "MONETARY" | "FILE" | "SELECT" | "REFERENCE" | "USER" | "EMAIL" | "URL" | "DURATION" | "DEPARTMENT" | "ADDRESS";
export type LocalFieldSearchType = "KEYWORD" | "TEXT" | "NUMBER" | "DATE" | "BOOLEAN" | "ATTACHMENT" | "REFERENCE" | "USER" | "DEPARTMENT" | "EMAIL" | "URL" | "DURATION" | "ADDRESS";
export type LocalFieldDataClassification = "PUBLIC" | "INTERNAL" | "PII" | "CONFIDENTIAL";
export type LocalFieldAttributes = {
    /** Display name, unique among the version's local fields. */
    custom_name: string;
    /** Free text shown beside the name. */
    description?: string | null;
    /** Unified Fields api_name, unique across the client's fields. */
    api_name: string;
    /** The Unified Fields scope the field lives in. Opaque to clients. */
    scope: string;
    logical_type: LocalFieldLogicalType;
    /** Deprecated. Unified Fields no longer reports it and it is removed in a later release. */
    search_type?: LocalFieldSearchType | null;
    data_classification: LocalFieldDataClassification;
    /** Option set a dropdown field draws its options from. */
    option_set_id?: string | null;
    /** Value a new ticket starts with, in the shape Unified Fields stores for the logical type. */
    default_value?: any;
    /** Opaque settings stored by Unified Fields as sent. */
    custom_settings?: {
        [key: string]: any;
    };
    /** Opaque settings stored by Unified Fields as sent. */
    display_settings?: {
        [key: string]: any;
    };
    /** When the field was deactivated, if it was. */
    deactivated_at?: string | null;
    /** When Unified Fields created the field. */
    created_at: string;
    /** When Unified Fields last changed the field. */
    updated_at: string;
};
export type LocalFieldResponseData = {
    /** JSON:API resource type. */
    type?: "local-field";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: LocalFieldAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type PartyType = "internal" | "counter";
export type Party = {
    /** Unique ID of the party within the workflow */
    id: string;
    /** Display name of the party */
    name?: string;
    type: PartyType;
};
export type DocumentSource = "uploaded" | "generated";
export type DocumentStorage = "pilot" | "muse";
export type SigningStatus = "none" | "pending" | "signed";
export type DocumentSignerRecord = {
    /** Participant assigned to this slot; null for a template slot not yet assigned. */
    participant_id?: string | null;
    /** Stable label for a signing position in the document; independent of signing order. */
    signing_slot?: number;
    /** When the signature for this slot was recorded; null until signed. */
    signed_at?: string | null;
    /** Backend-managed anchor tags for this slot, keyed by signer field name (e.g. `signature`); each holds the placeholder or vendor anchor string under `string`. */
    anchor_tag_values?: {
        [key: string]: any;
    };
    [key: string]: any;
};
export type DocumentLockingMetadataSchema = {
    /** Whether the document is locked for collaborative editing */
    is_locked?: boolean;
    /** Human-readable lock reason (e.g. editor display name) */
    reason?: string | null;
    /** When the lock was acquired */
    lock_acquired_at?: string | null;
    /** When the lock expires, if applicable */
    lock_expires_at?: string | null;
};
export type PaperType = "first_party" | "third_party";
export type ParsedSignerFieldSchema = {
    /** 1-based signing slot index within the document */
    slot: number;
    /** Signer field name: ``signature``/``name``/``email``/``date``/``initials`` or a freeform field name */
    field_name: string;
};
export type TemplateMetadataSchema = {
    /** When the template was parsed (UTC, ISO 8601). */
    parsed_at: string;
    /** All top-level ``{field}`` placeholder tokens found in the template, exactly as they appear in the DOCX (sorted). A token is not necessarily an api_name: a template may be authored with human-readable placeholders and bound to fields via ``placeholder_mappings``. */
    placeholders: string[];
    /** The conditional-block **gate names** — the booleans that include or exclude a block at fill time (sorted). Despite the name, these are gate identifiers, not `{field}` placeholders. At fill time each gate is matched (case-insensitively) to a workflow ``condition_library`` entry and that condition's expression is evaluated; a gate with no matching condition is omitted from the fill, leaving that block unresolved (K2 does not infer a gate from a same-named field value). */
    conditional_placeholders: string[];
    /** Discovered field api_names matched to a Unified Field (sorted). */
    valid_fields: string[];
    /** Discovered field api_names with no matching Unified Field (sorted); surfaced so the author can fix them. */
    invalid_fields: string[];
    /** Signer fields extracted from ``signer_N.field`` placeholders. */
    signer_fields?: ParsedSignerFieldSchema[];
};
export type TemplateParseErrorSchema = {
    /** Muse error code (e.g. ``document_parsing_error.condition_missing_period``); null when omitted. */
    code?: string | null;
};
export type WorkflowDocument = {
    /** Unique identifier for this document */
    document_id: string;
    /** Filename of the document */
    name: string;
    /** How the document was added (uploaded, generated, etc.) */
    source: DocumentSource;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the **head** (newest) version after the upload-timeout overlay. May be failed/pending while is_viewable is true when a prior READY version is shown. Default download stays blocked until the head is READY. */
    content_status: ContentStatus;
    /** Storage backend (pilot or muse) */
    storage: DocumentStorage;
    /** Current version number (increments on re-upload) */
    document_version?: number;
    /** Version the viewer treats as last-good (head when READY and pin-able, else the latest prior READY with a Pilot version pin). Null when nothing is viewable. Distinct from document_version (always the head). Default ORIGINAL download still requires the head to be READY. */
    served_document_version?: number | null;
    /** Per-document optimistic-concurrency token (distinct from document_version, the content re-upload counter). Optional on writes: when supplied on a document mutation it is enforced with a 409 on mismatch; omit it to fall back to ticket-version OCC. */
    document_lock_version?: number;
    /** Chronological list of all document versions with their metadata */
    version_history?: DocumentVersionMetaSchema[];
    /** Whether a browser-viewable rendering is available. Based on the **served** version (head when READY, else latest prior READY), not necessarily the head. True when that version is ready and either the format has a native viewer with a Pilot storage id (e.g. PDF + pilot_document_id) or its SFDT conversion is complete. May be true while content_status is failed/pending when a prior READY exists. Default download is still blocked in that case; pick a version. served_document_version is the last-good view slot, not the default ORIGINAL download. */
    is_viewable: boolean;
    /** Pilot-internal document identifier */
    pilot_document_id?: string | null;
    /** Pilot FileAttachment identifier. Set after a ticket-completion convert step transforms an ATTACHMENT-typed document into a Pilot FileAttachment. */
    pilot_attachment_id?: string | null;
    /** Pilot upload token. Present while the head is pending or failed so retry-processing can re-fire complete_upload server-side; cleared on ready. Clients should not treat this as a capability grant — retry requires doc_upload. */
    upload_id?: string | null;
    /** Template ID if document was generated from a template */
    template_id?: string | null;
    /** Original template document ID for generated documents */
    source_template_document_id?: string | null;
    /** E-signature lifecycle state (null for workflow documents) */
    signing_status?: SigningStatus | null;
    /** Signing slots of the document; empty when it is not signed. */
    signers?: DocumentSignerRecord[];
    /** When the document was generated from a template */
    generated_at?: string | null;
    /** Collaborative-edit lock metadata (Scribyl inbound S2S and future callers) */
    locking_metadata?: DocumentLockingMetadataSchema;
    /** Whether the document is the originator's paper (first_party) or the counterparty's paper (third_party). Set at attach; correctable afterwards via PATCH /tickets/{ticket_id}/documents/{document_id}. */
    paper_type?: PaperType;
    /** Parsed field metadata. Set on TEMPLATE documents after DOCX parsing completes; null otherwise. */
    template_metadata?: TemplateMetadataSchema | null;
    /** This document's slice of the workflow's ``placeholder_mappings`` — the entries whose ``placeholder`` this template actually contains. Mappings are workflow-scoped: the same literal token resolves to the same target in every template that contains it, so an entry shown here may also be shown on another document, and editing it through either one changes it for both. Every ``placeholder`` is drawn from ``template_metadata.placeholders`` and is never a conditional gate. A canonical signer token (``signer_1.name``) may carry an entry like any other placeholder, overriding its native signer behaviour. Ordered, following the workflow-level list. Empty means every placeholder in this template takes its native reading: a canonical signer token fills through the signer overlay, anything else is resolved as an api_name itself. Written via ``PUT /workflows/{id}/documents/{document_id}/placeholder-mappings``. */
    placeholder_mappings?: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
    /** Whether the template's field parse succeeded. True by default; false only when a TEMPLATE document's parse permanently failed at Muse (content_status may still be ready). See ``template_error`` for the reason. */
    template_valid?: boolean;
    /** Why the template parse permanently failed. Set only when ``template_valid`` is false; null otherwise. */
    template_error?: TemplateParseErrorSchema | null;
    /** Set on a TEMPLATE document the AI workflow builder generated: per Unified Field api_name, the template text the builder replaced with that field's token, and the fields it recommended without placing (`origin` `recommended`). Written by the template upload-request; cleared from every version when the workflow is published. Null otherwise. */
    ai_builder_fields?: {
        [key: string]: AiBuilderField;
    } | null;
};
export type ConditionReference = {
    /** ID of a condition in the workflow's condition library */
    condition_id: string;
};
export type SlotTemplate = {
    /** A workflow Document, of type TEMPLATE, this slot can generate from. */
    template_document_id: string;
    /** Gates generation from this template: a reference into ``WorkflowDefinition.condition_library``. Null is always eligible. **Stored and validated, not yet evaluated** — until it is, every entry is eligible and the first one in the list wins. */
    condition?: ConditionReference | null;
};
export type ArchiveLocation = {
    /** Pilot folder ID where documents are filed on ticket completion. */
    pilot_folder_id?: number | null;
    /** ID of an Expression in the workflow expression_library that evaluates to the subfolder path within the base folder. The expression should use a TemplateNode with delimiter='/' and resolve ticket field values. */
    file_path_expression_id?: string | null;
    /** ID of an Expression in the workflow expression_library that evaluates to the file name for the archived document. When set, Pilot stores the document under this name instead of its original upload name. */
    file_name_expression_id?: string | null;
};
export type DocumentSlot = {
    /** Stable slot id. Ticket documents and (later) form fulfillment key off this. */
    id: string;
    /** Identity shown in the builder ("MSA"). Defaults to the template name. */
    name: string;
    /** The templates this slot may generate from, **in priority order**: the first one whose condition holds is the one generated, and nothing else in the list is. Empty means upload-only (no template yet). A template id appears in at most one slot across a workflow, and at most once within a slot. */
    templates?: SlotTemplate[];
    /** Per-slot override of ``settings.archive_location``. Null inherits the workflow-level location at resolve time — it does not mean 'do not archive'. Left null by the migration on purpose, so later edits to the workflow-level setting keep reaching every slot nobody has deliberately overridden. */
    archive_location?: ArchiveLocation | null;
    /** Gates whether this slot is in play for a ticket at all: a reference into ``WorkflowDefinition.condition_library``. Null is always in play. When it does not hold, the slot generates nothing and takes no upload — but it never retroactively unslots a document already on the ticket. **Stored and validated, not yet evaluated** — until it is, every slot is in play, which is what keeps migrated workflows behaving exactly as today. */
    condition?: ConditionReference | null;
};
export type LabelText = string;
export type HelpText = string;
export type FieldLookupTableReference = {
    /** ID of the field lookup table */
    field_lookup_table_id: string;
    /** Field IDs this workflow field draws from the lookup table (at least one) */
    field_ids: string[];
};
export type FieldDefinition = {
    /** Unique ID of the field definition */
    id: string;
    /** Field label */
    name: LabelText;
    /** Help text for the field */
    description?: HelpText;
    /** Data type of the field's value. A free-form string, not validated against a fixed set and compared case-insensitively. Fields resolved from Unified Fields carry the Unified Fields logical type (e.g. TEXT, NUMBER, DATE, MONETARY, FILE, USER, DEPARTMENT). */
    data_type: string;
    field_lookup_table?: FieldLookupTableReference | null;
    /** Opaque Unified Fields scope of a workflow-local field; null for a global field. Local field values are never synced to Pilot. */
    scope?: string | null;
    /** Unified Fields scope under which this workflow overrides the global field's configuration (client_field_overrides). An opaque string, not parsed. Null when the workflow uses the field as-is. Set through the field-overrides endpoints: a workflow update ignores it and keeps the current version's value. */
    override_scope?: string | null;
    /** True when the field's override in `override_scope` exists only to hold an option subset: the field's own Unified Fields default still applies. Requires `override_scope`. Like it, ignored on workflow update. */
    override_inherits_default?: boolean;
};
export type FormFieldReference = {
    /** ID of the field definition the question captures. On an intake form this is the same id used as the key in `initial_field_values` on ticket create. */
    field_id: string;
};
export type FormQuestion = {
    /** Discriminator: a form question */
    type?: "question";
    /** Unique ID of the question within the form */
    id: string;
    /** Question label shown to the filler */
    name: LabelText;
    /** Help text shown with the question */
    description?: HelpText;
    /** Whether the filler must answer the question */
    is_required?: boolean;
    /** Whether the question's value is locked for the ticket filler */
    is_read_only?: boolean;
    form_field: FormFieldReference;
    visible_condition?: ConditionReference | null;
};
export type FormSection = {
    /** Discriminator: a form section */
    type?: "section";
    /** Unique ID of the section within the form */
    id: string;
    /** Section heading */
    name: LabelText;
    /** Help text shown with the section */
    description?: HelpText;
    /** The section's questions in display order */
    questions?: FormQuestion[];
    visible_condition?: ConditionReference | null;
    /** Whether this section is server-owned: the author cannot rename, delete, reorder it, or change which questions it holds. Derived from the section id on every validate, never read from client input. Distinct from FormQuestion.is_read_only, which locks a question's value for the ticket filler. */
    is_locked?: boolean;
};
export type UploadMode = "not_available" | "optional" | "required";
export type TemplateMode = "disabled" | "requester_choice" | "always";
export type PathRule = "choose_one_path" | "allow_both";
export type FormDocumentConfig = {
    /** Master toggle; when false, both upload and generation are blocked regardless of the mode fields */
    allow_doc_submission_or_generation?: boolean;
    upload_mode?: UploadMode;
    template_mode?: TemplateMode;
    path_rule?: PathRule;
    /** Whether the form may be completed without any document. Stored for the client to enforce; the server does not enforce it */
    allow_completing_with_no_document?: boolean;
};
export type Form = {
    /** Unique ID of the form within the workflow's form library */
    id: string;
    /** Form name */
    name: LabelText;
    /** Help text shown with the form */
    description?: HelpText;
    /** The form's ordered structure: sections that own questions, and free-floating questions. JSON ``null`` is accepted as an empty list at parse time but is not part of the OpenAPI type: generated clients should omit the property rather than send null. Responses always serialize a list (never null). */
    elements?: (({
        type: "question";
    } & FormQuestion) | ({
        type: "section";
    } & FormSection))[];
    /** Template documents this form generates from, referencing ``WorkflowDefinition.documents``. Responses serve the resolved list: an empty stored value means the form curates no specific list, so every fillable workflow template is a candidate and all of them are returned. Send an explicit list to curate a subset; sending back the resolved list persists it as that curation. */
    document_template_ids?: string[];
    document_config?: FormDocumentConfig;
};
export type ExpressionParam = {
    /** Parameter name as referenced in the expression without the `$` prefix, e.g. `ticket.field_values.<field_id>` */
    name: string;
    /** Declared value type of the parameter, e.g. `string` */
    type: string;
    /** Fixed value for the parameter; when null the value is resolved from the ticket at evaluation time */
    value?: any | null;
};
export type Expression = {
    /** Unique ID of the expression within the workflow's expression library */
    id: string;
    /** Human-readable label */
    name: string;
    /** Optional description */
    description?: string;
    /** Expected result type, e.g. `boolean` for conditions or `string` */
    result_type: string;
    /** Expression AST as a JSON-encoded string (see GET /api/v1/schemas/expression-ast). The default `[]` is a draft placeholder that validation and publish reject. */
    expression?: string;
    /** Parameters the expression references */
    expression_params?: ExpressionParam[];
};
export type ExpressionReference = {
    /** ID of an expression in the workflow's expression library */
    expression_id: string;
    /** True to look the expression up in this workflow's library; false marks it external and skips reference validation */
    is_local_expression?: boolean;
    /** Parameter overrides for the referenced expression */
    expression_params?: ExpressionParam[];
};
export type Condition = {
    /** Unique ID of the condition within the workflow's condition library */
    id: string;
    /** Human-readable label */
    name: string;
    /** Optional description */
    description?: string;
    /** The expression evaluated for this condition */
    expression: ExpressionReference;
};
export type ConditionalTextReference = {
    /** Gate name used in the template as `{{gate}}.[[text]]` */
    gate: string;
    /** ID of the condition in the workflow's condition library */
    condition_id: string;
};
export type ActionType = "notification" | "webhook" | "field_update" | "document_fill" | "document_parse" | "document_archive" | "esign_package_create";
export type Action = {
    /** Unique ID of the action within the workflow's action library */
    id: string;
    /** Human-readable label */
    name: string;
    type: ActionType;
    /** Optional description */
    description?: string;
    /** Parameters passed to the action */
    action_params?: ExpressionParam[];
};
export type AclPrincipalType = "user" | "department" | "role" | "implicit";
export type AclPrincipal = {
    /** Principal type: `user`, `department`, `role`, or `implicit`. */
    type: AclPrincipalType;
    /** Concrete grantee id for `user`/`department`/`role`; an implicit-role placeholder token for `implicit`. Valid tokens: `submitter`, `submitter_department`, `all_task_assignees`, `task_assignees:<task_id>`, `task_participants`, `field_users:<field_id>` (UF `USER` field), `field_departments:<field_id>` (UF `DEPARTMENT` field). */
    id: string;
};
export type Atom = "task_view" | "task_comment" | "task_execute" | "task_assign" | "task_remind" | "task_manage" | "task_claim" | "doc_view" | "doc_comment" | "doc_download" | "doc_upload" | "doc_edit" | "doc_share" | "ticket_view" | "ticket_comment" | "ticket_activity_view" | "ticket_edit" | "ticket_field_edit" | "ticket_pause" | "ticket_stage_transition" | "ticket_delete" | "ticket_cancel" | "ticket_complete" | "grant_view" | "grant_comment" | "grant_edit" | "grant_policy";
export type CustomPolicy = {
    /** Capabilities this ad-hoc policy grants. Mutually exclusive with `bundle_id`. The set identifies the policy, so restating the same atoms edits the existing one rather than creating a second. */
    atoms?: Atom[] | null;
    /** Identifier of a shareable permission policy to grant. Mutually exclusive with `atoms`. Referenceable are the tenant-wide policies and those declared by this ticket's own workflow; one belonging to another workflow, or to a single ticket, is rejected. */
    bundle_id?: string | null;
    /** Who holds this policy. Entries naming the same policy are merged. */
    principals: AclPrincipal[];
};
export type CustomPolicyRead = {
    /** Capabilities this ad-hoc policy grants. Mutually exclusive with `bundle_id`. The set identifies the policy, so restating the same atoms edits the existing one rather than creating a second. */
    atoms?: Atom[] | null;
    /** Identifier of a shareable permission policy to grant. Mutually exclusive with `atoms`. Referenceable are the tenant-wide policies and those declared by this ticket's own workflow; one belonging to another workflow, or to a single ticket, is rejected. */
    bundle_id?: string | null;
    /** Display name of the referenced policy. Read-only: it belongs to the policy, not to this grant, and is ignored on input so a GET response can be echoed back unchanged. */
    name?: string | null;
    /** Free text shown beside `name` in a policy picker. Read-only, like `name`. */
    description?: string | null;
    /** Who holds this policy. Entries naming the same policy are merged. */
    principals: AclPrincipal[];
};
export type WorkflowAclSettings = {
    /** Viewer (read-access) principals. */
    viewer?: AclPrincipal[];
    /** Commenter (read + comment) principals. */
    commenter?: AclPrincipal[];
    /** Editor (read + write) principals. */
    editor?: AclPrincipal[];
    /** Custom permission policies on this ACL, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) -- never both. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicy[];
};
export type WorkflowAclSettingsRead = {
    /** Viewer (read-access) principals. */
    viewer?: AclPrincipal[];
    /** Commenter (read + comment) principals. */
    commenter?: AclPrincipal[];
    /** Editor (read + write) principals. */
    editor?: AclPrincipal[];
    /** Custom permission policies on this ACL, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) -- never both. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicyRead[];
};
export type CustomNotification = {
    /** Client-generated UUID; stable key for upserts. */
    id: string;
    /** Pilot user IDs to notify; an empty list sends nothing */
    user_ids?: number[];
    /** Custom message included in the email body (max 4096 characters) */
    message?: string;
};
export type DefaultSigner = {
    /** Global signer index (matches signing_slot / participant order) */
    order: number;
    /** Default signer's name */
    name?: string | null;
    /** Default signer's email address */
    email?: string | null;
    /** Server-resolved from Rolodex by email; ignored on write. If no Rolodex fetcher is wired (e.g. a transient S2S outage, not just static misconfiguration) and this workflow's default_signers need resolving, the create/update write fails with a retryable 503 rather than persisting an unverified value. */
    pilot_user_id?: number | null;
    /** Additional signer identity fields (e.g. title, department) by field name. Core signer fields (name, email, signature, date, initials) are rejected at workflow save */
    field_values?: {
        [key: string]: string;
    };
    /** UI label for the signer slot; not used in fill */
    label?: string | null;
    /** Signer's relationship to the company; UI metadata, not used in fill */
    party?: ("N/A" | "Internal" | "External") | null;
    visible_condition?: ConditionReference | null;
};
export type WorkflowSigningConfig = {
    /** Default signers keyed by signer-collection task definition ID */
    default_signers?: {
        [key: string]: DefaultSigner[];
    };
};
export type WorkflowImplicitAclSettings = {
    /** Viewer (read-access) principals. */
    viewer?: AclPrincipal[];
    /** Commenter (read + comment) principals. */
    commenter?: AclPrincipal[];
    /** Editor (read + write) principals. */
    editor?: AclPrincipal[];
    /** Custom permission policies on this ACL, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) -- never both. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicy[];
};
export type WorkflowImplicitAclSettingsRead = {
    /** Viewer (read-access) principals. */
    viewer?: AclPrincipal[];
    /** Commenter (read + comment) principals. */
    commenter?: AclPrincipal[];
    /** Editor (read + write) principals. */
    editor?: AclPrincipal[];
    /** Custom permission policies on this ACL, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) -- never both. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicyRead[];
};
export type AclPermission = "viewer" | "commenter" | "editor";
export type TaskAssigneeAccess = {
    /** Built-in tier (`viewer`, `commenter` or `editor`) granted on the task. Mutually exclusive with `atoms` and `bundle_id`. */
    tier?: AclPermission | null;
    /** Capabilities granted on the task instead of a tier, on top of what being the assignee already allows (see `task_assignee_access`). Mutually exclusive with `tier` and `bundle_id`. Only task-level atoms (`task_*` and `grant_*`) are accepted; `ticket_*` and `doc_*` atoms are rejected. */
    atoms?: Atom[] | null;
    /** A permission bundle this workflow may reference, granted on the task. Edits to the bundle reach current assignees without re-saving the workflow. Only its task-level atoms (`task_*` and `grant_*`) take effect. Mutually exclusive with `tier` and `atoms`. */
    bundle_id?: string | null;
};
export type CertificateOfCompletionMode = "disabled" | "certificate_only" | "combined_with_certificate";
export type RequestIdDateChip = {
    /** Discriminator: date token */
    kind?: "date_chip";
    /** Date component of the ticket's creation date: year (4 or 2 digits), month or day (zero-padded or not) */
    token: "YYYY" | "YY" | "MM" | "M" | "DD" | "D";
};
export type RequestIdIncrementChip = {
    /** Discriminator: the auto-incrementing number */
    kind?: "increment_chip";
};
export type RequestIdTextPart = {
    /** Discriminator: literal text */
    kind?: "text";
    /** Literal text, e.g. `MSA-` */
    value: string;
};
export type WorkflowSettings = {
    /** File types accepted for this workflow's documents; stored as provided */
    accepted_file_types?: string[];
    /** Access template copied onto every ticket created from this workflow: concrete user/department/role grants at the built-in tiers, plus `custom` policies. `signing_participants:<task_id>` is accepted only on `viewer`, matching `implicit_role_permissions`. `custom` here and on `implicit_role_permissions` combined may total at most 100 entries -- enforced on save, not on this schema, so an already-saved workflow can still be read past that combined total. */
    acl?: WorkflowAclSettings;
    archive_location?: ArchiveLocation;
    /** Custom email notifications sent when a ticket from this workflow completes */
    custom_notifications?: CustomNotification[];
    /** ID of an Expression in the workflow expression_library that evaluates to the ticket name string. Only used when use_system_default_ticket_name is False. */
    ticket_naming_convention_expression_id?: string | null;
    /** When False, ticket_naming_convention_expression_id is evaluated to name the ticket. */
    use_system_default_ticket_name?: boolean;
    /** When True (default), a stage is automatically completed and the ticket advances once all of its tasks are done. On the final stage the ticket itself is completed. Clients that persist or send null (clone + AI-generated workflows that omit this setting) are coerced to True at input time. */
    auto_complete_stages?: boolean;
    /** User ID to set as the owner of tickets created from this workflow. When unset (None), the ticket owner defaults to the creating user. The create API does not accept a client-supplied owner, so this workflow setting is the only way to deviate from creator-as-owner. */
    default_owner_user_id?: string | null;
    /** Authoring-time esign defaults keyed by signer-collection task id. */
    signing_config?: WorkflowSigningConfig;
    /** Implicit-only access template granting default tiers, and `custom` policies, to role placeholders on tickets from this workflow. Only `type: implicit` principals are allowed. Valid `id` tokens match `AclPrincipal` (`submitter`, `submitter_department`, `all_task_assignees`, `task_assignees:<task_id>`, `task_participants`, `field_users:<field_id>`, `field_departments:<field_id>`). The default grants `task_participants` `viewer`; see `AclPrincipal` for the fallback. Concrete user/department/role principals are rejected here — put those on `settings.acl` or a ticket/node ACL instead. `signing_participants:<task_id>` is accepted only on `viewer` (redundant with the VIEW grant already applied unconditionally for every signer-collection task) and rejected on `editor`/`commenter`/any other key — signers never need write access. `custom` here and on `acl` combined may total at most 100 entries -- enforced on save, not on this schema, so an already-saved workflow can still be read past that combined total. */
    implicit_role_permissions?: WorkflowImplicitAclSettings;
    /** What each task's current assignees may do on their own task, for every task in this workflow. Applies only while the task is visible, pending or active and on the current stage of an open ticket; afterwards it grants nothing. Default `{"tier": "editor"}`. State a built-in `tier`, an `atoms` set of task-level atoms (`task_*`, `grant_*`), or the `bundle_id` of a permission bundle, whose later edits then apply without re-saving. None removes what being the assignee already allows on their own task: viewing, commenting, completing, approving or rejecting, reminding, managing subtasks and claiming it, and, until a pending permissions update ships, reassigning it. Every check is made per task node, and ticket-level grants (`implicit_role_permissions`) apply on top, so narrowing below the default also needs the ticket-level assignee grant (`all_task_assignees`) lowered. */
    task_assignee_access?: TaskAssigneeAccess;
    /** Free-text hint, authored by a workflow admin, describing when this workflow should be used. Used by Ask AI to suggest a workflow for a new ticket. */
    routing_hint?: string | null;
    /** Whether the vendor certificate of completion is attached to the ticket when an esign package finishes signing. Disabled (default) attaches nothing. CERTIFICATE_ONLY attaches the vendor certificate as its own PDF attachment. COMBINED_WITH_CERTIFICATE attaches the combined signed document plus certificate as a single PDF attachment. Signed source documents are ingested as new versions regardless of this setting. */
    certificate_of_completion_mode?: CertificateOfCompletionMode;
    /** Whether tickets from this workflow get a second, custom, human-readable Custom Request ID (additive to the system ticket id). Independent of use_system_default_ticket_name -- every workflow has a name, not every workflow has a Custom Request ID. */
    request_id_format_enabled?: boolean;
    /** Ordered template parts for the Custom Request ID -- exactly one increment_chip and at least one literal non-separator character are required whenever request_id_format_enabled is True. date_chip parts are modeled but not yet enabled by the editor; see RequestIdDateChip. */
    request_id_format_parts?: (({
        kind: "date_chip";
    } & RequestIdDateChip) | ({
        kind: "increment_chip";
    } & RequestIdIncrementChip) | ({
        kind: "text";
    } & RequestIdTextPart))[];
    /** Minimum digit width the increment_chip pads to with leading zeros. Never truncates -- the number grows past this width once it exceeds it. */
    request_id_min_digits?: number;
};
export type WorkflowSettingsRead = {
    /** File types accepted for this workflow's documents; stored as provided */
    accepted_file_types?: string[];
    /** Access template copied onto every ticket created from this workflow: concrete user/department/role grants at the built-in tiers, plus `custom` policies. `signing_participants:<task_id>` is accepted only on `viewer`, matching `implicit_role_permissions`. `custom` here and on `implicit_role_permissions` combined may total at most 100 entries -- enforced on save, not on this schema, so an already-saved workflow can still be read past that combined total. */
    acl?: WorkflowAclSettingsRead;
    archive_location?: ArchiveLocation;
    /** Custom email notifications sent when a ticket from this workflow completes */
    custom_notifications?: CustomNotification[];
    /** ID of an Expression in the workflow expression_library that evaluates to the ticket name string. Only used when use_system_default_ticket_name is False. */
    ticket_naming_convention_expression_id?: string | null;
    /** When False, ticket_naming_convention_expression_id is evaluated to name the ticket. */
    use_system_default_ticket_name?: boolean;
    /** When True (default), a stage is automatically completed and the ticket advances once all of its tasks are done. On the final stage the ticket itself is completed. Clients that persist or send null (clone + AI-generated workflows that omit this setting) are coerced to True at input time. */
    auto_complete_stages?: boolean;
    /** User ID to set as the owner of tickets created from this workflow. When unset (None), the ticket owner defaults to the creating user. The create API does not accept a client-supplied owner, so this workflow setting is the only way to deviate from creator-as-owner. */
    default_owner_user_id?: string | null;
    /** Authoring-time esign defaults keyed by signer-collection task id. */
    signing_config?: WorkflowSigningConfig;
    /** Implicit-only access template granting default tiers, and `custom` policies, to role placeholders on tickets from this workflow. Only `type: implicit` principals are allowed. Valid `id` tokens match `AclPrincipal` (`submitter`, `submitter_department`, `all_task_assignees`, `task_assignees:<task_id>`, `task_participants`, `field_users:<field_id>`, `field_departments:<field_id>`). The default grants `task_participants` `viewer`; see `AclPrincipal` for the fallback. Concrete user/department/role principals are rejected here — put those on `settings.acl` or a ticket/node ACL instead. `signing_participants:<task_id>` is accepted only on `viewer` (redundant with the VIEW grant already applied unconditionally for every signer-collection task) and rejected on `editor`/`commenter`/any other key — signers never need write access. `custom` here and on `acl` combined may total at most 100 entries -- enforced on save, not on this schema, so an already-saved workflow can still be read past that combined total. */
    implicit_role_permissions?: WorkflowImplicitAclSettingsRead;
    /** What each task's current assignees may do on their own task, for every task in this workflow. Applies only while the task is visible, pending or active and on the current stage of an open ticket; afterwards it grants nothing. Default `{"tier": "editor"}`. State a built-in `tier`, an `atoms` set of task-level atoms (`task_*`, `grant_*`), or the `bundle_id` of a permission bundle, whose later edits then apply without re-saving. None removes what being the assignee already allows on their own task: viewing, commenting, completing, approving or rejecting, reminding, managing subtasks and claiming it, and, until a pending permissions update ships, reassigning it. Every check is made per task node, and ticket-level grants (`implicit_role_permissions`) apply on top, so narrowing below the default also needs the ticket-level assignee grant (`all_task_assignees`) lowered. */
    task_assignee_access?: TaskAssigneeAccess;
    /** Free-text hint, authored by a workflow admin, describing when this workflow should be used. Used by Ask AI to suggest a workflow for a new ticket. */
    routing_hint?: string | null;
    /** Whether the vendor certificate of completion is attached to the ticket when an esign package finishes signing. Disabled (default) attaches nothing. CERTIFICATE_ONLY attaches the vendor certificate as its own PDF attachment. COMBINED_WITH_CERTIFICATE attaches the combined signed document plus certificate as a single PDF attachment. Signed source documents are ingested as new versions regardless of this setting. */
    certificate_of_completion_mode?: CertificateOfCompletionMode;
    /** Whether tickets from this workflow get a second, custom, human-readable Custom Request ID (additive to the system ticket id). Independent of use_system_default_ticket_name -- every workflow has a name, not every workflow has a Custom Request ID. */
    request_id_format_enabled?: boolean;
    /** Ordered template parts for the Custom Request ID -- exactly one increment_chip and at least one literal non-separator character are required whenever request_id_format_enabled is True. date_chip parts are modeled but not yet enabled by the editor; see RequestIdDateChip. */
    request_id_format_parts?: (({
        kind: "date_chip";
    } & RequestIdDateChip) | ({
        kind: "increment_chip";
    } & RequestIdIncrementChip) | ({
        kind: "text";
    } & RequestIdTextPart))[];
    /** Minimum digit width the increment_chip pads to with leading zeros. Never truncates -- the number grows past this width once it exceeds it. */
    request_id_min_digits?: number;
};
export type WorkflowDefinitionResponse = {
    /** Workflow definition ID (assigned by server on create) */
    id?: string | null;
    /** Workflow description */
    description?: string | null;
    /** Ordered list of stage definitions, each containing tasks, conditions, and gate rules */
    stages?: {
        [key: string]: any;
    }[];
    /** Counterparty definitions for external user workflows */
    parties?: Party[];
    /** Template document definitions with computed is_viewable and content_status fields */
    documents?: WorkflowDocument[];
    /** Named places for the documents a ticket is expected to carry. Always a list on a response — unmigrated workflows report one slot per template, minted on read. */
    document_slots?: DocumentSlot[];
    /** Form ID for the intake form shown at ticket creation */
    intake_form_id?: string | null;
    /** Reusable field definitions available across all stages */
    field_library?: FieldDefinition[];
    /** Reusable form definitions available across all stages */
    form_library?: Form[];
    /** Named expressions for computed values and conditions */
    expression_library?: Expression[];
    /** Named conditions that control task visibility and stage gates */
    condition_library?: Condition[];
    /** Links template document conditional-text gates to conditions */
    conditional_texts_library?: ConditionalTextReference[];
    /** Named actions triggered by workflow events */
    action_library?: Action[];
    /** Workflow-level settings: archive location, accepted file types, custom completion notifications, ticket-naming convention, auto-complete-stages behavior, and default signers. */
    settings?: WorkflowSettings;
    /** Every placeholder binding on this workflow: the union across its templates. One entry per literal ``{{token}}``, so a token appearing in several templates fills from the same target in all of them. Each document's ``placeholder_mappings`` is this list filtered to the tokens that template contains. Read-only here — write through ``PUT /workflows/{id}/documents/{document_id}/placeholder-mappings``; a value sent on ``PUT /workflows/{id}`` is ignored. */
    placeholder_mappings?: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
};
export type WorkflowDefinitionResponseRead = {
    /** Workflow definition ID (assigned by server on create) */
    id?: string | null;
    /** Workflow description */
    description?: string | null;
    /** Ordered list of stage definitions, each containing tasks, conditions, and gate rules */
    stages?: {
        [key: string]: any;
    }[];
    /** Counterparty definitions for external user workflows */
    parties?: Party[];
    /** Template document definitions with computed is_viewable and content_status fields */
    documents?: WorkflowDocument[];
    /** Named places for the documents a ticket is expected to carry. Always a list on a response — unmigrated workflows report one slot per template, minted on read. */
    document_slots?: DocumentSlot[];
    /** Form ID for the intake form shown at ticket creation */
    intake_form_id?: string | null;
    /** Reusable field definitions available across all stages */
    field_library?: FieldDefinition[];
    /** Reusable form definitions available across all stages */
    form_library?: Form[];
    /** Named expressions for computed values and conditions */
    expression_library?: Expression[];
    /** Named conditions that control task visibility and stage gates */
    condition_library?: Condition[];
    /** Links template document conditional-text gates to conditions */
    conditional_texts_library?: ConditionalTextReference[];
    /** Named actions triggered by workflow events */
    action_library?: Action[];
    /** Workflow-level settings: archive location, accepted file types, custom completion notifications, ticket-naming convention, auto-complete-stages behavior, and default signers. */
    settings?: WorkflowSettingsRead;
    /** Every placeholder binding on this workflow: the union across its templates. One entry per literal ``{{token}}``, so a token appearing in several templates fills from the same target in all of them. Each document's ``placeholder_mappings`` is this list filtered to the tokens that template contains. Read-only here — write through ``PUT /workflows/{id}/documents/{document_id}/placeholder-mappings``; a value sent on ``PUT /workflows/{id}`` is ignored. */
    placeholder_mappings?: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
};
export type IntegrationType = "none" | "wss_only" | "procurement";
export type BlockedReason = {
    /** Stable machine-readable reason code. */
    code: string;
    /** Localized human-readable explanation of why the action is blocked. */
    message: string;
    /** Structured detail for the code (e.g. blocking_task_ids, missing_field_ids); {} when none. */
    meta?: {
        [key: string]: any;
    };
};
export type WorkflowActionEntry = {
    /** Which action this entry describes. */
    id: "archive" | "unarchive" | "delete";
    /** True iff the action can be performed now (blocked_reason is null). */
    available: boolean;
    /** Why the action is unavailable; null iff available is true. */
    blocked_reason?: BlockedReason | null;
};
export type WorkflowAttributes = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. On GET /workflows/{workflow_id} it is returned when ``include`` is omitted (load-all) or contains ``workflow_definition``, and is null when ``include`` lists only other tokens. On GET /workflows (list) it is null unless ``?include=workflow_definition`` is passed. Update, archive, unarchive and unpublish responses always return it. */
    workflow_definition?: WorkflowDefinitionResponse | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether *this version row* is published. After an older-version publish the latest row is unpublished while an older version is live, so this is not whether the workflow can create tickets: on workflow list and read responses, `published_version` is the live version. */
    published: boolean;
    /** Whether the workflow is archived (soft-deleted). Archived workflows are excluded from GET /workflows list results by default; see the `include_archived` parameter. */
    is_archived: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Available archive/unarchive/delete actions and why any are blocked. Included when ?include=actions is specified. Omitted entirely (not merely null) by every route that cannot populate it -- see each route's own handling in src/hosting/workflows/routes.py and src/hosting/integrate_workflow/routes.py. */
    actions?: WorkflowActionEntry[] | null;
};
export type WorkflowAttributesRead = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. On GET /workflows/{workflow_id} it is returned when ``include`` is omitted (load-all) or contains ``workflow_definition``, and is null when ``include`` lists only other tokens. On GET /workflows (list) it is null unless ``?include=workflow_definition`` is passed. Update, archive, unarchive and unpublish responses always return it. */
    workflow_definition?: WorkflowDefinitionResponseRead | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether *this version row* is published. After an older-version publish the latest row is unpublished while an older version is live, so this is not whether the workflow can create tickets: on workflow list and read responses, `published_version` is the live version. */
    published: boolean;
    /** Whether the workflow is archived (soft-deleted). Archived workflows are excluded from GET /workflows list results by default; see the `include_archived` parameter. */
    is_archived: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Available archive/unarchive/delete actions and why any are blocked. Included when ?include=actions is specified. Omitted entirely (not merely null) by every route that cannot populate it -- see each route's own handling in src/hosting/workflows/routes.py and src/hosting/integrate_workflow/routes.py. */
    actions?: WorkflowActionEntry[] | null;
};
export type WorkflowVersionStatus = "draft" | "published" | "in_use" | "superseded";
export type WorkflowVersionMeta = {
    /** `published` when the version is published and the workflow is not archived; otherwise `in_use` when a request was created from it; otherwise `draft` for the newest unpublished version; otherwise `superseded`. No version of an archived workflow is `published`. */
    status: WorkflowVersionStatus;
    /** Whether this is the newest version of the workflow. */
    is_latest: boolean;
    /** Number of requests created from this version, counted across every request regardless of whether the caller can see it. A version with requests cannot be deleted. */
    request_count: number;
};
export type WorkflowResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Summary of the returned version, set by `GET /workflows/{workflow_id}` when the release flag is on; null otherwise and on every other endpoint. */
    meta?: WorkflowVersionMeta | null;
};
export type WorkflowResponseDataRead = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Summary of the returned version, set by `GET /workflows/{workflow_id}` when the release flag is on; null otherwise and on every other endpoint. */
    meta?: WorkflowVersionMeta | null;
};
export type CreateLocalFieldResponse = {
    /** The primary resource object. */
    data: LocalFieldResponseData;
    /** The workflow at the version the field was added to: the draft, or a newly forked one. */
    included: WorkflowResponseData[];
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type CreateLocalFieldResponseRead = {
    /** The primary resource object. */
    data: LocalFieldResponseData;
    /** The workflow at the version the field was added to: the draft, or a newly forked one. */
    included: WorkflowResponseDataRead[];
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ResourceDescription = string;
export type CreateLocalFieldAttributes = {
    /** Current workflow version for optimistic locking. */
    version: VersionInt;
    /** Display name, unique among the version's local fields. */
    custom_name: ResourceName;
    /** Free text shown beside the name. */
    description?: ResourceDescription | null;
    logical_type: LocalFieldLogicalType;
    /** Deprecated and ignored: the filter type is derived by Unified Fields. */
    search_type?: LocalFieldSearchType | null;
    /** Deprecated and ignored: nothing reads it. Accepted for backward compatibility. */
    data_classification?: LocalFieldDataClassification | null;
    /** Option set for a dropdown field. */
    option_set_id?: string | null;
    /** Value a new ticket starts with, in the shape Unified Fields stores for the logical type. */
    default_value?: {
        [key: string]: any;
    } | null;
    /** Opaque settings stored by Unified Fields as sent. */
    custom_settings?: {
        [key: string]: any;
    } | null;
    /** Opaque settings stored by Unified Fields as sent. */
    display_settings?: {
        [key: string]: any;
    } | null;
};
export type CreateLocalFieldRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "local-field";
    /** The resource's attributes. */
    attributes: CreateLocalFieldAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CreateLocalFieldRequest = {
    /** The primary resource object of the request. */
    data: CreateLocalFieldRequestData;
};
export type ListLocalFieldsResponse = {
    /** The primary resource objects, in response order. */
    data: LocalFieldResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type LocalFieldOption = {
    /** The choice, in the shape of one item of a value's `data` for the field's logical type. */
    value: {
        [key: string]: any;
    };
    /** Whether the dropdown preselects this choice. */
    default?: boolean;
};
export type LocalFieldSortOptions = "POSITION" | "ALPHABETICAL";
export type UpdateLocalFieldAttributes = {
    /** Current workflow version for optimistic locking. */
    version: VersionInt;
    /** Display name, unique among the version's local fields. */
    custom_name?: ResourceName;
    /** Free text shown beside the name. */
    description?: ResourceDescription | null;
    /** Option set for a dropdown field. */
    option_set_id?: string | null;
    /** Value a new ticket starts with, in the shape Unified Fields stores for the logical type. */
    default_value?: {
        [key: string]: any;
    } | null;
    /** Opaque settings stored by Unified Fields as sent. */
    custom_settings?: {
        [key: string]: any;
    } | null;
    /** Opaque settings stored by Unified Fields as sent. */
    display_settings?: {
        [key: string]: any;
    } | null;
    /** A dropdown field's whole option list, in display order, replacing the current one: leave a choice out to delete it, change its `value` to rename it. The field moves to a new option set holding them, so option ids change; values already on tickets are not rewritten. Cannot be sent with `option_set_id`. */
    options?: LocalFieldOption[];
    /** How a dropdown field lists its choices: `POSITION` in the order given, `ALPHABETICAL` in each type's natural order. The field moves to a new option set holding its current choices, or the sent `options`, so option ids change. Cannot be sent with `option_set_id`. */
    sort_options?: LocalFieldSortOptions;
};
export type UpdateLocalFieldRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "local-field";
    /** The resource's attributes. */
    attributes: UpdateLocalFieldAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateLocalFieldRequest = {
    /** The primary resource object of the request. */
    data: UpdateLocalFieldRequestData;
};
export type DefaultMode = "inherit" | "none" | "value";
export type FieldOverrideDefault = {
    /** `inherit` uses the field's own default (none when an option subset omits it), `none` gives no default, and `value` gives `value`. */
    mode: DefaultMode;
    /** The Unified Fields default container (`{"data": [...]}`) when `mode` is `value`, else null. */
    value: {
        [key: string]: any;
    } | null;
};
export type UnifiedFieldsOverride = {
    /** The Unified Fields override id. */
    id: string;
    /** The row's `meta.version` in Unified Fields. */
    version: number;
    /** The overridden global field. */
    field_id: string;
    /** The override's scope, the field's `override_scope`. */
    scope: string;
    /** The scope's default, in the field's `default_value` shape; null for none or an inherited default. */
    default_value?: any;
    /** The override's own option set, holding copies of the shown options; null when every option shows. Its option ids are not those in `option_ids`. */
    option_set_id?: string | null;
    /** The user who created the row. */
    created_by?: number | null;
    /** The user who last changed the row. */
    updated_by?: number | null;
    /** When the row was created. */
    created_at?: string | null;
    /** When the row last changed. */
    updated_at?: string | null;
    [key: string]: any;
};
export type FieldOverrideAttributes = {
    /** The global Unified Fields field id. */
    field_id: string;
    /** The Unified Fields scope that holds this field's override rows. Null only when a `DELETE` names a field that had no override. */
    override_scope: string | null;
    default: FieldOverrideDefault;
    /** Ids of the options the workflow shows, or null when every option shows. */
    option_ids: string[] | null;
    /** The default option among `option_ids`, or null for none; always null without a subset. */
    default_option_id: string | null;
    /** The Unified Fields row behind this override, or null when Unified Fields holds none. */
    unified_fields_override?: UnifiedFieldsOverride | null;
};
export type FieldOverrideResponseData = {
    /** JSON:API resource type. */
    type?: "field-override";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: FieldOverrideAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListFieldOverridesResponse = {
    /** The primary resource objects, in response order. */
    data: FieldOverrideResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type FieldOverrideWriteResponse = {
    /** The primary resource object. */
    data: FieldOverrideResponseData;
    /** The workflow at the version the override was written to: the draft, or a newly forked one. */
    included: WorkflowResponseData[];
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type FieldOverrideWriteResponseRead = {
    /** The primary resource object. */
    data: FieldOverrideResponseData;
    /** The workflow at the version the override was written to: the draft, or a newly forked one. */
    included: WorkflowResponseDataRead[];
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type PutFieldOverrideAttributes = {
    /** Current workflow version for optimistic locking. */
    version: VersionInt;
    default: FieldOverrideDefault;
    /** Ids of the options the workflow shows, or null (the default) for every option. Must not be empty. */
    option_ids?: string[] | null;
    /** The default option among `option_ids`, or null (the default) for none. Requires `option_ids`. A PUT replaces the whole override, so send back the value the GET returned to keep it. */
    default_option_id?: string | null;
};
export type PutFieldOverrideRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "field-override";
    /** The resource's attributes. */
    attributes: PutFieldOverrideAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type PutFieldOverrideRequest = {
    /** The primary resource object of the request. */
    data: PutFieldOverrideRequestData;
};
export type PermissionBundleAttributes = {
    /** Display name, unique within the workflow (case-insensitive). */
    name: string;
    /** Free text shown beside the name. */
    description?: string | null;
    /** The permission atoms this bundle grants. A ticket ACL holds this bundle's id rather than a copy of these atoms, so editing them changes what that reference grants. */
    atoms: Atom[];
};
export type PermissionBundleResponseData = {
    /** JSON:API resource type. */
    type?: "permission-bundle";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: PermissionBundleAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type PermissionBundleResponse = {
    /** The primary resource object. */
    data: PermissionBundleResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type CreatePermissionBundleAttributes = {
    /** Display name. */
    name: string;
    /** Free text shown beside the name. */
    description?: string | null;
    /** The permission atoms this bundle grants. A ticket ACL holds this bundle's id rather than a copy of these atoms, so editing them changes what that reference grants. */
    atoms: Atom[];
};
export type CreatePermissionBundleRequestData = {
    /** JSON:API resource type; defaults to `permission-bundle` when omitted. */
    type?: "permission-bundle";
    attributes: CreatePermissionBundleAttributes;
};
export type CreatePermissionBundleRequest = {
    /** The primary resource object of the request. */
    data: CreatePermissionBundleRequestData;
};
export type ListPermissionBundlesResponse = {
    /** The primary resource objects, in response order. */
    data: PermissionBundleResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type UpdatePermissionBundleAttributes = {
    /** New display name, unique within the workflow (case-insensitive). Omit to leave unchanged. */
    name?: string | null;
    /** Free text shown beside the name. Omit to leave unchanged; send null to clear it. */
    description?: string | null;
    /** The permission atoms this bundle grants. A ticket ACL holds this bundle's id rather than a copy of these atoms, so editing them changes what that reference grants. */
    atoms?: Atom[] | null;
};
export type UpdatePermissionBundleRequestData = {
    /** JSON:API resource type; defaults to `permission-bundle` when omitted. */
    type?: "permission-bundle";
    attributes: UpdatePermissionBundleAttributes;
};
export type UpdatePermissionBundleRequest = {
    /** The primary resource object of the request. */
    data: UpdatePermissionBundleRequestData;
};
export type WorkflowCreateResponseAttributes = {
    /** Workflow name */
    name: string;
    /** Initial version number (1) */
    version: number;
    /** Published state (initially false) */
    published: boolean;
    /** When the workflow was created */
    created_at: string;
    /** User ID who created the workflow */
    created_by: string;
};
export type WorkflowCreateResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowCreateResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type CreateWorkflowResponse = {
    /** The primary resource object. */
    data: WorkflowCreateResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type WorkflowDefinition = {
    /** Workflow definition ID (assigned by server on create) */
    id?: string | null;
    /** Workflow description */
    description?: string | null;
    /** Ordered list of stage definitions, each containing tasks, conditions, and gate rules */
    stages?: {
        [key: string]: any;
    }[];
    /** Counterparty definitions for external user workflows */
    parties?: Party[];
    /** Document template definitions for auto-generation */
    documents?: {
        [key: string]: any;
    }[];
    /** Named places for the documents a ticket is expected to carry. A slot points at a template in ``documents``; it is not the template itself. Each slot's ``archive_location`` is an override of ``settings.archive_location`` — null inherits it. Omit to leave slots untouched; unmigrated workflows report one slot per template, minted on read. */
    document_slots?: DocumentSlot[] | null;
    /** Form ID for the intake form shown at ticket creation */
    intake_form_id?: string | null;
    /** Reusable field definitions available across all stages */
    field_library?: FieldDefinition[];
    /** Reusable form definitions available across all stages */
    form_library?: Form[];
    /** Named expressions for computed values and conditions */
    expression_library?: Expression[];
    /** Named conditions that control task visibility and stage gates */
    condition_library?: Condition[];
    /** Links template document conditional-text gates to conditions */
    conditional_texts_library?: ConditionalTextReference[];
    /** Named actions triggered by workflow events */
    action_library?: Action[];
    /** Workflow-level settings: archive location, accepted file types, custom completion notifications, ticket-naming convention, auto-complete-stages behavior, and default signers. */
    settings?: WorkflowSettings;
};
export type WorkflowDefinitionRead = {
    /** Workflow definition ID (assigned by server on create) */
    id?: string | null;
    /** Workflow description */
    description?: string | null;
    /** Ordered list of stage definitions, each containing tasks, conditions, and gate rules */
    stages?: {
        [key: string]: any;
    }[];
    /** Counterparty definitions for external user workflows */
    parties?: Party[];
    /** Document template definitions for auto-generation */
    documents?: {
        [key: string]: any;
    }[];
    /** Named places for the documents a ticket is expected to carry. A slot points at a template in ``documents``; it is not the template itself. Each slot's ``archive_location`` is an override of ``settings.archive_location`` — null inherits it. Omit to leave slots untouched; unmigrated workflows report one slot per template, minted on read. */
    document_slots?: DocumentSlot[] | null;
    /** Form ID for the intake form shown at ticket creation */
    intake_form_id?: string | null;
    /** Reusable field definitions available across all stages */
    field_library?: FieldDefinition[];
    /** Reusable form definitions available across all stages */
    form_library?: Form[];
    /** Named expressions for computed values and conditions */
    expression_library?: Expression[];
    /** Named conditions that control task visibility and stage gates */
    condition_library?: Condition[];
    /** Links template document conditional-text gates to conditions */
    conditional_texts_library?: ConditionalTextReference[];
    /** Named actions triggered by workflow events */
    action_library?: Action[];
    /** Workflow-level settings: archive location, accepted file types, custom completion notifications, ticket-naming convention, auto-complete-stages behavior, and default signers. */
    settings?: WorkflowSettingsRead;
};
export type WorkflowCreateAttributes = {
    /** Workflow name */
    name: ResourceName;
    /** Complete workflow definition blueprint */
    workflow_definition: WorkflowDefinition;
    /** WSS / Procurement integration type, set once at create (immutable afterward). */
    integration_type?: IntegrationType | null;
    /** Workday contract type id. Only settable when ``integration_type`` is ``procurement``; validated against the Workday contract types catalog. May be omitted while the workflow is a draft, but required before it can be published. */
    contract_type_id?: string | null;
    /** Optional access control list keyed by permission. The workflow stays public/open to the tenant unless it has a non-empty ``viewer`` list — only a viewer grant restricts visibility; editor/commenter-only grants leave it open. The creator is automatically kept as an editor. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
};
export type WorkflowCreateAttributesRead = {
    /** Workflow name */
    name: ResourceName;
    /** Complete workflow definition blueprint */
    workflow_definition: WorkflowDefinitionRead;
    /** WSS / Procurement integration type, set once at create (immutable afterward). */
    integration_type?: IntegrationType | null;
    /** Workday contract type id. Only settable when ``integration_type`` is ``procurement``; validated against the Workday contract types catalog. May be omitted while the workflow is a draft, but required before it can be published. */
    contract_type_id?: string | null;
    /** Optional access control list keyed by permission. The workflow stays public/open to the tenant unless it has a non-empty ``viewer`` list — only a viewer grant restricts visibility; editor/commenter-only grants leave it open. The creator is automatically kept as an editor. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
};
export type WorkflowCreateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowCreateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type WorkflowCreateRequestDataRead = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowCreateAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CreateWorkflowRequest = {
    /** The primary resource object of the request. */
    data: WorkflowCreateRequestData;
};
export type CreateWorkflowRequestRead = {
    /** The primary resource object of the request. */
    data: WorkflowCreateRequestDataRead;
};
export type WorkflowListAttributes = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. On GET /workflows/{workflow_id} it is returned when ``include`` is omitted (load-all) or contains ``workflow_definition``, and is null when ``include`` lists only other tokens. On GET /workflows (list) it is null unless ``?include=workflow_definition`` is passed. Update, archive, unarchive and unpublish responses always return it. */
    workflow_definition?: WorkflowDefinitionResponse | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether *this version row* is published. After an older-version publish the latest row is unpublished while an older version is live, so this is not whether the workflow can create tickets: on workflow list and read responses, `published_version` is the live version. */
    published: boolean;
    /** Whether the workflow is archived (soft-deleted). Archived workflows are excluded from GET /workflows list results by default; see the `include_archived` parameter. */
    is_archived: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Available archive/unarchive/delete actions and why any are blocked. Included when ?include=actions is specified. Omitted entirely (not merely null) by every route that cannot populate it -- see each route's own handling in src/hosting/workflows/routes.py and src/hosting/integrate_workflow/routes.py. */
    actions?: WorkflowActionEntry[] | null;
    /** Highest published version number of the workflow, whichever version is returned: after publishing an older version it is older than the latest `version`, and `published` (which describes the returned version) is false. Null when no version is published. Omitted while the release feature is off. */
    published_version?: number | null;
};
export type WorkflowListAttributesRead = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. On GET /workflows/{workflow_id} it is returned when ``include`` is omitted (load-all) or contains ``workflow_definition``, and is null when ``include`` lists only other tokens. On GET /workflows (list) it is null unless ``?include=workflow_definition`` is passed. Update, archive, unarchive and unpublish responses always return it. */
    workflow_definition?: WorkflowDefinitionResponseRead | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether *this version row* is published. After an older-version publish the latest row is unpublished while an older version is live, so this is not whether the workflow can create tickets: on workflow list and read responses, `published_version` is the live version. */
    published: boolean;
    /** Whether the workflow is archived (soft-deleted). Archived workflows are excluded from GET /workflows list results by default; see the `include_archived` parameter. */
    is_archived: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Available archive/unarchive/delete actions and why any are blocked. Included when ?include=actions is specified. Omitted entirely (not merely null) by every route that cannot populate it -- see each route's own handling in src/hosting/workflows/routes.py and src/hosting/integrate_workflow/routes.py. */
    actions?: WorkflowActionEntry[] | null;
    /** Highest published version number of the workflow, whichever version is returned: after publishing an older version it is older than the latest `version`, and `published` (which describes the returned version) is false. Null when no version is published. Omitted while the release feature is off. */
    published_version?: number | null;
};
export type WorkflowListResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowListAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Summary of the returned version, set by `GET /workflows/{workflow_id}` when the release flag is on; null otherwise and on every other endpoint. */
    meta?: WorkflowVersionMeta | null;
};
export type WorkflowListResponseDataRead = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowListAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Summary of the returned version, set by `GET /workflows/{workflow_id}` when the release flag is on; null otherwise and on every other endpoint. */
    meta?: WorkflowVersionMeta | null;
};
export type ListWorkflowsResponse = {
    /** The primary resource objects, in response order. */
    data: WorkflowListResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ListWorkflowsResponseRead = {
    /** The primary resource objects, in response order. */
    data: WorkflowListResponseDataRead[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type WorkflowIncludeParam = "workflow_definition" | "acl" | "actions";
export type WorkflowSortParam = "name" | "-name" | "created_at" | "-created_at" | "updated_at" | "-updated_at";
export type ReadWorkflowResponse = {
    /** The primary resource object. */
    data: WorkflowListResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ReadWorkflowResponseRead = {
    /** The primary resource object. */
    data: WorkflowListResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateWorkflowResponse = {
    /** The primary resource object. */
    data: WorkflowResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateWorkflowResponseRead = {
    /** The primary resource object. */
    data: WorkflowResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type WorkflowSaveMode = "new_version" | "update_draft";
export type WorkflowUpdateAttributes = {
    /** Workflow name */
    name: ResourceName;
    /** Updated workflow definition (creates a new immutable version) */
    workflow_definition: WorkflowDefinition;
    /** Workday contract type id, settable only on procurement workflows. Omit to leave unchanged; required before publishing. */
    contract_type_id?: string | null;
    /** The version this edit is based on (optimistic locking). Must be the latest for an in-place save. An older version creates a new version from it; a version above the latest is a 409. */
    version: VersionInt;
    /** ``new_version`` (default) always creates a new version; if ``version`` is older than the latest, it is created from that older one (no ``latest_version`` needed), and a ``version`` above the latest is a 409. ``update_draft`` saves the latest version in place, keeping its version number, when that version is an editable Draft (unpublished, and no request was created from it) and ``version`` is the latest; it requires ``updated_at``. If the latest version is published or has requests, a new version is created. If ``version`` is older than the latest, a new version is created from that older one and ``latest_version`` must equal the latest (409 otherwise); a ``version`` above the latest is a 409. The response carries the version to switch to. */
    save_mode?: WorkflowSaveMode;
    /** Concurrency token for ``save_mode=update_draft``: the ``updated_at`` from the last response for this workflow, echoed back exactly as received (do not round-trip it through a date type, which drops microseconds). Required for an in-place save (422 if absent), ignored otherwise. A stale value is rejected with 409. */
    updated_at?: string | null;
    /** The latest version the client believes exists. Required for ``save_mode=update_draft`` when ``version`` is older than the latest (409 if absent or different from the actual latest); ignored otherwise. */
    latest_version?: VersionInt | null;
};
export type WorkflowUpdateAttributesRead = {
    /** Workflow name */
    name: ResourceName;
    /** Updated workflow definition (creates a new immutable version) */
    workflow_definition: WorkflowDefinitionRead;
    /** Workday contract type id, settable only on procurement workflows. Omit to leave unchanged; required before publishing. */
    contract_type_id?: string | null;
    /** The version this edit is based on (optimistic locking). Must be the latest for an in-place save. An older version creates a new version from it; a version above the latest is a 409. */
    version: VersionInt;
    /** ``new_version`` (default) always creates a new version; if ``version`` is older than the latest, it is created from that older one (no ``latest_version`` needed), and a ``version`` above the latest is a 409. ``update_draft`` saves the latest version in place, keeping its version number, when that version is an editable Draft (unpublished, and no request was created from it) and ``version`` is the latest; it requires ``updated_at``. If the latest version is published or has requests, a new version is created. If ``version`` is older than the latest, a new version is created from that older one and ``latest_version`` must equal the latest (409 otherwise); a ``version`` above the latest is a 409. The response carries the version to switch to. */
    save_mode?: WorkflowSaveMode;
    /** Concurrency token for ``save_mode=update_draft``: the ``updated_at`` from the last response for this workflow, echoed back exactly as received (do not round-trip it through a date type, which drops microseconds). Required for an in-place save (422 if absent), ignored otherwise. A stale value is rejected with 409. */
    updated_at?: string | null;
    /** The latest version the client believes exists. Required for ``save_mode=update_draft`` when ``version`` is older than the latest (409 if absent or different from the actual latest); ignored otherwise. */
    latest_version?: VersionInt | null;
};
export type WorkflowUpdateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowUpdateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type WorkflowUpdateRequestDataRead = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowUpdateAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateWorkflowRequest = {
    /** The primary resource object of the request. */
    data: WorkflowUpdateRequestData;
};
export type UpdateWorkflowRequestRead = {
    /** The primary resource object of the request. */
    data: WorkflowUpdateRequestDataRead;
};
export type WorkflowVersionAttributes = {
    /** Version number. */
    version: number;
    /** Whether this is the newest version of the workflow. */
    is_latest: boolean;
    /** Whether this version is published. */
    published: boolean;
    /** `published` when the version is published and the workflow is not archived; otherwise `in_use` when a request was created from it; otherwise `draft` for the newest unpublished version; otherwise `superseded`. No version of an archived workflow is `published`. */
    status: WorkflowVersionStatus;
    /** Workflow name at this version. */
    name: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who last updated this version. */
    updated_by?: string | null;
    /** Number of requests created from this version, counted across every request regardless of whether the caller can see it. A version with requests cannot be deleted. */
    request_count: number;
};
export type WorkflowVersionResponseData = {
    /** JSON:API resource type. */
    type?: "workflow-version";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowVersionAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListWorkflowVersionsResponse = {
    /** The primary resource objects, in response order. */
    data: WorkflowVersionResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type GetWorkflowResponse = {
    /** The primary resource object. */
    data: WorkflowResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type GetWorkflowResponseRead = {
    /** The primary resource object. */
    data: WorkflowResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type WorkflowPublishResponseAttributes = {
    /** Workflow name */
    name: string;
    /** Published version number */
    version: number;
    /** Published state (true after publish) */
    published: boolean;
    /** When the workflow was published. This is the row's last-write timestamp (``updated_at``, falling back to ``created_at``), not an independently recorded publish event. */
    published_at: string;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
};
export type WorkflowPublishResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowPublishResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type PublishWorkflowResponse = {
    /** The primary resource object. */
    data: WorkflowPublishResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type WorkflowPublishAttributes = {
    /** Version to publish */
    version: VersionInt;
    /** The latest version the client saw. Part of the publish guard: required to publish a version older than the latest (omitted, 422), where it must equal the current latest (stale, 409: refresh and try again). Ignored when `version` is the latest. */
    latest_version?: VersionInt | null;
    /** The published version the client saw, or an explicit `null` for none live; omitting the key is not the same as `null`. The other half of the publish guard: required to publish an older version (omitted, 422), and it must equal the version live at commit time (stale, 409: refresh and try again), so an older-version publish never unpublishes a version the client has not seen live. Ignored when `version` is the latest. */
    published_version?: VersionInt | null;
};
export type WorkflowPublishRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowPublishAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type PublishWorkflowRequest = {
    /** The primary resource object of the request. */
    data: WorkflowPublishRequestData;
};
export type WorkflowCloneAttributes = {
    /** Name for the cloned workflow. If omitted, the server defaults to "{original_name} (Copy)". */
    new_name?: string | null;
};
export type WorkflowCloneRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowCloneAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CloneWorkflowRequest = {
    /** The primary resource object of the request. */
    data: WorkflowCloneRequestData;
};
export type UpdateWorkflowAclResponseAttributes = {
    /** Complete ACL after the update, keyed by permission name */
    acl: {
        [key: string]: AclPrincipal[];
    };
};
export type UpdateWorkflowAclResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateWorkflowAclResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateWorkflowAclResponse = {
    /** The primary resource object. */
    data: UpdateWorkflowAclResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateWorkflowAclAttributes = {
    /** ACL updates keyed by permission. Only specified permissions are replaced; omitted ones remain unchanged. `implicit` principals are rejected here with a 400: an implicit-only workflow ACL would resolve to an empty principal set, which the default-open view rule reads as *unrestricted* — the opposite of the intent. Implicit principals are valid on ticket ACLs and on the stage/task ACLs inside `workflow_definition`. */
    acl: {
        [key: string]: AclPrincipal[];
    };
};
export type UpdateWorkflowAclRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: UpdateWorkflowAclAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateWorkflowAclRequest = {
    /** The primary resource object of the request. */
    data: UpdateWorkflowAclRequestData;
};
export type WorkflowValidationContext = {
    /** Stage the item is about. */
    stage_id?: string;
    /** Task the item is about. */
    task_id?: string;
    /** Task group that `task_id` depends on; a task cannot depend on a group. */
    group_id?: string;
    /** Form the item is about. */
    form_id?: string;
    /** Field the item is about. */
    field_id?: string;
    /** Fields a form captures that its own visibility condition reads. */
    field_ids?: string[];
    /** Display names of `field_ids`, in the same order. */
    field_names?: string[];
    /** Data type of `field_id` that the check does not support. */
    data_type?: string;
    /** Condition the item is about. */
    condition_id?: string;
    /** Index in `condition_library` of the condition whose name this one duplicates. */
    conflicts_with_index?: string;
    /** Conditional-text gate that appears more than once, ignoring case. */
    gate?: string;
    /** Expression the item is about. */
    expression_id?: string;
    /** Shortened text of the offending expression. */
    expression_preview?: string;
    /** Result type of `expression_id`. */
    result_type?: string;
    /** Action reference that is not in the action library. */
    action_id?: string;
    /** Document the item is about. */
    document_id?: string;
    /** Document template the item is about. */
    template_id?: string;
    /** Document templates the item is about, sorted. */
    template_ids?: string[];
    /** Workday contract type already linked to another workflow. */
    contract_type_id?: string;
    /** Signing order of the default signer the item is about. */
    order?: number;
    /** Core signer field names the default signer's `field_values` reuse, sorted. */
    keys?: string[];
    /** Number of increment chips in the request ID format; exactly one is required. */
    increment_count?: number;
    [key: string]: any;
};
export type ValidationErrorItem = {
    /** Machine-readable code */
    code: string;
    /** Human-readable message */
    message: string;
    /** JSON path to the problematic element */
    path?: string | null;
    /** Identifiers of the elements the item is about; an empty object when there are none. */
    context?: WorkflowValidationContext;
};
export type ValidationWarning = {
    /** Machine-readable code */
    code: string;
    /** Human-readable message */
    message: string;
    /** JSON path to the problematic element */
    path?: string | null;
    /** Identifiers of the elements the item is about; an empty object when there are none. */
    context?: WorkflowValidationContext;
};
export type WorkflowValidationResult = {
    /** Whether the workflow definition passed validation */
    valid: boolean;
    /** Validation errors that prevent publishing */
    errors?: ValidationErrorItem[];
    /** Non-blocking warnings about potential issues */
    warnings?: ValidationWarning[];
};
export type ValidationCheckGroup = "structure" | "references" | "conditions" | "expressions" | "forms" | "tasks" | "documents" | "signing" | "request_id_format" | "integration" | "warnings";
export type ValidationRunMeta = {
    /** Check groups that ran, in declaration order */
    checks: ValidationCheckGroup[];
    /** True when only some groups ran. `valid` then speaks for those groups only and is not a publish gate -- publish always runs every group. */
    partial: boolean;
};
export type ValidateWorkflowResponse = {
    /** Validation results including errors and warnings */
    data: WorkflowValidationResult;
    /** Metadata about the validation run */
    meta?: ValidationRunMeta | null;
};
export type WorkflowValidateAttributes = {
    /** Workflow definition to validate without saving */
    workflow_definition: WorkflowDefinition;
    /** WSS / Procurement integration type the definition is being validated as */
    integration_type?: IntegrationType | null;
    /** Workday contract type id. */
    contract_type_id?: string | null;
    /** Run only these validation check groups. Omit to run all of them. A narrowed run reports `valid` for the groups that ran only -- it is not a publish gate; see `meta.partial` on the response. */
    checks?: ValidationCheckGroup[] | null;
};
export type WorkflowValidateAttributesRead = {
    /** Workflow definition to validate without saving */
    workflow_definition: WorkflowDefinitionRead;
    /** WSS / Procurement integration type the definition is being validated as */
    integration_type?: IntegrationType | null;
    /** Workday contract type id. */
    contract_type_id?: string | null;
    /** Run only these validation check groups. Omit to run all of them. A narrowed run reports `valid` for the groups that ran only -- it is not a publish gate; see `meta.partial` on the response. */
    checks?: ValidationCheckGroup[] | null;
};
export type WorkflowValidateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowValidateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type WorkflowValidateRequestDataRead = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: WorkflowValidateAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ValidateWorkflowRequest = {
    /** The primary resource object of the request. */
    data: WorkflowValidateRequestData;
};
export type ValidateWorkflowRequestRead = {
    /** The primary resource object of the request. */
    data: WorkflowValidateRequestDataRead;
};
export type FieldLookupTableReferenceSchema = {
    /** Field lookup table id */
    field_lookup_table_id: string;
    /** Field ids configured for this workflow field from the field lookup table */
    field_ids: string[];
};
export type FormFieldDefinitionSchema = {
    /** Field definition ID */
    id: string;
    /** Field name */
    name: string;
    /** Field description */
    description?: string;
    /** Data type of the field (e.g., text, number, date, select) */
    data_type: string;
    /** Field lookup table reference configured for this field in the workflow */
    field_lookup_table?: FieldLookupTableReferenceSchema | null;
};
export type ConditionReferenceSchema = {
    /** ID of the condition in the condition_library */
    condition_id: string;
};
export type FormQuestionSchema = {
    /** Discriminator: required on top-level elements[]. FE branches on type=question vs section */
    type?: "question";
    /** Question ID within the form */
    id: string;
    /** Question display name */
    name: string;
    /** Help text or instructions for the question */
    description?: string;
    /** Whether the question must be answered */
    is_required?: boolean;
    /** Whether the question is read-only (pre-filled) */
    is_read_only?: boolean;
    /** ID of the field in the field_library this question maps to */
    field_id: string;
    /** Inline field definition for this question */
    field_definition: FormFieldDefinitionSchema;
    /** Reference to a condition in the condition_library that controls question visibility */
    visible_condition?: ConditionReferenceSchema | null;
};
export type FormSectionSchema = {
    /** Discriminator: required on top-level elements[]. FE branches on type=section vs question */
    type?: "section";
    /** Section ID within the form */
    id: string;
    /** Section display name */
    name: string;
    /** Help text or instructions for the section */
    description?: string;
    /** Ordered list of questions in this section */
    questions?: FormQuestionSchema[];
    /** Reference to a condition in the condition_library that controls section visibility. When false, the whole section (and every owned question) is omitted from pruned form views. */
    visible_condition?: ConditionReferenceSchema | null;
    /** Whether this section is server-owned. The workflow builder must not let the author rename, delete, reorder it, or add/remove its questions. Server-derived and read-only on the wire. Distinct from a question's is_read_only, which locks a value at fill time. */
    is_locked?: boolean;
};
export type FormDefinitionSchema = {
    /** Form definition ID */
    id: string;
    /** Form name */
    name: string;
    /** Form description */
    description?: string;
    /** Ordered list of this form's elements: sections of questions and free-floating questions */
    elements?: (({
        type: "question";
    } & FormQuestionSchema) | ({
        type: "section";
    } & FormSectionSchema))[];
};
export type FormVisibilityEvaluationResult = {
    /** Form definition with conditional visibility applied: hidden questions are omitted */
    form_definition: FormDefinitionSchema;
};
export type FormVisibilityEvaluationResponse = {
    /** Evaluated, visibility-filtered form definition */
    data: FormVisibilityEvaluationResult;
    /** Not used; always null. */
    meta?: null;
};
export type FormVisibilityEvaluationAttributes = {
    /** ID of the form to evaluate visibility for */
    form_id: string;
    /** Unsaved field values keyed by field id, used to evaluate visibility conditions in-memory */
    field_values?: {
        [key: string]: any;
    };
};
export type WorkflowFormVisibilityEvaluationRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "workflows";
    /** The resource's attributes. */
    attributes: FormVisibilityEvaluationAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type WorkflowFormVisibilityEvaluationRequest = {
    /** The primary resource object of the request. */
    data: WorkflowFormVisibilityEvaluationRequestData;
};
export type ActivityLogAttributes = {
    /** ID of the parent resource this log entry belongs to */
    parent_id: string;
    /** Type of the parent resource */
    parent_type: string;
    /** Type of the resource that changed */
    resource_type: string;
    /** ID of the resource that changed */
    resource_id: string;
    /** Action performed on the resource */
    action: string;
    /** ID of the user or system that performed the action */
    actor_id: string;
    /** Type of actor that performed the action */
    actor_type: string;
    /** Structured context for the action; keys depend on the resource_type and action */
    metadata?: {
        [key: string]: any;
    };
    /** When this activity was recorded */
    created_at?: string | null;
};
export type ActivityLogResponseData = {
    /** JSON:API resource type. */
    type?: "activity-logs";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ActivityLogAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListActivityLogsResponse = {
    /** The primary resource objects, in response order. */
    data: ActivityLogResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type WorkflowTemplateAttributes = {
    /** Display name for the template */
    name: string;
    /** Short description of what the template provides */
    description: string;
    /** Complete workflow definition that can be used as-is when creating a new workflow */
    workflow_definition: {
        [key: string]: any;
    };
};
export type WorkflowTemplateResponseData = {
    /** JSON:API resource type. */
    type?: "workflow-templates";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: WorkflowTemplateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListWorkflowTemplatesResponse = {
    /** The primary resource objects, in response order. */
    data: WorkflowTemplateResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ModelResponseWorkflowTemplateResponseData = {
    /** The primary resource object. */
    data: WorkflowTemplateResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type StageStatus = "pending" | "active" | "completed" | "skipped";
export type TaskSummary = {
    /** Total number of tasks in the stage */
    total: number;
    /** Number of completed/approved tasks */
    completed: number;
    /** Number of pending tasks */
    pending: number;
    /** Number of active (in-progress) tasks */
    active: number;
    /** Number of initialized tasks (stage not yet active) */
    initialized?: number;
};
export type StageAttributes = {
    /** Stage name from the workflow definition */
    name: string;
    /** Stage description */
    description?: string;
    /** Zero-indexed position of this stage in the workflow */
    order: number;
    /** Current stage status */
    status: StageStatus;
    /** Whether this is the currently active stage */
    is_current: boolean;
    /** Whether all blocking conditions are met to exit this stage */
    is_ready_to_complete: boolean;
    /** Human-readable reasons preventing stage completion */
    blocking_reasons?: string[];
    /** When the stage became active */
    entered_at?: string | null;
    /** When the stage was exited */
    exited_at?: string | null;
    /** User ID who triggered the stage transition */
    completed_by?: string | null;
    /** Summary of task counts by status */
    task_summary?: TaskSummary | null;
};
export type StageResponseData = {
    /** JSON:API resource type. */
    type?: "stages";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: StageAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListStagesResponse = {
    /** The primary resource objects, in response order. */
    data: StageResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type StageTransitionResponseAttributes = {
    /** Stage ID of the stage that was exited */
    previous_stage_id: string;
    /** Stage ID of the newly active stage */
    current_stage_id: string;
    /** Updated ticket version after the transition */
    version: number;
};
export type StageTransitionResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: StageTransitionResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type StageTransitionResponse = {
    /** The primary resource object. */
    data: StageTransitionResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type StageTransitionAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type StageTransitionRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: StageTransitionAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type StageTransitionRequest = {
    /** The primary resource object of the request. */
    data: StageTransitionRequestData;
};
export type AclSettings = {
    /** Viewer (read-access) principals. */
    viewer?: AclPrincipal[];
    /** Commenter (read + comment) principals. */
    commenter?: AclPrincipal[];
    /** Editor (read + write) principals. */
    editor?: AclPrincipal[];
    /** Custom permission policies on this ACL, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) -- never both. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicy[];
};
export type AclSettingsRead = {
    /** Viewer (read-access) principals. */
    viewer?: AclPrincipal[];
    /** Commenter (read + comment) principals. */
    commenter?: AclPrincipal[];
    /** Editor (read + write) principals. */
    editor?: AclPrincipal[];
    /** Custom permission policies on this ACL, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) -- never both. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicyRead[];
};
export type UpdateSubResourceAclResponseAttributes = {
    /** Effective ACL for the node after the operation. Sub-resource ACL, one field per permission: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access) -- sub-resources have no `owner` tier -- and `custom` (ad-hoc permission policies). Each tier value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. After a PATCH this is the override just set (including `custom`); after a DELETE it is the workflow-definition (or ad-hoc) default the node reverted to (possibly all-empty, meaning the node inherits access from its parent stage/ticket). */
    acl: AclSettings;
    /** Updated ticket version */
    version: number;
};
export type UpdateSubResourceAclResponseAttributesRead = {
    /** Effective ACL for the node after the operation. Sub-resource ACL, one field per permission: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access) -- sub-resources have no `owner` tier -- and `custom` (ad-hoc permission policies). Each tier value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. After a PATCH this is the override just set (including `custom`); after a DELETE it is the workflow-definition (or ad-hoc) default the node reverted to (possibly all-empty, meaning the node inherits access from its parent stage/ticket). */
    acl: AclSettingsRead;
    /** Updated ticket version */
    version: number;
};
export type UpdateStageAclResponseData = {
    /** JSON:API resource type. */
    type?: "stages";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateStageAclResponseDataRead = {
    /** JSON:API resource type. */
    type?: "stages";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclResponseAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateStageAclResponse = {
    /** The primary resource object. */
    data: UpdateStageAclResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateStageAclResponseRead = {
    /** The primary resource object. */
    data: UpdateStageAclResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type AclSettingsUpdate = {
    /** Viewer (read-access) principals. See the surface's own field for None semantics. */
    viewer?: AclPrincipal[] | null;
    /** Commenter (read + comment) principals. See the surface's own field for None semantics. */
    commenter?: AclPrincipal[] | null;
    /** Editor (read + write) principals. See the surface's own field for None semantics. */
    editor?: AclPrincipal[] | null;
    /** Ad-hoc permission policies, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` or `bundle_id` -- never both. See the surface's own field for None semantics. */
    custom?: CustomPolicy[] | null;
};
export type AclSettingsUpdateRead = {
    /** Viewer (read-access) principals. See the surface's own field for None semantics. */
    viewer?: AclPrincipal[] | null;
    /** Commenter (read + comment) principals. See the surface's own field for None semantics. */
    commenter?: AclPrincipal[] | null;
    /** Editor (read + write) principals. See the surface's own field for None semantics. */
    editor?: AclPrincipal[] | null;
    /** Ad-hoc permission policies, each granting a specific set of capabilities to specific principals. Each entry states either `atoms` or `bundle_id` -- never both. See the surface's own field for None semantics. */
    custom?: CustomPolicyRead[] | null;
};
export type UpdateSubResourceAclAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Sub-resource ACL, one field per permission: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access) -- sub-resources have no `owner` tier -- and `custom` (ad-hoc permission policies). Each tier value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. The override REPLACES the node's ACL and custom policies exactly with this object -- every field omitted (`null`) or sent as `[]` is empty on the result, including `custom` (unlike the ticket-level PATCH, where the same type instead merges field-by-field). An object with no principals and no `custom` entry anywhere is rejected with 422 — use DELETE to remove the override and revert to the workflow default. Tiered delegation on `viewer`/`commenter`/`editor`: you may only grant tiers up to your own access ON THIS NODE (view → viewer; comment → viewer/commenter; edit → any tier); granting a higher tier returns 403. Writing `custom` requires `edit` ON THIS NODE, since a policy names an arbitrary atom set that no tier contains. Removing an override deletes the policies this node owns; a referenced shareable policy survives it and merely loses this node's reference. `signing_participants:<task_id>` is rejected outside `viewer` with a 422. */
    acl?: AclSettingsUpdate;
};
export type UpdateSubResourceAclAttributesRead = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Sub-resource ACL, one field per permission: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access) -- sub-resources have no `owner` tier -- and `custom` (ad-hoc permission policies). Each tier value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. The override REPLACES the node's ACL and custom policies exactly with this object -- every field omitted (`null`) or sent as `[]` is empty on the result, including `custom` (unlike the ticket-level PATCH, where the same type instead merges field-by-field). An object with no principals and no `custom` entry anywhere is rejected with 422 — use DELETE to remove the override and revert to the workflow default. Tiered delegation on `viewer`/`commenter`/`editor`: you may only grant tiers up to your own access ON THIS NODE (view → viewer; comment → viewer/commenter; edit → any tier); granting a higher tier returns 403. Writing `custom` requires `edit` ON THIS NODE, since a policy names an arbitrary atom set that no tier contains. Removing an override deletes the policies this node owns; a referenced shareable policy survives it and merely loses this node's reference. `signing_participants:<task_id>` is rejected outside `viewer` with a 422. */
    acl?: AclSettingsUpdateRead;
};
export type UpdateStageAclRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "stages";
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateStageAclRequestDataRead = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "stages";
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateStageAclRequest = {
    /** The primary resource object of the request. */
    data: UpdateStageAclRequestData;
};
export type UpdateStageAclRequestRead = {
    /** The primary resource object of the request. */
    data: UpdateStageAclRequestDataRead;
};
export type TaskType = "review" | "sign" | "form" | "signer-collection" | "task_group";
export type TaskStatus = "initialized" | "pending" | "active" | "completed" | "approved" | "rejected";
export type RedactedTaskAttributes = {
    /** Discriminator: 'redacted' — the caller may not view this task; contents withheld. */
    visibility?: "redacted";
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
    /** Current task lifecycle state */
    status: TaskStatus;
    /** Whether this task was added at runtime (not defined in workflow) */
    is_ad_hoc: boolean;
    /** ID of the stage this task belongs to */
    stage_id?: string | null;
    /** ID of the parent task_group this task belongs to, if any */
    parent_task_id?: string | null;
};
export type AssignmentMode = "specific_user" | "group_all" | "group_any" | "round_robin" | "group_random";
export type ActorType = "User" | "Department" | "Role" | "ExternalUser" | "PreviousTaskCompleter" | "RequestSubmitter" | "Field";
export type ActorSchema = {
    /** Type of actor (User, Department, Role, etc.) */
    actor_type: ActorType;
    /** Identifier for the actor (user_id, department_id, role_uuid, external user id, source task definition id, or field id). Ignored for implicit actor types such as RequestSubmitter, which name no fixed principal: omit it, or send any value and it will be discarded. */
    actor_id?: string;
};
export type JudgmentIntent = "positive" | "negative";
export type TaskAction = {
    /** Unique identifier for this action within the task */
    action_id: string;
    /** Human-readable label for the action (e.g., 'Approve', 'Reject') */
    label: string;
    /** Semantic intent of this action (positive or negative) */
    intent: JudgmentIntent;
};
export type JudgmentSchema = {
    /** Internal user ID who issued this judgment */
    user_id?: string | null;
    /** External user ID who issued this judgment (mutually exclusive with user_id) */
    external_user_id?: string | null;
    /** ID of the action taken (matches an allowed_actions entry) */
    action_id: string;
    /** Semantic intent of the judgment (positive or negative) */
    intent: JudgmentIntent;
    /** Timestamp when the judgment was recorded */
    judged_at: string;
};
export type TaskAssociationType = "field" | "document" | "clause";
export type TaskAssociation = {
    /** Type of artifact this association links to */
    type: TaskAssociationType;
    /** Artifact identifier (field_id, document_id, or Pilot occurrence_id for clause). */
    id: string;
    /** Secondary qualifier. Opaque dict passed through verbatim; the UI determines its structure. */
    context?: {
        [key: string]: any;
    } | null;
};
export type TaskAttributes = {
    /** Discriminator: 'visible' — the caller may view this task's contents. */
    visibility?: "visible";
    /** Task name from the workflow definition */
    name: string;
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
    /** Current task lifecycle state */
    status: TaskStatus;
    /** Whether this task was added at runtime (not defined in workflow) */
    is_ad_hoc: boolean;
    /** Internal user IDs assigned to this task */
    assigned_to: string[];
    /** External user IDs assigned to this task */
    assigned_external_users?: string[];
    /** How the task is assigned to users */
    assignment_mode: AssignmentMode;
    /** Actors eligible to be assigned or to claim this task, from the task's own definition (workflow-defined or ad-hoc). For a shared-pool (group_any) task, these are the claim-pool grantees — read them here instead of re-deriving them from the included workflow_definition. */
    actors?: ActorSchema[];
    /** Actions available for completing this task (e.g., approve, reject) */
    allowed_actions: TaskAction[];
    /** Judgments recorded on this task */
    judgments?: JudgmentSchema[];
    /** Number of approvals required. When null, all assignees must approve. */
    required_approvals?: number | null;
    /** GROUP_RANDOM only: number of users selected from the combined actor pool. */
    assignee_count?: number | null;
    /** Current number of positive judgments */
    approval_count?: number;
    /** Task due date (informational) */
    due_at?: string | null;
    /** Task description or instructions */
    description?: string | null;
    /** ID of the stage this task belongs to */
    stage_id?: string | null;
    /** ID of the parent task_group this task belongs to, if any */
    parent_task_id?: string | null;
    /** Form definition ID for FORM-type tasks */
    form_id?: string | null;
    /** Full form definition for FORM-type tasks; null for other task types */
    form_definition?: FormDefinitionSchema | null;
    /** Linked artifacts (fields, documents, clauses) */
    associations?: TaskAssociation[];
    /** When this ad-hoc task was added (null for workflow-defined tasks) */
    added_at?: string | null;
    /** User ID of who added this ad-hoc task (null for workflow-defined tasks) */
    added_by?: string | null;
};
export type TaskResponseData = {
    /** JSON:API resource type. */
    type?: "tasks";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ({
        visibility: "redacted";
    } & RedactedTaskAttributes) | ({
        visibility: "visible";
    } & TaskAttributes);
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListTasksResponse = {
    /** The primary resource objects, in response order. */
    data: TaskResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type TaskResponseMeta = {
    /** ID of the ticket comment this request created from its `comment` attribute. */
    comment_id: string;
};
export type GetTaskResponse = {
    /** The primary resource object. */
    data: TaskResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Present only when the request created a comment (e.g. assigning with a `comment`); otherwise null. */
    meta?: TaskResponseMeta | null;
    /** Links for the document. */
    links?: Links | null;
};
export type AdHocTaskCreateAttributes = {
    /** Current TICKET version for optimistic locking (the ad-hoc task is a mutation on the ticket and is validated against the ticket's version). */
    version: VersionInt;
    /** Stage ID from the workflow definition where this ad-hoc task will be added. Use current_stage_id from the ticket or list stages via GET /tickets/{id}/stages. */
    parent_stage_id: string;
    /** Parent task_group ID if creating a child task */
    parent_task_id?: string | null;
    /** Display name for the ad-hoc task */
    name: ResourceName;
    /** Kind of task to create (review, form, task_group). Sign and signer-collection tasks are rejected. */
    type: TaskType;
    /** Optional sub-resource ACL for the new ad-hoc task, keyed by permission (`viewer` / `commenter` / `editor`; sub-resources have no `owner` tier — sending `owner` is rejected). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. When set, the task's ACL is materialized to SpiceDB on creation; omit or send `{}` to inherit access from the parent stage/ticket. You may only grant a tier you hold on the ticket. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Form ID; required when type is FORM */
    form_id?: string | null;
    /** How the task should be assigned */
    assignment_mode: AssignmentMode;
    /** Actions available for completing this task. NOTE: ad-hoc task allowed_actions use field name `action_id` for the action identifier (e.g. `{"action_id":"approve","label":"Approve","intent":"positive"}`). This differs from the workflow_definition's stages[].tasks[].allowed_actions, which uses `id`. */
    allowed_actions: TaskAction[];
    /** Optional due date for the task */
    due_at?: string | null;
    /** Optional task description or instructions */
    description?: ResourceDescription | null;
    /** List of task IDs that must complete before this task can start. If left empty, this defaults to the incomplete tail of any sequential dependency chain already present in the task's stage or task_group. */
    depends_on?: string[];
    /** Number of approvals required. When null, all assignees must approve. */
    required_approvals?: number | null;
    /** GROUP_RANDOM only: number of users to select from the combined actor pool. */
    assignee_count?: number | null;
    /** Actor definitions for task assignment. Each actor specifies a user, department, role, external user, previous task completer, ticket field, or the implicit request submitter. Resolved when the task starts: at creation if it activates then, otherwise when it activates later. A Field actor assigns whoever the ticket's User or Department field names; on a shared-pool (group_any) task, whoever the field currently names may claim. Its field must be a User or Department field on one of the workflow's forms. RequestSubmitter is the request's submitter: the assignee under any mode except group_any, and a claim candidate on a shared-pool (group_any) task. At least one actor is required in every assignment mode, except for task_group tasks. Outside group_any, a task that activates at creation, has a Department or Field actor, and resolves to nobody overall is rejected. */
    actors: ActorSchema[];
    /** Artifacts to link to the task (fields, documents, clauses) */
    associations?: TaskAssociation[];
};
export type AdHocTaskCreateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: AdHocTaskCreateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type AdHocTaskCreateRequest = {
    /** The primary resource object of the request. */
    data: AdHocTaskCreateRequestData;
};
export type AdHocTaskUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** New task name. Omit to leave unchanged. */
    name?: ResourceName | null;
    /** New due date. Omit to leave unchanged. Pass null to clear. */
    due_at?: string | null;
    /** New description. Omit to leave unchanged. Pass null to clear. */
    description?: ResourceDescription | null;
};
export type AdHocTaskUpdateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: AdHocTaskUpdateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type AdHocTaskUpdateRequest = {
    /** The primary resource object of the request. */
    data: AdHocTaskUpdateRequestData;
};
export type TaskCompleteResponseAttributes = {
    /** New task status after completion */
    status: string;
    /** When the judgment was recorded */
    judged_at: string;
    /** Total number of positive judgments after this completion */
    approval_count: number;
    /** Number of approvals needed for the task to be fully approved */
    required_approvals: number;
    /** IDs of tasks that were activated as a result of this completion */
    next_tasks_activated?: string[];
    /** ID of the comment created from `comment`; null when no comment was supplied */
    comment_id?: string | null;
};
export type TaskCompleteResponseData = {
    /** JSON:API resource type. */
    type?: "tasks";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TaskCompleteResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type TaskCompleteResponse = {
    /** The primary resource object. */
    data: TaskCompleteResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type TaskCompleteActionParams = {
    /** FORM tasks only. Templates the user selected to generate when the task's form allows a requester choice. Each ID must be one the form offers. An empty list is an explicit 'generate nothing'; omitting the field leaves the selection unstated. Ignored when the form generates every configured template, and rejected when the form disables generation. */
    template_ids?: string[] | null;
    [key: string]: any;
};
export type TaskCompleteAttributes = {
    /** Current TICKET version for optimistic locking. Task lifecycle endpoints (complete/claim/reset/retract/assign) validate against the parent ticket's version — not the task's. Re-GET the ticket after any prior mutation to obtain the correct value. */
    version: VersionInt;
    /** ID of the action to perform (must match one of the task's allowed_actions) */
    action_id: string;
    /** Optional parameters for the action (e.g., document template selection for FORM tasks) */
    action_params?: TaskCompleteActionParams;
    /** Optional note recorded against this judgment (approve/reject). Persisted as a task-scoped comment, atomically with the completion, and returned as `comment_id`. Readable afterwards through GET /tickets/{ticket_id}/comments like any other task comment. Blank or whitespace-only is treated as no comment. HTML tags are rejected. */
    comment?: string | null;
};
export type TaskCompleteRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: TaskCompleteAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TaskCompleteRequest = {
    /** The primary resource object of the request. */
    data: TaskCompleteRequestData;
};
export type TaskAssignAttributes = {
    /** Current TICKET version for optimistic locking. Task lifecycle endpoints validate against the parent ticket's version — not the task's. Re-GET the ticket after any prior mutation to obtain the correct value. */
    version: VersionInt;
    /** Internal user IDs to assign to the task */
    user_ids?: string[];
    /** External user IDs (must exist in ticket.external_users) */
    external_user_ids?: string[];
    /** Optional note recorded against this assignment. Persisted as a task-scoped comment, atomically with the assignment, and returned as `meta.comment_id`. Readable afterwards through GET /tickets/{ticket_id}/comments like any other task comment. Blank or whitespace-only is treated as no comment. HTML tags are rejected. */
    comment?: string | null;
};
export type TaskAssignRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: TaskAssignAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TaskAssignRequest = {
    /** The primary resource object of the request. */
    data: TaskAssignRequestData;
};
export type TaskClaimAttributes = {
    /** Current TICKET version for optimistic locking. Task lifecycle endpoints validate against the parent ticket's version — not the task's. */
    version: VersionInt;
};
export type TaskClaimRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: TaskClaimAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TaskClaimRequest = {
    /** The primary resource object of the request. */
    data: TaskClaimRequestData;
};
export type TaskResetAttributes = {
    /** Current TICKET version for optimistic locking. Also used by /retract. Task lifecycle endpoints validate against the parent ticket's version — not the task's. */
    version: VersionInt;
};
export type TaskResetRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: TaskResetAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TaskResetRequest = {
    /** The primary resource object of the request. */
    data: TaskResetRequestData;
};
export type TaskAssociationUpdateAttributes = {
    /** Current TICKET version for optimistic locking (task associations are a mutation on the ticket and are validated against the ticket's version). */
    version: VersionInt;
    /** Full replacement list of task associations (fields, documents, clauses) */
    associations?: TaskAssociation[];
};
export type TaskAssociationUpdateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tasks";
    /** The resource's attributes. */
    attributes: TaskAssociationUpdateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TaskAssociationUpdateRequest = {
    /** The primary resource object of the request. */
    data: TaskAssociationUpdateRequestData;
};
export type UpdateTaskAclResponseData = {
    /** JSON:API resource type. */
    type?: "tasks";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateTaskAclResponseDataRead = {
    /** JSON:API resource type. */
    type?: "tasks";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclResponseAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateTaskAclResponse = {
    /** The primary resource object. */
    data: UpdateTaskAclResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateTaskAclResponseRead = {
    /** The primary resource object. */
    data: UpdateTaskAclResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateTaskAclRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "tasks";
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateTaskAclRequestDataRead = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "tasks";
    /** The resource's attributes. */
    attributes: UpdateSubResourceAclAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateTaskAclRequest = {
    /** The primary resource object of the request. */
    data: UpdateTaskAclRequestData;
};
export type UpdateTaskAclRequestRead = {
    /** The primary resource object of the request. */
    data: UpdateTaskAclRequestDataRead;
};
export type EmptyData = {};
export type EmptyResponse = {
    /** Always an empty object. */
    data?: EmptyData;
};
export type FieldRawValue = string | boolean | any[] | {
    [key: string]: any;
};
export type FieldOrigin = "api" | "ai" | "manual";
export type FieldValueSchema = {
    /** Raw field value as stored in Postgres. Scalar for single-value fields; list for multi-value; dict for monetary. */
    value: FieldRawValue;
    /** When this field was last updated */
    updated_at: string;
    /** User ID who last updated this field */
    updated_by: string;
    /** How the value was set (manual, ai_extracted, system, etc.) */
    origin?: FieldOrigin;
};
export type FieldUpdateResponseAttributes = {
    /** Updated ticket version after the field update */
    version: number;
    /** Map of all field values on the ticket keyed by field_id from the workflow definition. */
    field_values: {
        [key: string]: FieldValueSchema;
    };
};
export type FieldUpdateResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: FieldUpdateResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type FieldUpdateResponse = {
    /** The primary resource object. */
    data: FieldUpdateResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UserEnteredText = string;
export type FieldValueScalarEntry = {
    /** Scalar field value: a string for TEXT/DATE/NUMBER fields, or a boolean for BOOLEAN fields. HTML tags are rejected. */
    value: UserEnteredText | boolean;
};
export type FieldValueMonetaryEntry = {
    /** Monetary amount as a decimal string */
    amount: UserEnteredText;
    /** ISO 4217 currency code */
    currency: UserEnteredText;
};
export type FieldValueFileEntry = {
    /** File attachment identifier */
    id: UserEnteredText;
    /** Filename of the attachment */
    name: UserEnteredText;
    /** File extension */
    file_type: UserEnteredText;
};
export type UpstreamResourceId = string;
export type UpstreamPrefillText = string;
export type FieldValueReferenceEntry = {
    /** Workday resource identifier (WID) */
    resource_id: UpstreamResourceId;
    /** Human-readable display name for the reference */
    default_value: UpstreamPrefillText;
};
export type FieldValueDurationEntry = {
    /** Positive integer count of periods */
    amount: number;
    /** Calendar unit for the duration */
    period: "day" | "week" | "month" | "quarter" | "year";
};
export type FieldValueAddressEntry = {
    /** Street-level address lines; at least one is required */
    address_lines: UserEnteredText[];
    /** City or locality */
    locality?: UserEnteredText | null;
    /** State, province, or region */
    administrative_area?: UserEnteredText | null;
    /** Postal or ZIP code */
    postal_code?: UserEnteredText | null;
    /** Country or region code */
    country?: UserEnteredText | null;
};
export type SafeUrlText = string;
export type FieldValueUrlEntry = {
    /** The URL string; only the http, https, mailto and tel schemes are accepted */
    value: SafeUrlText;
    /** Optional display text for the URL */
    label?: UserEnteredText | null;
};
export type FieldValueEntry = FieldValueScalarEntry | FieldValueMonetaryEntry | FieldValueFileEntry | FieldValueReferenceEntry | FieldValueDurationEntry | FieldValueAddressEntry | FieldValueUrlEntry;
export type FieldUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** New field value as a uniform array of entries (e.g. [{"value": "english"}]); an empty array clears the field. */
    value: FieldValueEntry[];
};
export type FieldUpdateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "fields";
    /** The resource's attributes. */
    attributes: FieldUpdateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type FieldUpdateRequest = {
    /** The primary resource object of the request. */
    data: FieldUpdateRequestData;
};
export type FieldBatchUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Map of field updates keyed by Unified Fields field_id (UUID). Each value is a uniform array of entries; an empty array clears the field. */
    updates: {
        [key: string]: FieldValueEntry[];
    };
};
export type FieldBatchUpdateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "fields";
    /** The resource's attributes. */
    attributes: FieldBatchUpdateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type FieldBatchUpdateRequest = {
    /** The primary resource object of the request. */
    data: FieldBatchUpdateRequestData;
};
export type CommentAttributes = {
    /** User ID who authored the comment */
    author_id: string;
    /** Comment body text */
    content: string;
    /** User IDs mentioned in this comment */
    mentions: string[];
    /** Task ID this comment is attached to; null for ticket-level comments */
    task_id: string | null;
    /** Parent comment ID; null for top-level comments */
    parent_id: string | null;
    /** When the comment was created */
    created_at: string | null;
    /** When the comment was last edited; null if never edited */
    updated_at: string | null;
    /** When the comment thread was resolved; null if still open */
    resolved_at: string | null;
};
export type CommentResponseData = {
    /** JSON:API resource type. */
    type?: "comments";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: CommentAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type CommentResponse = {
    /** The primary resource object. */
    data: CommentResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type CreateCommentAttributes = {
    /** Comment body text (HTML tags are rejected) */
    content: string;
    /** Task ID to attach this comment to; null for ticket-level comments */
    task_id?: string | null;
    /** Parent comment ID for threading; null for top-level comments */
    parent_id?: UuidStr | null;
    /** User IDs mentioned in the comment (rendered as @-mentions in the UI) */
    mentions?: string[];
};
export type CreateCommentRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "comments";
    /** The resource's attributes. */
    attributes: CreateCommentAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CreateCommentRequest = {
    /** The primary resource object of the request. */
    data: CreateCommentRequestData;
};
export type ListCommentsResponse = {
    /** The primary resource objects, in response order. */
    data: CommentResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ThreadAttributes = {
    /** User ID who authored the root comment */
    author_id: string;
    /** Root comment body text */
    content: string;
    /** User IDs mentioned in the root comment */
    mentions: string[];
    /** Task ID this thread is attached to; null for ticket-level threads */
    task_id: string | null;
    /** When the root comment was created */
    created_at: string | null;
    /** When the root comment was last edited; null if never edited */
    updated_at: string | null;
    /** When the thread was resolved; null if still open */
    resolved_at: string | null;
    /** Direct replies to this comment, ordered by created_at ascending. Each reply is a full resource object (with its own id) so clients can target it for edit/delete. */
    replies: CommentResponseData[];
};
export type ThreadResponseData = {
    /** JSON:API resource type. */
    type?: "comment-threads";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ThreadAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListThreadsResponse = {
    /** The primary resource objects, in response order. */
    data: ThreadResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type UpdateCommentAttributes = {
    /** Updated comment body text (HTML tags are rejected) */
    content: string;
    /** Updated list of mentioned user IDs; replaces the previous mentions list */
    mentions?: string[];
};
export type UpdateCommentRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "comments";
    /** The resource's attributes. */
    attributes: UpdateCommentAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateCommentRequest = {
    /** The primary resource object of the request. */
    data: UpdateCommentRequestData;
};
export type DocumentRetryGenerationResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Unique identifier for this document */
    document_id: string;
    /** Ticket version after the operation */
    version: number;
    /** True once generation has been re-queued; stays true until fill completes or fails. */
    generation_pending: boolean;
};
export type DocumentRetryGenerationResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentRetryGenerationResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentRetryGenerationResponse = {
    /** The primary resource object. */
    data: DocumentRetryGenerationResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentForceUnlockResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Unique identifier for this document */
    document_id: string;
    /** Ticket version after the operation */
    version: number;
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
    /** Lock metadata after the operation (defaults when unlocked) */
    locking_metadata: DocumentLockingMetadataSchema;
};
export type DocumentForceUnlockResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentForceUnlockResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentForceUnlockResponse = {
    /** The primary resource object. */
    data: DocumentForceUnlockResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentForceUnlockRequestAttributes = {
    /** Expected ticket version for optimistic locking. Optional when a per-document lock token is supplied; at least one of the two is required to unlock. */
    version?: VersionInt | null;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    document_lock_version?: number | null;
};
export type DocumentForceUnlockRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "documents";
    /** The resource's attributes. */
    attributes: DocumentForceUnlockRequestAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type DocumentForceUnlockRequest = {
    /** The primary resource object of the request. */
    data: DocumentForceUnlockRequestData;
};
export type DocumentVersionUpResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Unique identifier for this document */
    document_id: string;
    /** Ticket version after the operation (unchanged by document writes) */
    version: number;
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
};
export type DocumentVersionUpResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentVersionUpResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentVersionUpResponse = {
    /** The primary resource object. */
    data: DocumentVersionUpResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentVersionUpAttributes = {
    /** Current ticket version for optimistic locking */
    version: VersionInt;
    /** Per-document optimistic-concurrency token. Rejected with 409 when it no longer matches the document's current document_lock_version. */
    document_lock_version: number;
    /** If true, record a turn handoff to `turn_to_party` atomically with this version-up. */
    record_turn_handoff?: boolean;
    /** Required when `record_turn_handoff` is true. */
    turn_to_party?: ("internal" | "counter") | null;
};
export type DocumentVersionUpRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "documents";
    /** The resource's attributes. */
    attributes: DocumentVersionUpAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type DocumentVersionUpRequest = {
    /** The primary resource object of the request. */
    data: DocumentVersionUpRequestData;
};
export type DocumentPatchResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** ID of the patched document */
    document_id: string;
    /** Ticket version after the patch */
    version: number;
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
    /** Paper source after the patch: first_party or third_party. */
    paper_type: PaperType;
};
export type DocumentPatchResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentPatchResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentPatchResponse = {
    /** The primary resource object. */
    data: DocumentPatchResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentPatchAttributes = {
    /** Current ticket version for optimistic locking */
    version: VersionInt;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    document_lock_version?: number | null;
    /** Target document type. Must be ATTACHMENT or one of the signable main types (CONTRACT, EXHIBIT, REDLINE, NDA). TEMPLATE is not assignable here. */
    document_type?: DocumentType | null;
    /** New display filename (max 256 chars; a forward slash '/' is not allowed). */
    name?: string | null;
    /** Corrected paper source — whether this is the originator's paper (first_party) or the counterparty's paper (third_party). Omit to leave the current paper source unchanged. A template-generated document cannot be made third_party. */
    paper_type?: PaperType | null;
};
export type DocumentPatchRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "documents";
    /** The resource's attributes. */
    attributes: DocumentPatchAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type DocumentPatchRequest = {
    /** The primary resource object of the request. */
    data: DocumentPatchRequestData;
};
export type RecordShareResponseAttributes = {
    /** Number of distinct recipients recorded on the audit entry. */
    recipients_count: number;
};
export type RecordShareResponseData = {
    /** JSON:API resource type. */
    type?: "record-share";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: RecordShareResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type RecordShareResponse = {
    /** The primary resource object. */
    data: RecordShareResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type SharePlatform = "salesforce" | "evisort";
export type RecordShareAttributes = {
    /** Email addresses the document was shared with on the foreign platform. At least one required. Recorded only -- no mail is sent to them. */
    recipients: string[];
    /** Version number of the document that was shared. Must exist on the document. */
    document_version: number;
    /** When the share happened on the foreign platform. Must include a UTC offset (e.g. trailing 'Z') -- a naive timestamp is rejected, not assumed UTC -- and may not be more than 5 minutes ahead of the server clock, a window that absorbs skew on the reporting platform's side. Normalized to UTC. Recorded alongside the entry; the activity-log row's own timestamp remains the time K2 recorded it. */
    shared_at: string;
    /** Foreign platform the share happened on. Omitted when the caller does not report one -- an audit entry must not invent a source. */
    platform?: SharePlatform | null;
};
export type RecordShareRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "record-share";
    /** The resource's attributes. */
    attributes: RecordShareAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type RecordShareRequest = {
    /** The primary resource object of the request. */
    data: RecordShareRequestData;
};
export type CurrentTurn = {
    /** ID of the currently open turn_intervals row */
    turn_interval_id: string;
    /** Which party currently holds the ball */
    party: "internal" | "counter";
    /** Elapsed seconds on this turn, computed against `as_of` */
    duration_seconds: number;
};
export type CycleTimeSummary = {
    /** Whole-ticket wall-clock elapsed time (against `as_of`) */
    total_seconds: number;
    /** Whole-ticket seconds attributed to Internal */
    internal_seconds: number;
    /** Whole-ticket seconds attributed to Counterparty */
    counter_seconds: number;
    /** Whole-ticket seconds while the request was paused */
    paused_seconds: number;
    /** Count of distinct turn_number values among non-paused turn_intervals rows */
    turn_count: number;
};
export type PartySplit = {
    /** Seconds attributed to Internal within the window */
    internal_seconds: number;
    /** Seconds attributed to Counterparty within the window */
    counter_seconds: number;
};
export type AssigneeSeconds = {
    /** Internal user ID; omitted/null for the Counterparty row */
    user_id?: string | null;
    /** Display name — the assignee's name, or 'Counterparty' */
    name: string;
    /** Whether this row is an internal assignee or Counterparty */
    role: "internal" | "counter";
    /** Seconds attributed to this assignee/party within the enclosing bucket */
    seconds: number;
};
export type PhaseBreakdown = {
    /** ID of the phase's task group in the workflow definition */
    phase_id: string;
    /** Phase name */
    name: string;
    /** Phase's wall-clock elapsed time */
    total_seconds: number;
    /** Phase time split between Internal and Counterparty */
    party_split: PartySplit;
    /** Not a component of party_split and not expected to sum with it or with total_seconds. */
    pending_assignment_seconds?: number;
    /** Per-assignee time within the phase */
    assignees?: AssigneeSeconds[];
};
export type OtherBucket = {
    /** Seconds in this stage outside any phase */
    total_seconds: number;
    /** Per-assignee time within this bucket */
    assignees?: AssigneeSeconds[];
};
export type StageBreakdown = {
    /** Stage ID from the workflow definition */
    stage_id: string;
    /** Stage name */
    name: string;
    /** 'active' stages are included here (not in `upcoming`) and are computed live against `as_of`, same as a completed stage */
    status: "pending" | "active" | "completed";
    /** Count of activation windows beyond the first, excluding skips */
    reopened_count: number;
    /** Stage's wall-clock elapsed time */
    total_seconds: number;
    /** Stage time split between Internal and Counterparty */
    party_split: PartySplit;
    /** Per-phase breakdown; empty when the caller cannot view the stage */
    phases?: PhaseBreakdown[];
    /** Time outside any phase; null when the caller cannot view the stage */
    other_bucket?: OtherBucket | null;
};
export type UpcomingStage = {
    /** Stage ID from the workflow definition */
    stage_id: string;
    /** Stage name */
    name: string;
    /** Always `pending` */
    status?: "pending";
};
export type CycleTimeAttributes = {
    /** The single instant every value in this payload was computed against */
    as_of: string;
    /** Null for a ticket with no turns yet */
    current_turn?: CurrentTurn | null;
    /** Whole-ticket totals */
    summary: CycleTimeSummary;
    /** Active and completed stages */
    stages?: StageBreakdown[];
    /** Stages that have not started yet */
    upcoming?: UpcomingStage[];
};
export type CycleTimeResponseData = {
    /** JSON:API resource type. */
    type: string;
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: CycleTimeAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type CycleTimeResponse = {
    /** The primary resource object. */
    data: CycleTimeResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type TurnTimelineEntryAttributes = {
    /** `turn` for a party's turn; `paused` for a span while the request was paused */
    entry_type: "turn" | "paused";
    /** Omitted/null would be unusual — paused rows still carry the carried-forward number */
    turn_number?: number | null;
    /** Null for a `paused` entry */
    party?: ("internal" | "counter") | null;
    /** When this segment started */
    started_at: string;
    /** Null for the currently open segment */
    ended_at?: string | null;
    /** True only for the ticket's single open segment */
    is_current?: boolean | null;
    /** Whether this segment's start time may be edited */
    is_start_editable: boolean;
    /** Whether this segment's end time may be edited */
    is_end_editable: boolean;
    /** Convenience for closed entries only; FE computes the open one live */
    duration_seconds?: number | null;
};
export type TurnTimelineEntryResponseData = {
    /** JSON:API resource type. */
    type: string;
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TurnTimelineEntryAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListTurnsMeta = {
    /** Turn-groups requested per page (unchanged by this ticket) */
    perPage: number;
    /** Opaque cursor to pass back as `next_token` to fetch the next page; null once `hasMore` is false */
    nextToken?: string | null;
    /** True if another page of turn-groups exists beyond this one */
    hasMore: boolean;
};
export type ListTurnsResponse = {
    /** The primary resource objects, in response order. */
    data: TurnTimelineEntryResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta: ListTurnsMeta;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type CreateTurnResponse = {
    /** The primary resource object. */
    data: TurnTimelineEntryResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type CreateTurnAttributes = {
    /** Optimistic lock — the ticket's current version */
    version: VersionInt;
    /** Defaults to the opposite of the current party */
    to_party?: ("internal" | "counter") | null;
    /** Defaults to now(); must be strictly after the current turn's start and not in the future. Must include a UTC offset (e.g. trailing 'Z') -- a naive timestamp is rejected, not assumed UTC. */
    occurred_at?: string | null;
    /** Defaults to 'manual'. `system` is not accepted here -- reserved for the ticket-creation seed. */
    source?: ("manual" | "task_claim_prompt" | "task_complete_prompt" | "document_upload") | null;
    /** Free-form provenance for non-manual sources (e.g. `{documents: [...]}` for document_upload). Bounded to 4096 bytes serialized -- every later read of this ticket's turn history selects this column for every row. */
    source_meta?: {
        [key: string]: any;
    } | null;
};
export type CreateTurnRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: string;
    /** The resource's attributes. */
    attributes: CreateTurnAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CreateTurnRequest = {
    /** The primary resource object of the request. */
    data: CreateTurnRequestData;
};
export type UpdateTurnAttributes = {
    /** Optimistic lock */
    version: VersionInt;
    /** Moves this turn's end (= the next segment's start); rejected if this turn is still open. Must include a UTC offset (e.g. trailing 'Z') -- a naive timestamp is rejected, not assumed UTC. */
    ended_at: string;
};
export type UpdateTurnRequestData = {
    /** JSON:API resource type (`turns`) */
    type: string;
    /** The turn's ID; the server acts on `turn_id` from the URL path */
    id: string;
    /** The new end time and the ticket version */
    attributes: UpdateTurnAttributes;
};
export type UpdateTurnRequest = {
    /** The primary resource object of the request. */
    data: UpdateTurnRequestData;
};
export type DocumentSignerSchema = {
    /** Participant assigned to this slot; null for a template-discovered slot not yet assigned. */
    participant_id: string | null;
    /** Stable label for a signing position in the document. */
    signing_slot: number;
    /** Backend-managed anchor tag data for the slot; opaque to clients. */
    anchor_tag_values?: {
        [key: string]: any;
    };
    /** When the signature was recorded in the manual signing flow; null until then. */
    signed_at?: string | null;
};
export type RecordSignaturesResponseAttributes = {
    /** Updated ticket version after recording. */
    version: number;
    /** Document whose signatures were recorded. */
    document_id: string;
    /** The document's signer slots after recording. */
    signers: DocumentSignerSchema[];
};
export type RecordSignaturesResponseData = {
    /** JSON:API resource type. */
    type?: "sign-tasks";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: RecordSignaturesResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type RecordSignaturesResponse = {
    /** The primary resource object. */
    data: RecordSignaturesResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type SignedParticipantItem = {
    /** ID of a participant in the sign task's signing configuration. */
    participant_id: string;
};
export type SigningParticipantWriteSchema = {
    /** Stable participant identifier (client-generated UUID); referenced by document signer slots. */
    participant_id: string;
    /** Participant name; null for a placeholder whose identity is not yet collected. */
    name?: string | null;
    /** Participant email; null for a placeholder. ``pilot_user_id`` is resolved from it server-side. */
    email?: string | null;
    /** Global signing order across all documents; must be unique within the list. */
    order: number;
    /** Ignored on input; resolved server-side from ``email``. */
    pilot_user_id?: number | null;
    /** Values for wildcard template fields, keyed by field name; keys must be among the participant's ``optional_field_names``. */
    field_values?: {
        [key: string]: string;
    };
    /** UI display label (e.g. "Buyer"); never injected into documents or the e-sign package. */
    label?: string | null;
    /** Signer party; UI metadata only. */
    party?: ("N/A" | "Internal" | "External") | null;
};
export type DocumentSignerWriteSchema = {
    /** Participant assigned to this slot; must appear in ``participants``. */
    participant_id: string;
    /** Stable label for a signing position in the document — slot 1 is always slot 1 regardless of who is assigned. */
    signing_slot?: number;
};
export type RecordSignaturesAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** ID of the document whose signers are being recorded */
    document_id: string;
    /** Participants whose signed_at timestamp should be set for this document */
    signed_participants: SignedParticipantItem[];
    /** Optional full replace of the signer-collection participant registry. Must be supplied together with document_assignments. Same full-replace payload rules as PUT /tickets/{id}/signing-participants/{task_id}; does not require the signer-collection task to be open (resolved via this sign task). */
    participants?: SigningParticipantWriteSchema[] | null;
    /** Optional full replace of per-document signer slot assignments. Must be supplied together with participants. */
    document_assignments?: {
        [key: string]: DocumentSignerWriteSchema[];
    } | null;
};
export type RecordSignaturesRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "sign-tasks";
    /** The resource's attributes. */
    attributes: RecordSignaturesAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type RecordSignaturesRequest = {
    /** The primary resource object of the request. */
    data: RecordSignaturesRequestData;
};
export type DocumentSignaturesResult = {
    /** Document whose signatures were recorded. */
    document_id: string;
    /** The document's signer slots after recording. */
    signers: DocumentSignerSchema[];
};
export type RecordSignaturesBatchResponseAttributes = {
    /** Updated ticket version after recording. */
    version: number;
    /** One result per document in the request. */
    documents: DocumentSignaturesResult[];
};
export type RecordSignaturesBatchResponseData = {
    /** JSON:API resource type. */
    type?: "sign-tasks";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: RecordSignaturesBatchResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type RecordSignaturesBatchResponse = {
    /** The primary resource object. */
    data: RecordSignaturesBatchResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentSignatureItem = {
    /** ID of the document whose signers are being recorded */
    document_id: string;
    /** Participants whose signed_at timestamp should be set for this document */
    signed_participants: SignedParticipantItem[];
};
export type RecordSignaturesBatchAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Documents and their signed participants to record in a single atomic operation */
    documents: DocumentSignatureItem[];
    /** Optional full replace of the signer-collection participant registry. Must be supplied together with document_assignments. Same full-replace payload rules as PUT /tickets/{id}/signing-participants/{task_id}; does not require the signer-collection task to be open (resolved via this sign task). */
    participants?: SigningParticipantWriteSchema[] | null;
    /** Optional full replace of per-document signer slot assignments. Must be supplied together with participants. */
    document_assignments?: {
        [key: string]: DocumentSignerWriteSchema[];
    } | null;
};
export type RecordSignaturesBatchRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "sign-tasks";
    /** The resource's attributes. */
    attributes: RecordSignaturesBatchAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type RecordSignaturesBatchRequest = {
    /** The primary resource object of the request. */
    data: RecordSignaturesBatchRequestData;
};
export type SigningParticipantSchema = {
    /** Stable participant identifier (client-generated UUID); referenced by document signer slots. */
    participant_id: string;
    /** Participant name; null for a placeholder whose identity is not yet collected. */
    name?: string | null;
    /** Participant email; null for a placeholder whose identity is not yet collected. */
    email?: string | null;
    /** Global signing order across all documents; unique within the sign task. */
    order: number;
    /** Server-resolved from Rolodex by email. On GET, this may briefly be a last-persisted value rather than a freshly-verified one if Rolodex was unreachable at read time — the request still succeeds rather than failing the page load, since nothing is written on a read. */
    pilot_user_id?: number | null;
    /** Values for the participant's wildcard template fields, keyed by field name. */
    field_values?: {
        [key: string]: string;
    };
    /** Server-computed names of the optional template fields across this participant's document slots. */
    optional_field_names?: string[];
    /** UI display label (e.g. "Buyer"); never injected into documents or the e-sign package. */
    label?: string | null;
    /** Signer party; UI metadata only. */
    party?: ("N/A" | "Internal" | "External") | null;
};
export type SigningConfigurationResponseAttributes = {
    /** Current ticket version. */
    version: number;
    /** The sign task's signing participant registry. */
    participants: SigningParticipantSchema[];
    /** Per-document signer slots, keyed by document_id. */
    document_assignments: {
        [key: string]: DocumentSignerSchema[];
    };
    /** Orders currently reserved by a DefaultSigner whose visible_condition evaluates false. These participants and document slots are still included in full in participants and document_assignments -- disabling is a visibility toggle, not a delete -- but a client should treat them as non-editable/hidden, and must also avoid these orders when picking one for a new manually-added recipient, to prevent silently colliding with a signer that is only temporarily hidden. */
    disabled_orders?: number[];
};
export type SigningConfigurationResponseData = {
    /** JSON:API resource type. */
    type?: "signing-participants";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: SigningConfigurationResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type SigningConfigurationResponse = {
    /** The primary resource object. */
    data: SigningConfigurationResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type SigningConfigurationAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Full replacement participant registry; participants omitted here are removed. */
    participants: SigningParticipantWriteSchema[];
    /** Map of document_id to ordered list of slot assignments for that document. */
    document_assignments?: {
        [key: string]: DocumentSignerWriteSchema[];
    };
};
export type SigningConfigurationRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "signing-participants";
    /** The resource's attributes. */
    attributes: SigningConfigurationAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type SigningConfigurationRequest = {
    /** The primary resource object of the request. */
    data: SigningConfigurationRequestData;
};
export type CreateEsignPackageAcceptedAttributes = {
    /** Sign task id for this enqueue. */
    task_id: string;
};
export type CreateEsignPackageAcceptedResponseData = {
    /** JSON:API resource type. */
    type?: "esign-packages";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: CreateEsignPackageAcceptedAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type CreateEsignPackageAcceptedResponse = {
    /** The primary resource object. */
    data: CreateEsignPackageAcceptedResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type EsignVendor = "DOCUSIGN" | "ADOBESIGN" | "DOCUSIGN_DEMO";
export type CreateEsignPackageAttributes = {
    /** Sign task id on the current stage (must depend on exactly one signer-collection task). */
    task_id: string;
    /** URL where the vendor redirects the user after completing the signing ceremony. */
    return_url: string;
    /** Ignored. Esign resolves the vendor from the client's selected integration. Accepted when present so existing clients keep working; new callers may omit it. */
    vendor?: EsignVendor | null;
    /** Package name; defaults to the ticket name if omitted. */
    package_name?: string | null;
};
export type CreateEsignPackageRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "esign-packages";
    /** The resource's attributes. */
    attributes: CreateEsignPackageAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CreateEsignPackageRequest = {
    /** The primary resource object of the request. */
    data: CreateEsignPackageRequestData;
};
export type ActionInvoke = {
    /** HTTP method of the route that performs this action. */
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    /** Path of the route that performs this action, e.g. /tickets/{id}/tasks/{task_id}/complete. */
    path: string;
};
export type ActionEntry = {
    /** Action identifier. For task_lifecycle this is the workflow action_id accepted verbatim by the complete route as the action_id body field. */
    id: string;
    /** The kind of action, grouping it by the surface it acts on. */
    kind: "ticket_lifecycle" | "task_lifecycle" | "task_assignment" | "sign_operation" | "document_operation" | "field_operation" | "metadata_operation" | "comment_operation" | "stage_lifecycle" | "turn_operation";
    /** True iff the action can be performed now (blocked_reason is null). */
    available: boolean;
    /** Why the action is unavailable; null iff available is true. */
    blocked_reason?: BlockedReason | null;
    /** Non-blocking advisory when the action is available (e.g. side-effect warning). Null when unavailable or when no advisory applies. */
    notice?: BlockedReason | null;
    /** The HTTP method and path used to perform this action. Required whenever a K2 route performs the action; null only when no such route exists (e.g. edit_document, where Scribyl — not K2 — opens and holds the collaborative-edit session). */
    invoke?: ActionInvoke | null;
    /** Display label for renderable workflow actions (task_lifecycle only). */
    label?: string | null;
    /** Visual intent for renderable workflow actions (task_lifecycle only); matches JudgmentIntent. */
    intent?: ("positive" | "negative") | null;
};
export type TicketActionsNodeTicket = {
    /** Ticket-level actions: lifecycle (pause/resume/cancel/complete), add_document, update_fields, and rename. */
    actions: ActionEntry[];
    /** True iff the caller may comment on the ticket (SpiceDB `comment` permission; editor/owner imply comment). */
    can_comment?: boolean;
    /** ACL tiers the caller may grant on this ticket via the ACL endpoint (tiered delegation), resolved from the schema's `can_grant_viewer`/`can_grant_commenter`/`can_grant_editor`: a tier is listed when the caller holds that tier's grant right, and holding the tier's other permissions is neither required nor sufficient. A viewer may grant `viewer`, a commenter `viewer`+`commenter` and an editor all three, so the tiers are cumulative for tier grantees; a custom permission set is resolved right by right and may produce any subset, including a non-contiguous one. Treat this as an opaque set rather than a ladder. Owner is never grantable here (set via owner-reassignment). */
    grantable_acl_tiers?: AclPermission[];
    /** Atom-level capabilities the caller currently holds on this ticket, resolved from the same bulk permission round trip as `can_comment`/`grantable_acl_tiers` (no extra SpiceDB cost). Limited to the atoms `/actions` already tracks (`ACTIONS_ATOMS` — the Tier-2 cutover subset, not the full `Atom` vocabulary): view/comment-band atoms not in that subset are answered instead by `can_comment` and the coarse `view` action gate, and `grant_*` atoms by `grantable_acl_tiers`. This is what lets a UI render 'download but not edit', and what a custom-policy picker prices an atom set against (spec 019) — the tier alone cannot express a non-contiguous custom grant. */
    granted_atoms?: Atom[];
    /** Union of every atom conferred by a tier in `grantable_acl_tiers` (the tier→atom matrix, spec 019 `:230`), so a custom-policy picker can price a bundle without a second read endpoint publishing the matrix separately. Empty whenever `grantable_acl_tiers` is empty (including the frozen-ACL/draft case). */
    grantable_atoms?: Atom[];
};
export type AssigneeActionMetadata = {
    /** Internal user ID; null for external users. */
    user_id?: string | null;
    /** External user ID; null for internal users. */
    external_user_id?: string | null;
    /** True iff this assignee's slot can be reassigned via PATCH /assign. */
    can_assign: boolean;
    /** True iff this assignee has a recorded judgment that can be cleared. */
    can_reset: boolean;
};
export type TaskActionsNode = {
    /** The task's type (review, sign, signer-collection, form, task_group). */
    task_type: string;
    /** True iff the caller's user id is among the task's assignees. Assignment gates the task's approve/reject JUDGMENT (the `complete` action) ONLY for a task that has actors configured OR current assignees: any caller who is not an assignee of such a task -- a Full Admin included -- sees the judgment as unavailable (`blocked_reason=not_assignee`) and `POST /complete` returns 403 (EKP-56581). A task authored with NO actors and no current assignees (e.g. Sign, Signer-Collection, or a Form left unassigned) is exempt from this gate -- any caller with edit may execute its judgment -- until someone assigns it (EKP-57022). Assignment does not affect the other task actions (assign/claim/reset), which remain gated on edit only. */
    assigned_to_caller: boolean;
    /** True iff the caller may add or change assignees on this task. False when the task is in a terminal status (completed/approved/rejected), the ticket is not active, or the caller lacks edit permission. Derived from the availability of the 'reassign' action. */
    can_assign: boolean;
    /** True iff the caller may execute a judgment on this task AND at least one workflow judgment action (approve/reject/sign/etc.) is currently available. 'May execute' means the caller is an assignee of an assignable task -- assignment is required and is NOT bypassed for Full Admins (EKP-56581) -- OR the task has neither actors configured nor current assignees (EKP-57022). Meta-operations like 'reset' and 'claim' are excluded. Use this to gate the 'execute action' UI affordance. */
    can_execute_action: boolean;
    /** Actions available on this task (keyed list, not a map). */
    actions: ActionEntry[];
    /** Per-assignee action metadata. One entry per internal or external assignee. */
    assignee_metadata?: AssigneeActionMetadata[];
};
export type DocumentActionsNode = {
    /** The document's type (e.g. CONTRACT, ATTACHMENT, NDA). */
    document_type: string;
    /** Whether this document's type is in the K2 signable allowlist (contract, exhibit, redline, nda). Sourced from the backend allowlist so callers do not infer signability from document type. */
    is_signable: boolean;
    /** Why the document is not signable; null iff is_signable is true. */
    not_signable_reason?: BlockedReason | null;
    /** Why the async field_regen planner would skip this document if it ran now; null when GENERATED and eligible for field regen. Regen-owned PENDING (generation_pending=true) is null — field_regen SUPERSEDEs it (EKP-57354). Signing-config replace still rejects PENDING via check_signing_regen_eligible, not this field. Also reflects an active signing package (ticket-wide) or a per-document skip (manually replaced/UPLOADED, collaborative lock, SIGNED, or orphaned PENDING). */
    regen_skip_reason?: BlockedReason | null;
    /** Document operations: upload_new_version, version_up, rename_document, change_document_type, delete_document, retry_generation, force_unlock, edit_document, and share. */
    actions: ActionEntry[];
};
export type StageActionsNode = {
    /** Current stage status (pending, active, completed, skipped). */
    status: StageStatus;
    /** Whether this is the ticket's currently active stage. */
    is_current: boolean;
    /** Zero-indexed position among the included stages (visible plus backward-reachable). */
    order: number;
    /** Stage operations: complete_stage, reset_stage, transition_to_stage, and add_task (each emitted only when applicable to this stage's status/position). */
    actions: ActionEntry[];
};
export type CommentActionsNode = {
    /** Task scope when the comment is task-scoped; null for ticket-level comments. */
    task_id?: string | null;
    /** True when the comment is a root thread (parent_id is null). */
    is_root: boolean;
    /** Per-comment operations: edit_comment, delete_comment, reply_comment, resolve_comment, and unresolve_comment. */
    actions: ActionEntry[];
};
export type NodeAclActions = {
    /** True iff the caller may view this node. */
    can_view: boolean;
    /** True iff the caller may comment on this node. */
    can_comment: boolean;
    /** True iff the caller may edit this node. */
    can_edit: boolean;
    /** ACL tiers the caller may grant on this node — the same `can_grant_*` question the ticket answers, asked of the node's own SpiceDB object: a tier is listed when the caller holds that tier's grant right ON THIS NODE (inherited from the parent ticket/stage if not granted directly). Like the ticket-level set, treat it as an opaque set rather than a ladder. */
    grantable_acl_tiers?: AclPermission[];
    /** Task-family atoms (`TASK_ATOMS`) the caller holds on THIS node, plus `task_view`/`task_comment` mirroring `can_view`/`can_comment` above. Doc-family and ticket-family atoms are not node-scoped for this shape (see `can_view`/`can_comment`/`can_edit`). Always `[]` for a document entry in `node_permissions` -- documents have no task-family atoms and are reported under `documents` instead. Same ticket-level twin as `TicketActionsNodeTicket.granted_atoms`; see that field for why the set is bounded to `ACTIONS_ATOMS` rather than the full vocabulary. */
    granted_atoms?: Atom[];
    /** Union of every atom conferred by a tier in this node's own `grantable_acl_tiers`. Always `[]` for a document entry, same reason as `granted_atoms`. Ticket-level twin: `TicketActionsNodeTicket.grantable_atoms`. */
    grantable_atoms?: Atom[];
};
export type NegotiationStatus = "not_started" | "in_progress" | "retracted" | "new_doc_version" | "accepted" | "failed";
export type TicketIntegrationSchema = {
    /** Configured ticket integration type */
    integration_type: IntegrationType;
    /** Workflow-side reference identifier */
    wss_reference_id?: string | null;
    /** External contract record identifier */
    contract_record_unique_id?: string | null;
    /** Amendment chain root CRUID. Equals contract_record_unique_id for non-amendments. */
    contract_record_unique_id_original?: string | null;
    /** Negotiation lifecycle status of the ticket's out-for-signature document. Defaults to not_started from creation. */
    negotiation_status?: NegotiationStatus;
};
export type TicketActionsAttributes = {
    /** Ticket-level action availability. */
    ticket: TicketActionsNodeTicket;
    /** Per-task action availability keyed by task_id (not an array); only visible tasks are included. */
    tasks: {
        [key: string]: TaskActionsNode;
    };
    /** Per-document action availability keyed by document_id (not an array). */
    documents: {
        [key: string]: DocumentActionsNode;
    };
    /** Per-stage action availability keyed by stage_id (not an array). Includes visible stages plus completed stages that remain backward-reachable for reopening. Stages the caller may not view (sub-resource ACL denial) are returned as redacted shells — structural status/is_current/order retained, no actions — mirroring the GET read-shape. */
    stages: {
        [key: string]: StageActionsNode;
    };
    /** Per-comment action availability keyed by comment_id (not an array). Includes only live (non-deleted) comments on visible, non-redacted tasks plus ticket-level comments. ``create_comment`` lives on the ticket/task nodes. */
    comments?: {
        [key: string]: CommentActionsNode;
    };
    /** Per-node sub-resource ACL capabilities keyed by stage_id/task_id (not an array). Contains ONLY ACL-controlled nodes; a node absent from this map is un-ACL'd and inherits the ticket-level capabilities (fall back to the ticket node, do not assume denial). {} when the ticket has no sub-resource grants. */
    node_permissions?: {
        [key: string]: NodeAclActions;
    };
    /** Integration metadata for workflows configured with an external integration. Mirrors GET /tickets/{id}'s integration block, including negotiation_status. */
    integration?: TicketIntegrationSchema | null;
};
export type TicketActionsResponseData = {
    /** JSON:API resource type. */
    type?: "ticket-actions";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketActionsAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type GetTicketActionsResponse = {
    /** The primary resource object. */
    data: TicketActionsResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type TicketMode = "live" | "sandbox";
export type TicketState = "DRAFT" | "ACTIVE" | "PAUSED" | "CANCELLED" | "COMPLETED";
export type TicketDocument = {
    /** Unique identifier for this document */
    document_id: string;
    /** Filename of the document */
    name: string;
    /** How the document was added (uploaded, generated, etc.) */
    source: DocumentSource;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the **head** (newest) version after the upload-timeout overlay. May be failed/pending while is_viewable is true when a prior READY version is shown. Default download stays blocked until the head is READY. */
    content_status: ContentStatus;
    /** Storage backend (pilot or muse) */
    storage: DocumentStorage;
    /** Current version number (increments on re-upload) */
    document_version?: number;
    /** Version the viewer treats as last-good (head when READY and pin-able, else the latest prior READY with a Pilot version pin). Null when nothing is viewable. Distinct from document_version (always the head). Default ORIGINAL download still requires the head to be READY. */
    served_document_version?: number | null;
    /** Per-document optimistic-concurrency token (distinct from document_version, the content re-upload counter). Optional on writes: when supplied on a document mutation it is enforced with a 409 on mismatch; omit it to fall back to ticket-version OCC. */
    document_lock_version?: number;
    /** Chronological list of all document versions with their metadata */
    version_history?: DocumentVersionMetaSchema[];
    /** Whether a browser-viewable rendering is available. Based on the **served** version (head when READY, else latest prior READY), not necessarily the head. True when that version is ready and either the format has a native viewer with a Pilot storage id (e.g. PDF + pilot_document_id) or its SFDT conversion is complete. May be true while content_status is failed/pending when a prior READY exists. Default download is still blocked in that case; pick a version. served_document_version is the last-good view slot, not the default ORIGINAL download. */
    is_viewable: boolean;
    /** Pilot-internal document identifier */
    pilot_document_id?: string | null;
    /** Pilot FileAttachment identifier. Set after a ticket-completion convert step transforms an ATTACHMENT-typed document into a Pilot FileAttachment. */
    pilot_attachment_id?: string | null;
    /** Pilot upload token. Present while the head is pending or failed so retry-processing can re-fire complete_upload server-side; cleared on ready. Clients should not treat this as a capability grant — retry requires doc_upload. */
    upload_id?: string | null;
    /** Template ID if document was generated from a template */
    template_id?: string | null;
    /** Original template document ID for generated documents */
    source_template_document_id?: string | null;
    /** E-signature lifecycle state */
    signing_status: SigningStatus;
    /** Signing slots of the document; empty when it is not signed. */
    signers?: DocumentSignerRecord[];
    /** When the document was generated from a template */
    generated_at?: string | null;
    /** Collaborative-edit lock metadata (Scribyl inbound S2S and future callers) */
    locking_metadata?: DocumentLockingMetadataSchema;
    /** Whether the document is the originator's paper (first_party) or the counterparty's paper (third_party). Set at attach; correctable afterwards via PATCH /tickets/{ticket_id}/documents/{document_id}. */
    paper_type?: PaperType;
    /** Whether a new version of this document can be uploaded. False when the document is signed (signing_status=SIGNED), has an upload in progress (content_status=PENDING), or is a read-only template (document_type=TEMPLATE). */
    is_able_to_upload_new_version: boolean;
    /** The workflow document slot this document fills; null for an ad-hoc document. */
    slot_id?: string | null;
};
export type RedactedAdHocTask = {
    /** Discriminator: 'redacted' — the caller may not view this ad-hoc task; contents are withheld. */
    visibility?: "redacted";
    /** Unique identifier for this ad-hoc task */
    task_id: string;
    /** Stage ID where this task was added */
    parent_stage_id: string;
    /** Parent task_group ID if this is a child task */
    parent_task_id?: string | null;
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
};
export type AdHocTask = {
    /** Discriminator: 'visible' — the caller may view this ad-hoc task's contents. */
    visibility?: "visible";
    /** Unique identifier for this ad-hoc task */
    task_id: string;
    /** Stage ID where this task was added */
    parent_stage_id: string;
    /** Parent task_group ID if this is a child task */
    parent_task_id?: string | null;
    /** Display name of the task */
    name: string;
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
    /** Internal user IDs assigned to this task */
    assigned_to?: string[];
    /** External user IDs assigned to this task */
    assigned_external_users?: string[];
    /** How the task is assigned to users */
    assignment_mode: AssignmentMode;
    /** Actions available for completing this task */
    allowed_actions?: TaskAction[];
    /** Task due date (informational, not enforced) */
    due_at?: string | null;
    /** Optional task description or instructions */
    description?: string | null;
    /** Number of approvals required. When null, all assignees must approve. */
    required_approvals?: number | null;
    /** GROUP_RANDOM only: number of users selected from the combined actor pool. */
    assignee_count?: number | null;
    /** When this ad-hoc task was created */
    added_at: string;
    /** User ID who created this ad-hoc task */
    added_by: string;
};
export type RedactedStageState = {
    /** Discriminator: 'redacted' — the caller may not view this stage; transition details withheld. */
    visibility?: "redacted";
    /** Current stage status (pending, active, completed, skipped) */
    status: StageStatus;
};
export type StageState = {
    /** Discriminator: 'visible' — the caller may view this stage's contents. */
    visibility?: "visible";
    /** Current stage status (pending, active, completed, skipped) */
    status: StageStatus;
    /** When the stage became active */
    entered_at?: string | null;
    /** When the stage was exited (completed or skipped) */
    exited_at?: string | null;
    /** User ID who triggered the stage transition */
    completed_by?: string | null;
};
export type RedactedTaskState = {
    /** Discriminator: 'redacted' — the caller may not view this task; contents withheld. */
    visibility?: "redacted";
    /** Current task status */
    status: TaskStatus;
};
export type TaskState = {
    /** Discriminator: 'visible' — the caller may view this task's contents. */
    visibility?: "visible";
    /** Current task status */
    status: TaskStatus;
    /** Internal user IDs assigned to this task */
    assigned_to?: string[];
    /** External user IDs assigned to this task */
    assigned_external_users?: string[];
    /** When the task transitioned to active */
    started_at?: string | null;
    /** Judgments recorded on this task */
    judgments?: JudgmentSchema[];
};
export type WorkflowEmbedAttributes = {
    /** Workflow name (frozen on the ticket at creation) */
    name: string;
    /** Workflow description */
    description?: string;
    /** Version of the workflow definition frozen on the ticket */
    version: number;
    /** The frozen workflow definition blueprint */
    workflow_definition: WorkflowDefinitionResponse;
};
export type WorkflowEmbedAttributesRead = {
    /** Workflow name (frozen on the ticket at creation) */
    name: string;
    /** Workflow description */
    description?: string;
    /** Version of the workflow definition frozen on the ticket */
    version: number;
    /** The frozen workflow definition blueprint */
    workflow_definition: WorkflowDefinitionResponseRead;
};
export type ContractFamilyActionType = "Renewal";
export type TicketContractFamilyAttributes = {
    /** Original Source Document.Id used for Renewal */
    source_document_id: string;
    /** The Pilot DocumentHandler.id the caller was viewing when this claim was made, if recorded. */
    source_document_handler_id?: string | null;
    /** 'Renewal' */
    type: ContractFamilyActionType;
};
export type TicketAttributes = {
    /** Ticket name */
    name: string;
    /** Ticket description */
    description?: string;
    /** Execution mode (live or sandbox) */
    mode: TicketMode;
    /** Current lifecycle state */
    state: TicketState;
    /** Stage ID of the currently active stage from the workflow definition */
    current_stage_id: string;
    /** Admin-defined, human-readable Request ID (Request ID Format), additive to the system ticket id. Null when the workflow's format is off, its template is invalid, or generation failed. */
    custom_request_id?: string | null;
    /** Zero-indexed position of current stage */
    current_stage_order?: number;
    /** Total number of stages in workflow */
    total_stages?: number;
    /** Whether current stage is ready to complete */
    is_ready_to_complete?: boolean;
    /** Number of open leaf tasks (excludes TASK_GROUP containers) */
    open_task_count?: number;
    /** ID of the workflow this ticket was created from */
    workflow_id: string;
    /** Version of the workflow definition used */
    workflow_version: number;
    /** Integration metadata for workflows configured with an external integration. */
    integration?: TicketIntegrationSchema | null;
    /** Absolute URL to this ticket's contract in the WSS portal. Null when the ticket has no WSS integration, has no contract record yet, or the portal address is unavailable — treat null as 'no link available', not an error. */
    wss_contract_url?: string | null;
    /** Optimistic locking version; incremented on every mutation */
    version: number;
    /** Map of field values keyed by field_id from the workflow definition. Included when ?include=field_values is specified. */
    field_values?: {
        [key: string]: FieldValueSchema;
    } | null;
    /** Attached documents. Included when ?include=documents is specified. */
    documents?: TicketDocument[] | null;
    /** User-created ad-hoc tasks. Included when ?include=ad_hoc_tasks is specified. Each entry is discriminated on `visibility`: `visible` carries full contents, `redacted` carries identity only (a sub-resource ACL denial). */
    ad_hoc_tasks?: (({
        visibility: "redacted";
    } & RedactedAdHocTask) | ({
        visibility: "visible";
    } & AdHocTask))[] | null;
    /** Access control for this ticket: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access), and `custom` (ad-hoc permission policies -- see `AclSettings`). Each tier value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. Included when ?include=acl is specified. Implicit principals are stored as placeholders (e.g. `field_users:<field_id>`) and echoed back unresolved. */
    acl?: AclSettings | null;
    /** Map of stage states keyed by stage_id from the workflow definition. Included when ?include=stage_states is specified. Each value is discriminated on `visibility`: `visible` carries status + transition details, `redacted` carries status only (a sub-resource ACL denial). */
    stage_states?: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedStageState) | ({
            visibility: "visible";
        } & StageState);
    } | null;
    /** Map of task states keyed by task_id from the workflow definition. Included when ?include=task_states is specified. Each value is discriminated on `visibility`: `visible` carries status + assignees + judgments, `redacted` carries status only (a sub-resource ACL denial). */
    task_states?: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedTaskState) | ({
            visibility: "visible";
        } & TaskState);
    } | null;
    /** E-sign authoring and package status (signer lists per signer-collection task, package status per sign task). Included when ?include=esign_state is specified. */
    esign_state?: {
        [key: string]: any;
    } | null;
    /** Embedded workflow blueprint. Populated only when ?include=workflow is specified (opt-in; not part of the default all-fields response). Lets a JWT ticket-authorized caller render the workflow without holding workflow.view. Omitted for inbound S2S and node-only grantees. */
    workflow?: WorkflowEmbedAttributes | null;
    /** Pending Contract Family claim, if it currently holds one. Null otherwise. */
    contract_family?: TicketContractFamilyAttributes | null;
    /** When the ticket transitioned to COMPLETED state; null until then. */
    completed_at?: string | null;
    /** When the ticket transitioned to CANCELLED state; null until then. */
    cancelled_at?: string | null;
    /** Reason provided when the ticket was cancelled; null until then. */
    cancellation_reason?: string | null;
    /** User ID of whoever cancelled the ticket; null until then. */
    cancelled_by?: string | null;
    /** User ID of the ticket owner (defaults to the creator on create) */
    owner_user_id: string;
    /** When the ticket was created */
    created_at: string;
    /** User ID who created the ticket */
    created_by: string;
    /** When the ticket was last updated */
    updated_at?: string | null;
    /** User ID who last updated the ticket */
    updated_by?: string | null;
};
export type TicketAttributesRead = {
    /** Ticket name */
    name: string;
    /** Ticket description */
    description?: string;
    /** Execution mode (live or sandbox) */
    mode: TicketMode;
    /** Current lifecycle state */
    state: TicketState;
    /** Stage ID of the currently active stage from the workflow definition */
    current_stage_id: string;
    /** Admin-defined, human-readable Request ID (Request ID Format), additive to the system ticket id. Null when the workflow's format is off, its template is invalid, or generation failed. */
    custom_request_id?: string | null;
    /** Zero-indexed position of current stage */
    current_stage_order?: number;
    /** Total number of stages in workflow */
    total_stages?: number;
    /** Whether current stage is ready to complete */
    is_ready_to_complete?: boolean;
    /** Number of open leaf tasks (excludes TASK_GROUP containers) */
    open_task_count?: number;
    /** ID of the workflow this ticket was created from */
    workflow_id: string;
    /** Version of the workflow definition used */
    workflow_version: number;
    /** Integration metadata for workflows configured with an external integration. */
    integration?: TicketIntegrationSchema | null;
    /** Absolute URL to this ticket's contract in the WSS portal. Null when the ticket has no WSS integration, has no contract record yet, or the portal address is unavailable — treat null as 'no link available', not an error. */
    wss_contract_url?: string | null;
    /** Optimistic locking version; incremented on every mutation */
    version: number;
    /** Map of field values keyed by field_id from the workflow definition. Included when ?include=field_values is specified. */
    field_values?: {
        [key: string]: FieldValueSchema;
    } | null;
    /** Attached documents. Included when ?include=documents is specified. */
    documents?: TicketDocument[] | null;
    /** User-created ad-hoc tasks. Included when ?include=ad_hoc_tasks is specified. Each entry is discriminated on `visibility`: `visible` carries full contents, `redacted` carries identity only (a sub-resource ACL denial). */
    ad_hoc_tasks?: (({
        visibility: "redacted";
    } & RedactedAdHocTask) | ({
        visibility: "visible";
    } & AdHocTask))[] | null;
    /** Access control for this ticket: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access), and `custom` (ad-hoc permission policies -- see `AclSettings`). Each tier value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. Included when ?include=acl is specified. Implicit principals are stored as placeholders (e.g. `field_users:<field_id>`) and echoed back unresolved. */
    acl?: AclSettingsRead | null;
    /** Map of stage states keyed by stage_id from the workflow definition. Included when ?include=stage_states is specified. Each value is discriminated on `visibility`: `visible` carries status + transition details, `redacted` carries status only (a sub-resource ACL denial). */
    stage_states?: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedStageState) | ({
            visibility: "visible";
        } & StageState);
    } | null;
    /** Map of task states keyed by task_id from the workflow definition. Included when ?include=task_states is specified. Each value is discriminated on `visibility`: `visible` carries status + assignees + judgments, `redacted` carries status only (a sub-resource ACL denial). */
    task_states?: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedTaskState) | ({
            visibility: "visible";
        } & TaskState);
    } | null;
    /** E-sign authoring and package status (signer lists per signer-collection task, package status per sign task). Included when ?include=esign_state is specified. */
    esign_state?: {
        [key: string]: any;
    } | null;
    /** Embedded workflow blueprint. Populated only when ?include=workflow is specified (opt-in; not part of the default all-fields response). Lets a JWT ticket-authorized caller render the workflow without holding workflow.view. Omitted for inbound S2S and node-only grantees. */
    workflow?: WorkflowEmbedAttributesRead | null;
    /** Pending Contract Family claim, if it currently holds one. Null otherwise. */
    contract_family?: TicketContractFamilyAttributes | null;
    /** When the ticket transitioned to COMPLETED state; null until then. */
    completed_at?: string | null;
    /** When the ticket transitioned to CANCELLED state; null until then. */
    cancelled_at?: string | null;
    /** Reason provided when the ticket was cancelled; null until then. */
    cancellation_reason?: string | null;
    /** User ID of whoever cancelled the ticket; null until then. */
    cancelled_by?: string | null;
    /** User ID of the ticket owner (defaults to the creator on create) */
    owner_user_id: string;
    /** When the ticket was created */
    created_at: string;
    /** User ID who created the ticket */
    created_by: string;
    /** When the ticket was last updated */
    updated_at?: string | null;
    /** User ID who last updated the ticket */
    updated_by?: string | null;
};
export type TicketResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type TicketResponseDataRead = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListTicketsResponse = {
    /** The primary resource objects, in response order. */
    data: TicketResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ListTicketsResponseRead = {
    /** The primary resource objects, in response order. */
    data: TicketResponseDataRead[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type TicketIncludeParam = "field_values" | "stage_states" | "task_states" | "documents" | "ad_hoc_tasks" | "acl" | "esign_state" | "workflow";
export type TicketCreateResponseAttributes = {
    /** Ticket name. Empty string on a draft created without one. */
    name: string;
    /** Ticket description */
    description?: string;
    /** Execution mode (live or sandbox) */
    mode: TicketMode;
    /** Initial lifecycle state: ACTIVE for the ordinary create, DRAFT when state 'DRAFT' was sent. */
    state: TicketState;
    /** Stage ID of the first active stage. Empty string on a draft — stage selection needs the final field values and happens at POST /tickets/{id}/submit. */
    current_stage_id: string;
    /** Admin-defined, human-readable Request ID (Request ID Format). Null when the workflow's format is off, its template is invalid, or generation failed. */
    custom_request_id?: string | null;
    /** ID of the workflow this ticket was created from */
    workflow_id: string;
    /** Version of the workflow definition used */
    workflow_version: number;
    /** Integration metadata for workflows configured with an external integration. */
    integration?: TicketIntegrationSchema | null;
    /** Initial optimistic locking version */
    version: number;
    /** When the ticket was created */
    created_at: string;
    /** User ID who created the ticket */
    created_by: string;
};
export type TicketCreateResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketCreateResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type CreateTicketResponse = {
    /** The primary resource object. */
    data: TicketCreateResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentSourceChoice = "template" | "upload" | "none";
export type ContractActionType = "renewal" | "amendment" | "termination" | "non-renewal";
export type TicketCreateAttributes = {
    /** Name for the new ticket */
    name: ResourceName;
    /** Pre-populated field values from the intake form, keyed by Unified Fields field_id (UUID). Each key is the same id as an intake-form question's `form_field.field_id` (the `id` of a `field_library` entry in the workflow definition). Each value is a uniform array of entries (e.g. [{"value": "english"}]); an empty array means no value. */
    initial_field_values?: {
        [key: string]: FieldValueEntry[];
    };
    /** DEPRECATED: use template_ids. Template selected by the requester when the intake form uses requester_choice generation. The ID must be present in the form's document_template_ids. */
    template_id?: string | null;
    /** Templates selected by the requester when the intake form uses requester_choice (or always) generation. Each ID must be present in the form's document_template_ids. Supersedes template_id, which remains supported as a single-element selection. */
    template_ids?: string[] | null;
    /** Requester's explicit template-vs-upload choice, for intake forms whose requester_choice generation mode presents both as a real binary choice (EKP-58403). 'upload' or 'none' skips initial document generation entirely, even when the form has configured templates and template_ids is omitted. Omitting this field (older/unmigrated FE flows) preserves the prior behavior of generating every configured template when no template_ids is given. */
    document_source_choice?: DocumentSourceChoice | null;
    /** Contract actions only: the source contract's canonical Pilot document id, as a whole number in string form (not its document-handler id). A renewal request additionally claims this contract's Contract Family slot. Omit for a normal create. */
    source_document_id?: string | null;
    /** Contract actions only: the action that produced this ticket (e.g. "renewal", "amendment", "termination", "non-renewal"). Recorded on the create activity metadata alongside source_document_id. Only "renewal" currently has Contract Family semantics. Serializes as its string value. */
    action_type?: ContractActionType | null;
    /** Contract actions only: the Pilot document-handler id for the specific version/handler of the source contract the requester was viewing (not the source contract's own document id -- see source_document_id). Recorded on a renewal's Contract Family claim when present. Omit for a normal create. */
    source_document_handler_id?: string | null;
    /** Execution mode: live (real) or sandbox (test, deletable) */
    mode?: TicketMode;
    /** Procurement amendment only: the source contract's CRUID. K2 resolves the amendment chain root from this value and stores it as contract_record_unique_id_original on the new ticket. */
    previous_contract_record_unique_id?: string | null;
};
export type TicketDraftCreateAttributes = {
    /** Name for the new ticket. Required unless state is 'DRAFT'. */
    name?: ResourceName | null;
    /** NOT ACCEPTED on a draft — this is an intake-form answer, so send it to POST /tickets/{id}/submit instead. A non-empty value here is a 400. */
    initial_field_values?: {
        [key: string]: FieldValueEntry[];
    };
    /** DEPRECATED: use template_ids. NOT ACCEPTED on a draft — this is an intake-form answer, so send it to POST /tickets/{id}/submit instead. A non-empty value here is a 400. */
    template_id?: string | null;
    /** NOT ACCEPTED on a draft — this is an intake-form answer, so send it to POST /tickets/{id}/submit instead. A non-empty value here is a 400. */
    template_ids?: string[] | null;
    /** NOT ACCEPTED on a draft — this is an intake-form answer, so send it to POST /tickets/{id}/submit instead. A non-empty value here is a 400. */
    document_source_choice?: DocumentSourceChoice | null;
    /** Contract actions only: the source contract's canonical Pilot document id, as a whole number in string form (not its document-handler id). A renewal request additionally claims this contract's Contract Family slot. Omit for a normal create. */
    source_document_id?: string | null;
    /** Contract actions only: the action that produced this ticket (e.g. "renewal", "amendment", "termination", "non-renewal"). Recorded on the create activity metadata alongside source_document_id. Only "renewal" currently has Contract Family semantics. Serializes as its string value. */
    action_type?: ContractActionType | null;
    /** Contract actions only: the Pilot document-handler id for the specific version/handler of the source contract the requester was viewing (not the source contract's own document id -- see source_document_id). Recorded on a renewal's Contract Family claim when present. Omit for a normal create. */
    source_document_handler_id?: string | null;
    /** Execution mode: live (real) or sandbox (test, deletable) */
    mode?: TicketMode;
    /** NOT ACCEPTED on a draft — omit this field at draft creation and supply it on POST /tickets/{id}/submit instead. The amendment slot is claimed at submit time to avoid holding it for an abandonable draft. A non-empty value here is a 400. */
    previous_contract_record_unique_id?: string | null;
    /** Set to 'DRAFT' to create an intake draft: a shell ticket that gives an in-progress intake form an id to hang document uploads off. A draft holds no intake answers, selects no stage, and emits no ticket_create -- POST /tickets/{id}/submit supplies the answers and does all of that. A draft also cannot start a procurement amendment. Document operations that author intake content -- attaching, renaming, reclassifying, and removing a file -- all work on a DRAFT; operations that mint a new document version or open a collaborative edit session require an ACTIVE ticket. download-request is a view operation and works on a DRAFT (and on paused/cancelled/completed tickets). Omit this field for the ordinary one-shot create, which is unchanged. */
    state: "DRAFT";
};
export type TicketCreateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketCreateAttributes | TicketDraftCreateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CreateTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketCreateRequestData;
};
export type TicketCloneAttributes = {
    /** Whether to copy field values from the source ticket */
    copy_field_values?: boolean;
    /** Whether to copy documents from the source ticket */
    copy_documents?: boolean;
};
export type TicketCloneRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketCloneAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CloneTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketCloneRequestData;
};
export type TicketStateAttributes = {
    /** Current lifecycle state of the ticket */
    state: TicketState;
    /** Stage ID of the currently active stage from the workflow definition */
    current_stage_id: string;
    /** Map of stage states keyed by stage_id from the workflow definition (not an array). Keys are stage IDs; values are discriminated on `visibility`: `visible` carries status + timestamps, `redacted` carries status only (a sub-resource ACL denial). */
    stage_states: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedStageState) | ({
            visibility: "visible";
        } & StageState);
    };
    /** Map of visible task states keyed by task_id from the workflow definition (not an array). Keys are task IDs; values are discriminated on `visibility`: `visible` carries status + assignments + judgments, `redacted` carries status only (a sub-resource ACL denial). */
    task_states: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedTaskState) | ({
            visibility: "visible";
        } & TaskState);
    };
    /** Optimistic locking version */
    version: number;
};
export type TicketStateResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketStateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type TicketStateResponse = {
    /** The primary resource object. */
    data: TicketStateResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type GetTicketResponse = {
    /** The primary resource object. */
    data: TicketResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type GetTicketResponseRead = {
    /** The primary resource object. */
    data: TicketResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type TicketUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** New ticket name. Omit to leave unchanged. */
    name?: ResourceName | null;
    /** New description. Omit to leave unchanged. Pass null to clear. */
    description?: ResourceDescription | null;
};
export type TicketUpdateRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketUpdateAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketUpdateRequestData;
};
export type TicketFormVisibilityEvaluationRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: FormVisibilityEvaluationAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TicketFormVisibilityEvaluationRequest = {
    /** The primary resource object of the request. */
    data: TicketFormVisibilityEvaluationRequestData;
};
export type TicketPauseAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type TicketPauseRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketPauseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type PauseTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketPauseRequestData;
};
export type TicketResumeAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type TicketResumeRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketResumeAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ResumeTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketResumeRequestData;
};
export type TicketCancelAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Reason for cancelling the ticket (appears in activity log). HTML tags are rejected. */
    reason: UserEnteredText;
};
export type TicketCancelRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketCancelAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CancelTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketCancelRequestData;
};
export type TicketCompleteAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type TicketCompleteRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketCompleteAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type CompleteTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketCompleteRequestData;
};
export type TicketSubmitAttributes = {
    /** Name for the new ticket. Required unless state is 'DRAFT'. */
    name?: ResourceName | null;
    /** Pre-populated field values from the intake form, keyed by Unified Fields field_id (UUID). Each key is the same id as an intake-form question's `form_field.field_id` (the `id` of a `field_library` entry in the workflow definition). Each value is a uniform array of entries (e.g. [{"value": "english"}]); an empty array means no value. */
    initial_field_values?: {
        [key: string]: FieldValueEntry[];
    };
    /** DEPRECATED: use template_ids. Template selected by the requester when the intake form uses requester_choice generation. The ID must be present in the form's document_template_ids. */
    template_id?: string | null;
    /** Templates selected by the requester when the intake form uses requester_choice (or always) generation. Each ID must be present in the form's document_template_ids. Supersedes template_id, which remains supported as a single-element selection. */
    template_ids?: string[] | null;
    /** Requester's explicit template-vs-upload choice, for intake forms whose requester_choice generation mode presents both as a real binary choice (EKP-58403). 'upload' or 'none' skips initial document generation entirely, even when the form has configured templates and template_ids is omitted. Omitting this field (older/unmigrated FE flows) preserves the prior behavior of generating every configured template when no template_ids is given. */
    document_source_choice?: DocumentSourceChoice | null;
    /** Contract actions only: the source contract's canonical Pilot document id, as a whole number in string form (not its document-handler id). A renewal request additionally claims this contract's Contract Family slot. Omit for a normal create. */
    source_document_id?: string | null;
    /** Contract actions only: the action that produced this ticket (e.g. "renewal", "amendment", "termination", "non-renewal"). Recorded on the create activity metadata alongside source_document_id. Only "renewal" currently has Contract Family semantics. Serializes as its string value. */
    action_type?: ContractActionType | null;
    /** Contract actions only: the Pilot document-handler id for the specific version/handler of the source contract the requester was viewing (not the source contract's own document id -- see source_document_id). Recorded on a renewal's Contract Family claim when present. Omit for a normal create. */
    source_document_handler_id?: string | null;
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Procurement amendment only: the source contract's CRUID. Deferred from draft creation to avoid claiming the amendment slot for an abandonable shell. */
    previous_contract_record_unique_id?: string | null;
};
export type TicketSubmitRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: TicketSubmitAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type SubmitTicketRequest = {
    /** The primary resource object of the request. */
    data: TicketSubmitRequestData;
};
export type ResetStageTasksResponseAttributes = {
    /** IDs of tasks that were reset to PENDING */
    reset_task_ids: string[];
    /** Stage that was reset */
    stage_id: string;
    /** Updated ticket version */
    version: number;
};
export type ResetStageTasksResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ResetStageTasksResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ResetStageTasksResponse = {
    /** The primary resource object. */
    data: ResetStageTasksResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ResetStageTasksAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Stage to reset. Defaults to the current stage; must be the current stage when provided. */
    stage_id?: string | null;
};
export type ResetStageTasksRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: ResetStageTasksAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ResetStageTasksRequest = {
    /** The primary resource object of the request. */
    data: ResetStageTasksRequestData;
};
export type UpdateTicketAclResponseAttributes = {
    /** Complete ACL after the update: `viewer`, `commenter`, `editor` (each a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`, implicit placeholders echoed unresolved), and `custom` (the complete set of ad-hoc permission policies after the update -- a policy the ticket owns is returned as its `atoms`; a shareable one as its `bundle_id`; empty when the ticket has none). */
    acl: AclSettings;
    /** Updated ticket version */
    version: number;
};
export type UpdateTicketAclResponseAttributesRead = {
    /** Complete ACL after the update: `viewer`, `commenter`, `editor` (each a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`, implicit placeholders echoed unresolved), and `custom` (the complete set of ad-hoc permission policies after the update -- a policy the ticket owns is returned as its `atoms`; a shareable one as its `bundle_id`; empty when the ticket has none). */
    acl: AclSettingsRead;
    /** Updated ticket version */
    version: number;
};
export type UpdateTicketAclResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateTicketAclResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateTicketAclResponseDataRead = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: UpdateTicketAclResponseAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type UpdateTicketAclResponse = {
    /** The primary resource object. */
    data: UpdateTicketAclResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateTicketAclResponseRead = {
    /** The primary resource object. */
    data: UpdateTicketAclResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type UpdateTicketAclAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** ACL changes, one field per permission: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access), and `custom` (ad-hoc policies). Each field is independently a MERGE against the ticket's current ACL: omitted (`null`) leaves that field unchanged, `[]` clears it, and a non-empty value replaces it outright -- this applies to `custom` too, unlike the node-level PATCH below where the same type means a whole-object replace. Tiered delegation on `viewer`/`commenter`/`editor`: you may only grant tiers up to your own access (view → viewer; comment → viewer/commenter; edit → any tier); granting a higher tier returns 403. A `custom` entry is authorized by the atoms it confers: you must be able to grant the lowest built-in tier that would confer all of them, so a read-only policy needs only `grant_view`. Dropping a policy the ticket already has requires `edit`. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. Implicit principals use `type: implicit` with an id token such as `submitter`, `field_users:<field_id>`, or `field_departments:<field_id>` — see `AclPrincipal`; `signing_participants:<task_id>` is rejected outside `viewer` with a 422. */
    acl?: AclSettingsUpdate;
};
export type UpdateTicketAclAttributesRead = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** ACL changes, one field per permission: `viewer` (read access), `commenter` (read + comment), `editor` (read + write access), and `custom` (ad-hoc policies). Each field is independently a MERGE against the ticket's current ACL: omitted (`null`) leaves that field unchanged, `[]` clears it, and a non-empty value replaces it outright -- this applies to `custom` too, unlike the node-level PATCH below where the same type means a whole-object replace. Tiered delegation on `viewer`/`commenter`/`editor`: you may only grant tiers up to your own access (view → viewer; comment → viewer/commenter; edit → any tier); granting a higher tier returns 403. A `custom` entry is authorized by the atoms it confers: you must be able to grant the lowest built-in tier that would confer all of them, so a read-only policy needs only `grant_view`. Dropping a policy the ticket already has requires `edit`. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. Implicit principals use `type: implicit` with an id token such as `submitter`, `field_users:<field_id>`, or `field_departments:<field_id>` — see `AclPrincipal`; `signing_participants:<task_id>` is rejected outside `viewer` with a 422. */
    acl?: AclSettingsUpdateRead;
};
export type UpdateTicketAclRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: UpdateTicketAclAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateTicketAclRequestDataRead = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "tickets";
    /** The resource's attributes. */
    attributes: UpdateTicketAclAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type UpdateTicketAclRequest = {
    /** The primary resource object of the request. */
    data: UpdateTicketAclRequestData;
};
export type UpdateTicketAclRequestRead = {
    /** The primary resource object of the request. */
    data: UpdateTicketAclRequestDataRead;
};
export type TicketOwnerReassignAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Pilot user ID of the incoming ticket owner. */
    owner_user_id: string;
};
export type TicketOwnerReassignRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "ticket-owner";
    /** The resource's attributes. */
    attributes: TicketOwnerReassignAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ReassignTicketOwnerRequest = {
    /** The primary resource object of the request. */
    data: TicketOwnerReassignRequestData;
};
export type NegotiationAction = "share" | "retract";
export type SupplierNegotiationResponseAttributes = {
    /** The action that was performed. */
    action: NegotiationAction;
    /** The ticket's negotiation status after the action. */
    negotiation_status: NegotiationStatus;
};
export type SupplierNegotiationResponseData = {
    /** JSON:API resource type. */
    type?: "supplier-negotiation";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: SupplierNegotiationResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type SupplierNegotiationResponse = {
    /** The primary resource object. */
    data: SupplierNegotiationResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type RetractFromSupplierAttributes = {
    /** Retract the document from the supplier. */
    action: "retract";
    /** Current ticket version for optimistic locking. */
    version: VersionInt;
};
export type SupplierContactAttributes = {
    /** Workday identifier of the supplier contact. */
    supplier_contact_wss_id: string;
    /** Supplier contact email address. */
    email: string;
};
export type ShareWithSupplierAttributes = {
    /** Share the document with the supplier. */
    action: "share";
    /** Id of the ticket document to share. Its latest READY version is sent. */
    document_id: string;
    /** Workday identifier of the supplier company. */
    supplier_company_wss_id: string;
    /** Supplier contacts to share with. At least one required. */
    supplier_contacts: SupplierContactAttributes[];
    /** Current ticket version for optimistic locking. The negotiation status is claimed before the supplier portal is called, so a stale version returns 409 rather than sending the document twice. */
    version: VersionInt;
};
export type SupplierNegotiationRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "supplier-negotiation";
    /** The resource's attributes. */
    attributes: ({
        action: "retract";
    } & RetractFromSupplierAttributes) | ({
        action: "share";
    } & ShareWithSupplierAttributes);
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type SupplierNegotiationRequest = {
    /** The primary resource object of the request. */
    data: SupplierNegotiationRequestData;
};
export type ShareExternallyResponseAttributes = {
    /** Number of recipients the email was sent to. */
    recipients_count: number;
    /** Number of documents attached to the email. */
    documents_shared: number;
};
export type ShareExternallyResponseData = {
    /** JSON:API resource type. */
    type?: "share-externally";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ShareExternallyResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ShareExternallyResponse = {
    /** The primary resource object. */
    data: ShareExternallyResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ShareExternallyAttributes = {
    /** Email addresses to share with. Any recipient email that resolves to an active user in this tenant is treated as internal and auto-granted VIEWER access to the ticket; the rest are delivered as external attachments. At least one required. */
    recipients: string[];
    /** IDs of ticket documents to attach. At least one required. */
    document_ids: string[];
    /** Email subject line. Defaults to 'Document shared: {ticket name}'. */
    subject?: string | null;
    /** Optional freeform note from the sender, injected into the email template. */
    message?: string | null;
    /** Current ticket version for optimistic locking on the ACL update. Required only when at least one recipient resolves to an internal user; external-only shares can omit it. A stale version returns 409. */
    version?: VersionInt | null;
    /** If true, record a turn handoff to `turn_to_party` atomically with this share. */
    record_turn_handoff?: boolean;
    /** Required when `record_turn_handoff` is true. */
    turn_to_party?: ("internal" | "counter") | null;
};
export type ShareExternallyRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "share-externally";
    /** The resource's attributes. */
    attributes: ShareExternallyAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ShareExternallyRequest = {
    /** The primary resource object of the request. */
    data: ShareExternallyRequestData;
};
export type ShareInternallyResponseAttributes = {
    /** Number of recipients the email was sent to. */
    recipients_count: number;
    /** Number of documents attached to the email. */
    documents_shared: number;
};
export type ShareInternallyResponseData = {
    /** JSON:API resource type. */
    type?: "share-internally";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ShareInternallyResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ShareInternallyResponse = {
    /** The primary resource object. */
    data: ShareInternallyResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ShareInternallyAttributes = {
    /** Email addresses of internal (existing) recipients. At least one required. */
    recipients: string[];
    /** IDs of ticket documents to attach. At least one required. */
    document_ids: string[];
    /** Email subject line. Defaults to 'Document shared: {ticket name}'. */
    subject?: string | null;
    /** Optional freeform note from the sender, injected into the email template. */
    message?: string | null;
    /** Current ticket version for optimistic locking on the ACL update. */
    version: VersionInt;
    /** If true, record a turn handoff to `turn_to_party` atomically with this share. */
    record_turn_handoff?: boolean;
    /** Required when `record_turn_handoff` is true. */
    turn_to_party?: ("internal" | "counter") | null;
};
export type ShareInternallyRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "share-internally";
    /** The resource's attributes. */
    attributes: ShareInternallyAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ShareInternallyRequest = {
    /** The primary resource object of the request. */
    data: ShareInternallyRequestData;
};
export type ContractFamilyNodeType = "Root" | "Renewal";
export type ContractFamilyNodeMetadataAttributes = {
    /** Document.document_name from Pilot, or the pending ticket's own name. */
    name: string;
    /** The document's current Pilot status, or the pending ticket's own state. */
    status: string;
};
export type ContractFamilyNodeAttributes = {
    /** The Pilot Document.id this node represents; null for a still-pending draft, or when accessible is false. */
    document_id?: string | null;
    /** The kind of row this node represents. */
    type?: ContractFamilyNodeType | null;
    /** This node's own in-progress Renewal Request ticket id, if it is a still-pending draft. */
    family_pending_ticket_id?: string | null;
    /** False when the caller cannot view this document; every other attribute is withheld in that case. */
    accessible?: boolean;
    /** Display data (from Pilot for a document, or the ticket itself for a pending draft), present only when include=metadata was requested and this member is accessible to the caller. */
    metadata?: ContractFamilyNodeMetadataAttributes | null;
    /** The Pilot DocumentHandler.id the caller was viewing when this edge was claimed, for linking directly to the source document. Null on a root row, on an edge no caller identified a handler for, or when accessible is false. */
    source_document_handler_id?: string | null;
    /** This node's own Pilot DocumentHandler.id, for linking directly to this document. Null when accessible is false, or when not yet resolved. */
    document_handler_id?: string | null;
};
export type ContractFamilyResponseData = {
    /** JSON:API resource type. */
    type?: "contract_family_node";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ContractFamilyNodeAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListContractFamilyResponse = {
    /** The primary resource objects, in response order. */
    data: ContractFamilyResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ContractFamilyIncludeParam = "metadata";
export type BulkReassignResponseAttributes = {
    /** Total number of task assignments that were updated */
    reassigned_count: number;
    /** IDs of tickets that had at least one task reassigned */
    tickets_affected: string[];
};
export type BulkReassignResponseData = {
    /** JSON:API resource type. */
    type?: "bulk-operations";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: BulkReassignResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type BulkReassignResponse = {
    /** The primary resource object. */
    data: BulkReassignResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type BulkReassignAttributes = {
    /** User ID to reassign tasks from */
    from_user_id: string;
    /** User ID to reassign tasks to */
    to_user_id: string;
    /** Optional list of workflow IDs to limit reassignment scope */
    workflow_ids?: string[];
};
export type BulkReassignRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "bulk-operations";
    /** The resource's attributes. */
    attributes: BulkReassignAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type BulkReassignRequest = {
    /** The primary resource object of the request. */
    data: BulkReassignRequestData;
};
export type SupplierAttributes = {
    /** The Workday ID (WID) of the supplier */
    wid?: string | null;
    /** The name of the supplier */
    name: string;
    /** The Workday supplier status (e.g. Active, Inactive, Hold) */
    external_status?: string | null;
    /** The WSS supplier segmentation (e.g. Approved, Tier 1, Tier 2) */
    segmentation?: string | null;
    /** The WSS supplier risk level (e.g. Low, Medium, High) */
    risk?: string | null;
};
export type SupplierResponseData = {
    /** JSON:API resource type. */
    type?: "supplier_companies";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: SupplierAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListSuppliersResponse = {
    /** The primary resource objects, in response order. */
    data: SupplierResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type SupplierContactTypeAttributes = {
    /** Contact type ID */
    id: number;
    /** Contact type name (e.g. Primary Contact, Legal Contact) */
    name: string;
};
export type SupplierContactAttributes2 = {
    /** Full name of the contact */
    name?: string | null;
    /** First name (may be null from WSS) */
    first_name?: string | null;
    /** Last name (may be null from WSS) */
    last_name?: string | null;
    /** Contact email address */
    email?: string | null;
    /** Contact type classifications */
    contact_types?: SupplierContactTypeAttributes[];
};
export type SupplierContactResponseData = {
    /** JSON:API resource type. */
    type?: "supplier_contacts";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: SupplierContactAttributes2;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type GetSupplierCompanyResponse = {
    /** The primary resource object. */
    data: SupplierResponseData;
    /** Related supplier contacts when include_contacts is true */
    included?: SupplierContactResponseData[];
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ContractTypeAttributes = {
    /** A description of the contract type */
    descriptor: string;
    /** The Workday reference ID of the contract type */
    supplier_contract_type_id: string;
    /** IDs of published workflows already linked to this contract type, taking the latest published version of each workflow. Empty when the contract type is unclaimed. */
    linked_workflow_ids?: string[];
};
export type ContractTypeResponseData = {
    /** JSON:API resource type. */
    type?: "contract_type";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ContractTypeAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListContractTypesResponse = {
    /** The primary resource objects, in response order. */
    data: ContractTypeResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type ListCurrenciesResponse = {
    /** Workday currency codes available in the tenant, sorted alphabetically. Mostly ISO 4217, but not exclusively — the catalogue also carries non-ISO codes such as BUSD and CCR01, so do not assume a 3-character format. */
    data?: string[];
};
export type IntakeFormWorkflowAttributes = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. On GET /workflows/{workflow_id} it is returned when ``include`` is omitted (load-all) or contains ``workflow_definition``, and is null when ``include`` lists only other tokens. On GET /workflows (list) it is null unless ``?include=workflow_definition`` is passed. Update, archive, unarchive and unpublish responses always return it. */
    workflow_definition?: WorkflowDefinitionResponse | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether *this version row* is published. After an older-version publish the latest row is unpublished while an older version is live, so this is not whether the workflow can create tickets: on workflow list and read responses, `published_version` is the live version. */
    published: boolean;
    /** Whether the workflow is archived (soft-deleted). Archived workflows are excluded from GET /workflows list results by default; see the `include_archived` parameter. */
    is_archived: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Available archive/unarchive/delete actions and why any are blocked. Included when ?include=actions is specified. Omitted entirely (not merely null) by every route that cannot populate it -- see each route's own handling in src/hosting/workflows/routes.py and src/hosting/integrate_workflow/routes.py. */
    actions?: WorkflowActionEntry[] | null;
    /** Prepopulated field values (e.g., supplier from WSS), keyed by Unified Fields field ID. Only present when provided. */
    initial_field_values?: {
        [key: string]: PrefillFieldValue;
    } | null;
};
export type IntakeFormWorkflowAttributesRead = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. On GET /workflows/{workflow_id} it is returned when ``include`` is omitted (load-all) or contains ``workflow_definition``, and is null when ``include`` lists only other tokens. On GET /workflows (list) it is null unless ``?include=workflow_definition`` is passed. Update, archive, unarchive and unpublish responses always return it. */
    workflow_definition?: WorkflowDefinitionResponseRead | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether *this version row* is published. After an older-version publish the latest row is unpublished while an older version is live, so this is not whether the workflow can create tickets: on workflow list and read responses, `published_version` is the live version. */
    published: boolean;
    /** Whether the workflow is archived (soft-deleted). Archived workflows are excluded from GET /workflows list results by default; see the `include_archived` parameter. */
    is_archived: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Available archive/unarchive/delete actions and why any are blocked. Included when ?include=actions is specified. Omitted entirely (not merely null) by every route that cannot populate it -- see each route's own handling in src/hosting/workflows/routes.py and src/hosting/integrate_workflow/routes.py. */
    actions?: WorkflowActionEntry[] | null;
    /** Prepopulated field values (e.g., supplier from WSS), keyed by Unified Fields field ID. Only present when provided. */
    initial_field_values?: {
        [key: string]: PrefillFieldValue;
    } | null;
};
export type IntakeFormWorkflowResponseData = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: IntakeFormWorkflowAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type IntakeFormWorkflowResponseDataRead = {
    /** JSON:API resource type. */
    type?: "workflows";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: IntakeFormWorkflowAttributesRead;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type GetIntakeFormLinkResponse = {
    /** The primary resource object. */
    data: IntakeFormWorkflowResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type GetIntakeFormLinkResponseRead = {
    /** The primary resource object. */
    data: IntakeFormWorkflowResponseDataRead;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type ProcurementAmendabilityReason = "not_completed" | "not_integrated" | "inflight_amendment" | "document_terminated" | "document_identifier_error" | "not_latest_amendment" | "pilot_error" | "no_contract_type" | "no_published_workflow";
export type ProcurementAmendabilityAttributes = {
    /** Whether the contract can be amended via Procurement amendment. */
    is_amendable: boolean;
    /** Reason when not amendable. Null when amendable. */
    reason?: ProcurementAmendabilityReason | null;
};
export type ProcurementAmendabilityResponseData = {
    /** JSON:API resource type. */
    type?: "procurement_amendability";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ProcurementAmendabilityAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ProcurementAmendabilityResponse = {
    /** The primary resource object. */
    data: ProcurementAmendabilityResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type CompanyAttributes = {
    /** A description of the company or hierarchy */
    descriptor: string;
    /** The Workday ID (WID) of the company or hierarchy */
    id: string;
    /** The Workday reference ID of the organization */
    Organization_Reference_ID: string;
};
export type CompanyResponseData = {
    /** JSON:API resource type. */
    type?: "company";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: CompanyAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ListCompaniesResponse = {
    /** The primary resource objects, in response order. */
    data: CompanyResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type TicketDocumentUploadUrlAttributes = {
    /** Current owner version. Optional and not enforced — document uploads sit outside the owner's optimistic-locking system; accepted for caller compatibility. */
    version?: number | null;
    /** Existing document ID for re-upload of a new version. Omit for a new document. */
    document_id?: string | null;
    /** Filename of the document to upload */
    name: string;
    /** MIME type of the file */
    content_type: string;
    /** File size in bytes. Capped at an INTERIM threat-model ceiling (EKP-58254) pending a real number from Product/vendor docs — see MAX_DOCUMENT_UPLOAD_SIZE_BYTES. This bound is enforced at the API layer only; end-to-end enforcement is tracked in EKP-63193. */
    content_length: number;
    /** Document's role: contract | attachment | template. Omit to use the owner's default (ATTACHMENT for tickets, TEMPLATE for workflows). */
    document_type?: DocumentType | null;
    /** Optional Unified Field values to set on the document. Each entry identifies a field by UUID and supplies one or more values. */
    fields?: UploadField[] | null;
    /** How to handle a name collision with an existing document. true — rename the incoming file by appending '(N)' before the extension (e.g. 'doc(1).docx'). false — treat this upload as a new version of the existing document with the same name. Omit when document_id is set (re-uploads are already explicitly versioned), or when the caller is certain the name is unique. */
    rename?: boolean | null;
    /** The workflow document slot this upload fills. Uploads carry no template provenance and this payload carries no form id, so the server cannot infer the slot -- the client names it, and the document is slotted from birth. Applied only on fresh uploads (document_id omitted); ignored on re-uploads, which preserve the existing document's slot. Rejected with 422 when the slot is not defined on the ticket's workflow or already holds a document. Omit for an ordinary ad-hoc attachment. */
    slot_id?: string | null;
    /** Whether this is the originator's paper (first_party) or the counterparty's paper (third_party). Omit to default to first_party. Applied only on fresh uploads (document_id omitted); ignored on re-uploads, which preserve the existing document's paper_type. */
    paper_type?: PaperType | null;
};
export type TicketDocumentUploadUrlRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type: "documents";
    /** The resource's attributes. */
    attributes: TicketDocumentUploadUrlAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type TicketDocumentUploadUrlRequest = {
    /** The primary resource object of the request. */
    data: TicketDocumentUploadUrlRequestData;
};
export type DocumentCancelUploadResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** ID of the completed document */
    document_id: string;
    /** Owner version of the parent resource after completion. Tickets increment; workflows are unchanged (in-place definition update). */
    version: number;
};
export type DocumentCancelUploadResponseData = {
    /** JSON:API resource type. */
    type?: "documents";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentCancelUploadResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentCancelUploadResponse = {
    /** The primary resource object. */
    data: DocumentCancelUploadResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentComparisonResponseAttributes = {
    /** ID of the compared document */
    document_id: string;
    /** Newer version (target) in the diff */
    newer_version: number;
    /** Older version (reference) in the diff */
    older_version: number;
    /** Presigned GET URL for the cached SFDT diff. Null when ``download_status=pending`` (comparison still being generated; poll the same endpoint). */
    download_url?: string | null;
    /** URL expiration time in seconds (0 when pending) */
    expires_in?: number;
    /** ``ready`` when ``download_url`` is set; ``pending`` when the diff is still being generated (HTTP 202; poll the same endpoint). */
    download_status?: DocumentDownloadStatus;
};
export type DocumentComparisonResponseData = {
    /** JSON:API resource type. */
    type?: "document-comparisons";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: DocumentComparisonResponseAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type DocumentComparisonResponse = {
    /** The primary resource object. */
    data: DocumentComparisonResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type TicketSearchResultAttributes = {
    /** Name of the ticket */
    ticket_name: string;
    /** Current lifecycle state */
    state: TicketState;
    /** ID of the source workflow */
    workflow_id: string;
    /** Name of the source workflow */
    workflow_name: string;
    /** Name of the current stage */
    current_stage_name: string;
    /** When the current stage was entered */
    current_stage_entered_at?: string | null;
    /** Number of attached documents */
    document_count?: number;
    /** Number of open tasks */
    open_task_count?: number;
    /** User IDs assigned to open tasks */
    assignee_ids?: string[];
    /** Display names of assigned users */
    assignee_names?: string[];
    /** User IDs ever assigned to any visible task (past, present, future) */
    participant_ids?: string[];
    /** Start time of the oldest open task */
    oldest_open_task_started_at?: string | null;
    /** User ID of the ticket owner */
    owner_user_id?: string | null;
    /** Display name of the ticket owner */
    owner_name?: string | null;
    /** User ID who created the ticket */
    created_by: string;
    /** When the ticket was created */
    created_at: string;
    /** When the ticket was last updated */
    updated_at?: string | null;
    /** Managed Entities S2S only: `{field_id: [values]}` for the field ids named in `filters.field_values`. Omitted for Bearer JWT callers. */
    field_values?: {
        [key: string]: any[];
    };
};
export type TicketSearchResultData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketSearchResultAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type TicketSearchResponse = {
    /** The primary resource objects, in response order. */
    data: TicketSearchResultData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
export type SearchDateFilter = {
    /** Exact date match */
    eq?: string | null;
    /** Greater than or equal to date */
    gte?: string | null;
    /** Less than or equal to date */
    lte?: string | null;
    /** Date range as [start, end] tuple */
    between?: string[] | null;
    /** Relative duration filter (e.g., '7d', '2w', '3m', '1y') */
    last?: string | null;
};
export type SearchNumericFilter = {
    /** Exact numeric match */
    eq?: number | null;
    /** Greater than value */
    gt?: number | null;
    /** Greater than or equal to value */
    gte?: number | null;
    /** Less than value */
    lt?: number | null;
    /** Less than or equal to value */
    lte?: number | null;
    /** Numeric range as [min, max] tuple */
    between?: number[] | null;
};
export type SearchDurationFilter = {
    /** Minimum elapsed duration (e.g., '7d', '2w', '3m', '1y') */
    gte?: string | null;
    /** Maximum elapsed duration (e.g., '7d', '2w', '3m', '1y') */
    lte?: string | null;
};
export type FieldValueFilter = {
    /** Ticket field ID (UUID); matches a key in the ticket's field_values */
    field_id: UuidStr;
    /** Accepted values for this field (OR within a field). Omit or leave empty to filter by field presence only (ticket has this field set). A ticket whose field holds a multi-value list matches when any element equals one of these values. */
    values?: (string | number | number | boolean | {
        [key: string]: any;
    })[] | null;
};
export type TicketSearchFilters = {
    /** Filter by ticket state(s). `DRAFT` tickets are unsubmitted intake forms and are omitted from these results for everyone, the requester who created them and admins included — so `state: [DRAFT]` returns an empty page. Retrieve a draft by id via `GET /tickets/{ticket_id}`. */
    state?: TicketState[] | null;
    /** Filter by workflow name (case-insensitive exact match) */
    workflow_name?: string[] | null;
    /** Filter by workflow ID (exact match) */
    workflow_id?: string[] | null;
    /** Filter by current stage name (case-insensitive exact match) */
    current_stage_name?: string[] | null;
    /** Filter by assigned user IDs (any match) */
    assignee_ids?: string[] | null;
    /** Filter by ticket owner user IDs (exact match against any provided ID) */
    owner_ids?: string[] | null;
    /** Filter by all-time participant user IDs (any match). Matches users ever assigned to any visible task on the ticket regardless of task status, including completed and not-yet-started tasks. Use assignee_ids for currently open tasks only. */
    participant_ids?: string[] | null;
    /** Filter by creator user ID */
    created_by?: string | null;
    /** Filter by creation date */
    created_at?: SearchDateFilter | null;
    /** Filter by last update date */
    updated_at?: SearchDateFilter | null;
    /** Filter by number of attached documents */
    document_count?: SearchNumericFilter | null;
    /** Filter by number of open tasks */
    open_task_count?: SearchNumericFilter | null;
    /** Filter by time spent in current stage (seconds) */
    time_in_stage?: SearchDurationFilter | null;
    /** Filter by duration of longest open task (seconds) */
    time_for_longest_task?: SearchDurationFilter | null;
    /** Filter by ticket field values. Each entry targets one field by ID; entries are ANDed. Provide 'values' for a field id/value match (OR within), or omit them to match tickets that merely have the field set. */
    field_values?: FieldValueFilter[] | null;
};
export type SearchSortParam = {
    /** Field name to sort by */
    field?: "ticket_name" | "workflow_name" | "current_stage_name" | "state" | "created_at" | "updated_at" | "document_count" | "open_task_count" | "time_in_stage" | "time_for_longest_task";
    /** Sort direction: 'asc' or 'desc' */
    direction?: "asc" | "desc";
};
export type SearchPageParam = {
    /** Page number (1-based) */
    number?: number;
    /** Number of results per page (max 100) */
    size?: number;
};
export type TicketSearchRequest = {
    /** Free-text search query across ticket name, workflow name, assignee names, and owner name. Each word matches anywhere inside a word in those fields, not only at its start, so `730` matches `Request 0730` and `ntake` matches `Intake Form`. A word of 1-2 characters matches by prefix instead when no word in the query is 3+ characters. By default (`search_mode=and`) a ticket must match every word in the query. Set `search_mode=or` so a ticket needs to match only some of the query's words, not all of them; in that mode words of 1-2 characters match by prefix. When `search_mode=or` and a multi-word query is used with `sort` left on the `created_at` field (the default), results are ordered by `ts_rank_cd` relevance (weighted toward ticket-name matches) instead of recency. Sorting by any other field is always honored as the primary order; relevance only breaks ties between results with an equal sort value in that case. */
    search?: string | null;
    /** How `search`'s words are combined: `and` (default) requires every word to match, matching only the results a caller would expect for a scoped/unique lookup. `or` matches a ticket that contains only some of the query's words, better suited to conversational multi-word queries, at the cost of matching a broader set of tickets and enabling relevance ordering — see the `search` field. In `or` mode, words of 1-2 characters match by prefix rather than anywhere in a word. */
    search_mode?: "and" | "or";
    /** Structured filters to narrow results */
    filters?: TicketSearchFilters | null;
    /** Sort specification for results. If left on the `created_at` field (either direction, or omitted entirely) while `search` is a multi-word query and `search_mode=or`, relevance leads instead — see the `search` and `search_mode` fields. Sorting by any other field always wins as the primary order, even while searching. */
    sort?: SearchSortParam | null;
    /** Pagination parameters */
    page?: SearchPageParam | null;
};
export type DocumentLockVersionEntry = {
    /** Document id on the ticket */
    document_id: string;
    /** Per-document optimistic-concurrency token */
    document_lock_version: number;
};
export type TicketVersionAttributes = {
    /** Current optimistic locking version */
    version: number;
    /** Per-document lock versions for optimistic concurrency (Scribyl S2S) */
    documents?: DocumentLockVersionEntry[];
};
export type TicketVersionResponseData = {
    /** JSON:API resource type. */
    type?: "tickets";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: TicketVersionAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type TicketVersionResponse = {
    /** The primary resource object. */
    data: TicketVersionResponseData;
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Not used by this endpoint; always null. */
    meta?: null;
    /** Links for the document. */
    links?: Links | null;
};
export type DocumentLockRequestAttributes = {
    /** Editor display name; NFC-normalised on validation. */
    reason: string;
    /** Expected ticket version for optimistic locking when acquiring or replacing a lock after expiry. Omit only while renewing an active collaborative lock on this document; the server skips the client version check and persists using the current ticket version. */
    version?: VersionInt | null;
};
export type DocumentLockRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "documents";
    /** The resource's attributes. */
    attributes: DocumentLockRequestAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ScribylDocumentLockRequest = {
    /** The primary resource object of the request. */
    data: DocumentLockRequestData;
};
export type DocumentUnlockRequestAttributes = {
    /** Expected ticket version for optimistic locking. Optional when a per-document lock token is supplied; at least one of the two is required to unlock. */
    version?: VersionInt | null;
};
export type DocumentUnlockRequestData = {
    /** JSON:API resource type; must match the resource type of the endpoint. */
    type?: "documents";
    /** The resource's attributes. */
    attributes: DocumentUnlockRequestAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
};
export type ScribylDocumentUnlockRequest = {
    /** The primary resource object of the request. */
    data: DocumentUnlockRequestData;
};
export type WssWorkflowStage = {
    /** Stage display name */
    name: string;
    /** Always true: K2 stages have no enable/disable toggle */
    is_enabled: boolean;
};
export type WssContractType = {
    /** Workday contract type ID; null for non-procurement workflows */
    resource_id?: string | null;
    /** Workday contract type display name; null for non-procurement workflows */
    default_value?: string | null;
};
export type WssWorkflowAttributes = {
    /** Workflow ID; all versions of a workflow share it */
    parent_id: string;
    /** Workflow name */
    name: string;
    /** When the workflow was last updated (or created, if never updated); ISO-8601 without offset */
    modified_date: string;
    /** Always empty: K2 has no workflow-level paper source; kept for response-shape parity */
    paper_type?: string[];
    /** The workflow's stages in order */
    stages?: WssWorkflowStage[];
    contract_type: WssContractType;
};
export type WssWorkflowResponseData = {
    /** Resource type; always `workflow` */
    type?: string;
    /** Workflow ID */
    id: string;
    attributes: WssWorkflowAttributes;
};
export type WorkflowListResponse = {
    /** Integrated workflows */
    data?: WssWorkflowResponseData[];
};
export type ContractNegotiationUpdateResponseData = {
    /** Resource type; always `contract_negotiations` */
    type?: string;
    /** The contract record unique ID from the request path */
    id: string;
};
export type ContractNegotiationUpdateResponse = {
    /** The updated contract negotiation */
    data: ContractNegotiationUpdateResponseData;
};
export type SupplierAcceptedAttributes = {
    /** Discriminator: the supplier accepted the document */
    response_status: "accepted";
    /** WSS contact who responded */
    supplier_contact_id: string;
};
export type SupplierErrorAttributes = {
    /** Discriminator: the negotiation failed */
    response_status: "error";
    /** WSS error code */
    error_code: string;
    /** Human-readable failure reason */
    description: string;
};
export type SupplierContractDocument = {
    /** Presigned https location of the supplier's document */
    url: string;
    /** File name of the supplier's document */
    file_name: string;
    /** File extension, e.g. ``docx`` */
    file_type: string;
};
export type SupplierUpdatedVersionAttributes = {
    /** Discriminator: the supplier returned a new document version */
    response_status: "updated_version";
    /** WSS contact who responded */
    supplier_contact_id: string;
    contract_document: SupplierContractDocument;
};
export type ContractNegotiationUpdateRequestData = {
    /** Resource type; always `contract_negotiations` */
    type?: "contract_negotiations";
    /** The supplier's response, discriminated by `response_status`: `accepted`, `error` or `updated_version` */
    attributes: ({
        response_status: "accepted";
    } & SupplierAcceptedAttributes) | ({
        response_status: "error";
    } & SupplierErrorAttributes) | ({
        response_status: "updated_version";
    } & SupplierUpdatedVersionAttributes);
};
export type ContractNegotiationUpdateRequest = {
    /** The supplier response resource */
    data: ContractNegotiationUpdateRequestData;
};
export type ContractFamilyChainAttributes = {
    /** Pilot document IDs of the family's realized documents, in chain order: index 0 is the root, the last element is the tail, and a document's successor is the next element. The order is guaranteed. A pending renewal is not listed here; see pending_ticket_id. */
    document_ids: number[];
    /** The tail's pending renewal ticket ID, or null when there is none. A claim whose ticket is completed but whose document is not yet in the chain still counts; only a cancelled ticket releases it. While set, no document in this family may be deleted. */
    pending_ticket_id: string | null;
};
export type ContractFamilyChainResponseData = {
    /** JSON:API resource type. */
    type?: "contract_family_chain";
    /** Unique identifier of the resource. */
    id: string;
    /** The resource's attributes. */
    attributes: ContractFamilyChainAttributes;
    /** Related resources, keyed by relationship name. */
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    /** Links for this resource. */
    links?: Links | null;
    /** Not used; always null. */
    meta?: null;
};
export type ContractFamilyChainCheckResponse = {
    /** The primary resource objects, in response order. */
    data: ContractFamilyChainResponseData[];
    /** Not used by this endpoint; always null. */
    included?: null;
    /** Pagination metadata; null when the collection is not paginated. */
    meta?: PaginationMeta | null;
    /** Pagination links; follow `next` until it is null to read every page. */
    links?: Links | null;
};
